// @ts-nocheck
import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AccessStatusesResponse = {
  __typename?: 'AccessStatusesResponse';
  /** Having an account in the app */
  accountAvailabilityApp: Scalars['Boolean']['output'];
  /** Availability of MyHub */
  availabilityMyHub: Scalars['Boolean']['output'];
  /** The presence of MyHub in the ownership of the use */
  availabilityMyHubOwnedByUser: Scalars['Boolean']['output'];
};

export type Account = {
  __typename?: 'Account';
  _count: AccountCount;
  beneficiaryAnonymousPropForEMail?: Maybe<Array<BeneficiaryAnonymousPropForEmail>>;
  confirmedPhone?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nextOwnerPropForEmail?: Maybe<Array<NextOwnerPropForEmail>>;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Profile>;
  profileId?: Maybe<Scalars['Int']['output']>;
  schemaVersion: Scalars['Int']['output'];
  sessions?: Maybe<Array<AccountSession>>;
  twoFactorQuestions: Array<TwoFactorQuestion>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountCount = {
  __typename?: 'AccountCount';
  beneficiaryAnonymousPropForEMail: Scalars['Int']['output'];
  nextOwnerPropForEmail: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
};

export type AccountCreateManyProfileInput = {
  confirmedPhone?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  passwordHash: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountCreateManyProfileInputEnvelope = {
  data: Array<AccountCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<AccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<AccountCreateManyProfileInputEnvelope>;
};

export type AccountCreateOrConnectWithoutProfileInput = {
  create: AccountCreateWithoutProfileInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateWithoutProfileInput = {
  beneficiaryAnonymousPropForEMail?: InputMaybe<BeneficiaryAnonymousPropForEmailCreateNestedManyWithoutAccountInput>;
  confirmedPhone?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  nextOwnerPropForEmail?: InputMaybe<NextOwnerPropForEmailCreateNestedManyWithoutAccountInput>;
  passwordHash: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  sessions?: InputMaybe<AccountSessionCreateNestedManyWithoutAccountInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountListRelationFilter = {
  every?: InputMaybe<AccountWhereInput>;
  none?: InputMaybe<AccountWhereInput>;
  some?: InputMaybe<AccountWhereInput>;
};

export type AccountRelationFilter = {
  is?: InputMaybe<AccountWhereInput>;
  isNot?: InputMaybe<AccountWhereInput>;
};

export type AccountScalarWhereInput = {
  AND?: InputMaybe<Array<AccountScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccountScalarWhereInput>>;
  OR?: InputMaybe<Array<AccountScalarWhereInput>>;
  confirmedPhone?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  passwordHash?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  profileId?: InputMaybe<IntNullableFilter>;
  schemaVersion?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AccountSession = {
  __typename?: 'AccountSession';
  account: Account;
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  fcmToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ipAddr: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AccountSessionCreateManyAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ipAddr: Scalars['String']['input'];
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type AccountSessionCreateManyAccountInputEnvelope = {
  data: Array<AccountSessionCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountSessionCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AccountSessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountSessionCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountSessionCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountSessionCreateManyAccountInputEnvelope>;
};

export type AccountSessionCreateOrConnectWithoutAccountInput = {
  create: AccountSessionCreateWithoutAccountInput;
  where: AccountSessionWhereUniqueInput;
};

export type AccountSessionCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  ipAddr: Scalars['String']['input'];
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type AccountSessionListRelationFilter = {
  every?: InputMaybe<AccountSessionWhereInput>;
  none?: InputMaybe<AccountSessionWhereInput>;
  some?: InputMaybe<AccountSessionWhereInput>;
};

export type AccountSessionScalarWhereInput = {
  AND?: InputMaybe<Array<AccountSessionScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccountSessionScalarWhereInput>>;
  OR?: InputMaybe<Array<AccountSessionScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  fcmToken?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  ipAddr?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAgent?: InputMaybe<StringNullableFilter>;
};

export type AccountSessionUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  ipAddr?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type AccountSessionUpdateManyWithWhereWithoutAccountInput = {
  data: AccountSessionUpdateManyMutationInput;
  where: AccountSessionScalarWhereInput;
};

export type AccountSessionUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AccountSessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountSessionCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountSessionCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountSessionCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AccountSessionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountSessionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountSessionWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountSessionWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountSessionUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AccountSessionUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AccountSessionUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AccountSessionUpdateWithWhereUniqueWithoutAccountInput = {
  data: AccountSessionUpdateWithoutAccountInput;
  where: AccountSessionWhereUniqueInput;
};

export type AccountSessionUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  ipAddr?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type AccountSessionUpsertWithWhereUniqueWithoutAccountInput = {
  create: AccountSessionCreateWithoutAccountInput;
  update: AccountSessionUpdateWithoutAccountInput;
  where: AccountSessionWhereUniqueInput;
};

export type AccountSessionWhereInput = {
  AND?: InputMaybe<Array<AccountSessionWhereInput>>;
  NOT?: InputMaybe<Array<AccountSessionWhereInput>>;
  OR?: InputMaybe<Array<AccountSessionWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  fcmToken?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  ipAddr?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAgent?: InputMaybe<StringNullableFilter>;
};

export type AccountSessionWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountSessionWhereInput>>;
  NOT?: InputMaybe<Array<AccountSessionWhereInput>>;
  OR?: InputMaybe<Array<AccountSessionWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  fcmToken?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ipAddr?: InputMaybe<StringFilter>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAgent?: InputMaybe<StringNullableFilter>;
};

export const AccountStatus = {
  Active: 'ACTIVE',
  Created: 'CREATED',
  Deleted: 'DELETED',
  Inactive: 'INACTIVE'
} as const;

export type AccountStatus = typeof AccountStatus[keyof typeof AccountStatus];
export type AccountUpdateManyMutationInput = {
  confirmedPhone?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountUpdateManyWithWhereWithoutProfileInput = {
  data: AccountUpdateManyMutationInput;
  where: AccountScalarWhereInput;
};

export type AccountUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<AccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<AccountCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<AccountWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<AccountUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<AccountUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type AccountUpdateWithWhereUniqueWithoutProfileInput = {
  data: AccountUpdateWithoutProfileInput;
  where: AccountWhereUniqueInput;
};

export type AccountUpdateWithoutProfileInput = {
  beneficiaryAnonymousPropForEMail?: InputMaybe<BeneficiaryAnonymousPropForEmailUpdateManyWithoutAccountNestedInput>;
  confirmedPhone?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  nextOwnerPropForEmail?: InputMaybe<NextOwnerPropForEmailUpdateManyWithoutAccountNestedInput>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  sessions?: InputMaybe<AccountSessionUpdateManyWithoutAccountNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountUpsertWithWhereUniqueWithoutProfileInput = {
  create: AccountCreateWithoutProfileInput;
  update: AccountUpdateWithoutProfileInput;
  where: AccountWhereUniqueInput;
};

export type AccountWhereInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  beneficiaryAnonymousPropForEMail?: InputMaybe<BeneficiaryAnonymousPropForEmailListRelationFilter>;
  confirmedPhone?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  nextOwnerPropForEmail?: InputMaybe<NextOwnerPropForEmailListRelationFilter>;
  passwordHash?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableRelationFilter>;
  profileId?: InputMaybe<IntNullableFilter>;
  schemaVersion?: InputMaybe<IntFilter>;
  sessions?: InputMaybe<AccountSessionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AccountWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  beneficiaryAnonymousPropForEMail?: InputMaybe<BeneficiaryAnonymousPropForEmailListRelationFilter>;
  confirmedPhone?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nextOwnerPropForEmail?: InputMaybe<NextOwnerPropForEmailListRelationFilter>;
  passwordHash?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableRelationFilter>;
  profileId?: InputMaybe<IntNullableFilter>;
  schemaVersion?: InputMaybe<IntFilter>;
  sessions?: InputMaybe<AccountSessionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ActivateAccountInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type AddItemGqlInput = {
  /** Example collection name */
  collectionName: Scalars['String']['input'];
  /** Unique DTO ID (key) for the item */
  dtoId: Scalars['String']['input'];
  /** Any JSON object representing the new item */
  item: Scalars['JSON']['input'];
  /** Platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type AddItemGqlPayload = {
  __typename?: 'AddItemGqlPayload';
  /** Example collection name */
  collectionName: Scalars['String']['output'];
  /** Latest version of the collection */
  collectionVersion: Scalars['Float']['output'];
  /** DTO ID of the newly added item */
  dtoId: Scalars['String']['output'];
  /** The added item (contains signature) */
  item: Scalars['JSON']['output'];
  /** Generated signature (JWT) */
  signature: Scalars['String']['output'];
};

export type AddItemsGqlInput = {
  /** Example collection name */
  collectionName: Scalars['String']['input'];
  /** List of items to add, each containing dtoId and item data */
  items: Array<Scalars['JSON']['input']>;
  /** Platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type AddItemsGqlPayload = {
  __typename?: 'AddItemsGqlPayload';
  /** List of successfully added items with their signatures */
  addedItems: Array<Scalars['JSON']['output']>;
  /** Example collection name */
  collectionName: Scalars['String']['output'];
  /** Latest collection version */
  collectionVersion: Scalars['Float']['output'];
};

export type AssistantInput = {
  name: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
};

export type AttachFileGqlInput = {
  /** Attachments */
  attachments: Array<AttachmentsInboxGGl>;
};

export const AttachmentType = {
  AssetList: 'ASSET_LIST',
  Comment: 'COMMENT',
  Document: 'DOCUMENT',
  Video: 'VIDEO'
} as const;

export type AttachmentType = typeof AttachmentType[keyof typeof AttachmentType];
export type AttachmentsInboxGGl = {
  comment: Scalars['String']['input'];
  encryptedSymmetricKey: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AuthLoginResponse = {
  __typename?: 'AuthLoginResponse';
  /** This field contains a account */
  account: Account;
  /** This field contains a account */
  profile: Profile;
  /** This field contains a token */
  token: Scalars['String']['output'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  /** This field contains a account */
  account: Account;
  /** This field contains a token */
  token: Scalars['String']['output'];
};

export type BeneficiaryActivationInput = {
  jwt: Scalars['String']['input'];
  password: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  twoFactorQuestions: Array<TwoFactorQuestionPlainObject>;
};

export type BeneficiaryAnonymousPropForEmail = {
  __typename?: 'BeneficiaryAnonymousPropForEmail';
  account: Account;
  accountId: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
};

export type BeneficiaryAnonymousPropForEmailCreateManyAccountInput = {
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
};

export type BeneficiaryAnonymousPropForEmailCreateManyAccountInputEnvelope = {
  data: Array<BeneficiaryAnonymousPropForEmailCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeneficiaryAnonymousPropForEmailCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BeneficiaryAnonymousPropForEmailCreateManyAccountInputEnvelope>;
};

export type BeneficiaryAnonymousPropForEmailCreateOrConnectWithoutAccountInput = {
  create: BeneficiaryAnonymousPropForEmailCreateWithoutAccountInput;
  where: BeneficiaryAnonymousPropForEmailWhereUniqueInput;
};

export type BeneficiaryAnonymousPropForEmailCreateWithoutAccountInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type BeneficiaryAnonymousPropForEmailListRelationFilter = {
  every?: InputMaybe<BeneficiaryAnonymousPropForEmailWhereInput>;
  none?: InputMaybe<BeneficiaryAnonymousPropForEmailWhereInput>;
  some?: InputMaybe<BeneficiaryAnonymousPropForEmailWhereInput>;
};

export type BeneficiaryAnonymousPropForEmailScalarWhereInput = {
  AND?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailScalarWhereInput>>;
  OR?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  lastName?: InputMaybe<StringFilter>;
};

export type BeneficiaryAnonymousPropForEmailUpdateManyMutationInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type BeneficiaryAnonymousPropForEmailUpdateManyWithWhereWithoutAccountInput = {
  data: BeneficiaryAnonymousPropForEmailUpdateManyMutationInput;
  where: BeneficiaryAnonymousPropForEmailScalarWhereInput;
};

export type BeneficiaryAnonymousPropForEmailUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BeneficiaryAnonymousPropForEmailCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereUniqueInput>>;
  set?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereUniqueInput>>;
  update?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type BeneficiaryAnonymousPropForEmailUpdateWithWhereUniqueWithoutAccountInput = {
  data: BeneficiaryAnonymousPropForEmailUpdateWithoutAccountInput;
  where: BeneficiaryAnonymousPropForEmailWhereUniqueInput;
};

export type BeneficiaryAnonymousPropForEmailUpdateWithoutAccountInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type BeneficiaryAnonymousPropForEmailUpsertWithWhereUniqueWithoutAccountInput = {
  create: BeneficiaryAnonymousPropForEmailCreateWithoutAccountInput;
  update: BeneficiaryAnonymousPropForEmailUpdateWithoutAccountInput;
  where: BeneficiaryAnonymousPropForEmailWhereUniqueInput;
};

export type BeneficiaryAnonymousPropForEmailWhereInput = {
  AND?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereInput>>;
  NOT?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereInput>>;
  OR?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  lastName?: InputMaybe<StringFilter>;
};

export type BeneficiaryAnonymousPropForEmailWhereUniqueInput = {
  AND?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereInput>>;
  NOT?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereInput>>;
  OR?: InputMaybe<Array<BeneficiaryAnonymousPropForEmailWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<StringFilter>;
};

export type BeneficiaryCreateByInviteCodeInput = {
  email: Scalars['String']['input'];
  invitationCode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  twoFactorQuestions: Array<TwoFactorQuestionPlainObject>;
};

export type BeneficiaryInput = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  dontSendInviteEmail?: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeneficiaryInviteCode = {
  __typename?: 'BeneficiaryInviteCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isUsed: Scalars['Boolean']['output'];
  mainUserProfile: Profile;
  mainUserProfileId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usedForProfile?: Maybe<Profile>;
  usedForProfileId?: Maybe<Scalars['Int']['output']>;
};

export type BeneficiaryInviteCodeCreateManyMainUserProfileInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usedForProfileId?: InputMaybe<Scalars['Int']['input']>;
};

export type BeneficiaryInviteCodeCreateManyMainUserProfileInputEnvelope = {
  data: Array<BeneficiaryInviteCodeCreateManyMainUserProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeneficiaryInviteCodeCreateManyUsedForProfileInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUserProfileId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BeneficiaryInviteCodeCreateManyUsedForProfileInputEnvelope = {
  data: Array<BeneficiaryInviteCodeCreateManyUsedForProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput = {
  connect?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeneficiaryInviteCodeCreateOrConnectWithoutMainUserProfileInput>>;
  create?: InputMaybe<Array<BeneficiaryInviteCodeCreateWithoutMainUserProfileInput>>;
  createMany?: InputMaybe<BeneficiaryInviteCodeCreateManyMainUserProfileInputEnvelope>;
};

export type BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput = {
  connect?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeneficiaryInviteCodeCreateOrConnectWithoutUsedForProfileInput>>;
  create?: InputMaybe<Array<BeneficiaryInviteCodeCreateWithoutUsedForProfileInput>>;
  createMany?: InputMaybe<BeneficiaryInviteCodeCreateManyUsedForProfileInputEnvelope>;
};

export type BeneficiaryInviteCodeCreateOrConnectWithoutMainUserProfileInput = {
  create: BeneficiaryInviteCodeCreateWithoutMainUserProfileInput;
  where: BeneficiaryInviteCodeWhereUniqueInput;
};

export type BeneficiaryInviteCodeCreateOrConnectWithoutUsedForProfileInput = {
  create: BeneficiaryInviteCodeCreateWithoutUsedForProfileInput;
  where: BeneficiaryInviteCodeWhereUniqueInput;
};

export type BeneficiaryInviteCodeCreateWithoutMainUserProfileInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usedForProfile?: InputMaybe<ProfileCreateNestedOneWithoutBeneficiaryInviteCodeAsUsedForProfileInput>;
};

export type BeneficiaryInviteCodeCreateWithoutUsedForProfileInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUserProfile: ProfileCreateNestedOneWithoutBeneficiaryInviteCodeAsMainUserInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BeneficiaryInviteCodeListRelationFilter = {
  every?: InputMaybe<BeneficiaryInviteCodeWhereInput>;
  none?: InputMaybe<BeneficiaryInviteCodeWhereInput>;
  some?: InputMaybe<BeneficiaryInviteCodeWhereInput>;
};

export type BeneficiaryInviteCodeScalarWhereInput = {
  AND?: InputMaybe<Array<BeneficiaryInviteCodeScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeneficiaryInviteCodeScalarWhereInput>>;
  OR?: InputMaybe<Array<BeneficiaryInviteCodeScalarWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isUsed?: InputMaybe<BoolFilter>;
  mainUserProfileId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usedForProfileId?: InputMaybe<IntNullableFilter>;
};

export type BeneficiaryInviteCodeUniqueBeneficiaryInviteCodeCompoundUniqueInput = {
  mainUserProfileId: Scalars['Int']['input'];
  usedForProfileId: Scalars['Int']['input'];
};

export type BeneficiaryInviteCodeUpdateManyMutationInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BeneficiaryInviteCodeUpdateManyWithWhereWithoutMainUserProfileInput = {
  data: BeneficiaryInviteCodeUpdateManyMutationInput;
  where: BeneficiaryInviteCodeScalarWhereInput;
};

export type BeneficiaryInviteCodeUpdateManyWithWhereWithoutUsedForProfileInput = {
  data: BeneficiaryInviteCodeUpdateManyMutationInput;
  where: BeneficiaryInviteCodeScalarWhereInput;
};

export type BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput = {
  connect?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeneficiaryInviteCodeCreateOrConnectWithoutMainUserProfileInput>>;
  create?: InputMaybe<Array<BeneficiaryInviteCodeCreateWithoutMainUserProfileInput>>;
  createMany?: InputMaybe<BeneficiaryInviteCodeCreateManyMainUserProfileInputEnvelope>;
  delete?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeneficiaryInviteCodeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  set?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  update?: InputMaybe<Array<BeneficiaryInviteCodeUpdateWithWhereUniqueWithoutMainUserProfileInput>>;
  updateMany?: InputMaybe<Array<BeneficiaryInviteCodeUpdateManyWithWhereWithoutMainUserProfileInput>>;
  upsert?: InputMaybe<Array<BeneficiaryInviteCodeUpsertWithWhereUniqueWithoutMainUserProfileInput>>;
};

export type BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput = {
  connect?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeneficiaryInviteCodeCreateOrConnectWithoutUsedForProfileInput>>;
  create?: InputMaybe<Array<BeneficiaryInviteCodeCreateWithoutUsedForProfileInput>>;
  createMany?: InputMaybe<BeneficiaryInviteCodeCreateManyUsedForProfileInputEnvelope>;
  delete?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeneficiaryInviteCodeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  set?: InputMaybe<Array<BeneficiaryInviteCodeWhereUniqueInput>>;
  update?: InputMaybe<Array<BeneficiaryInviteCodeUpdateWithWhereUniqueWithoutUsedForProfileInput>>;
  updateMany?: InputMaybe<Array<BeneficiaryInviteCodeUpdateManyWithWhereWithoutUsedForProfileInput>>;
  upsert?: InputMaybe<Array<BeneficiaryInviteCodeUpsertWithWhereUniqueWithoutUsedForProfileInput>>;
};

export type BeneficiaryInviteCodeUpdateWithWhereUniqueWithoutMainUserProfileInput = {
  data: BeneficiaryInviteCodeUpdateWithoutMainUserProfileInput;
  where: BeneficiaryInviteCodeWhereUniqueInput;
};

export type BeneficiaryInviteCodeUpdateWithWhereUniqueWithoutUsedForProfileInput = {
  data: BeneficiaryInviteCodeUpdateWithoutUsedForProfileInput;
  where: BeneficiaryInviteCodeWhereUniqueInput;
};

export type BeneficiaryInviteCodeUpdateWithoutMainUserProfileInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usedForProfile?: InputMaybe<ProfileUpdateOneWithoutBeneficiaryInviteCodeAsUsedForProfileNestedInput>;
};

export type BeneficiaryInviteCodeUpdateWithoutUsedForProfileInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUserProfile?: InputMaybe<ProfileUpdateOneRequiredWithoutBeneficiaryInviteCodeAsMainUserNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BeneficiaryInviteCodeUpsertWithWhereUniqueWithoutMainUserProfileInput = {
  create: BeneficiaryInviteCodeCreateWithoutMainUserProfileInput;
  update: BeneficiaryInviteCodeUpdateWithoutMainUserProfileInput;
  where: BeneficiaryInviteCodeWhereUniqueInput;
};

export type BeneficiaryInviteCodeUpsertWithWhereUniqueWithoutUsedForProfileInput = {
  create: BeneficiaryInviteCodeCreateWithoutUsedForProfileInput;
  update: BeneficiaryInviteCodeUpdateWithoutUsedForProfileInput;
  where: BeneficiaryInviteCodeWhereUniqueInput;
};

export type BeneficiaryInviteCodeWhereInput = {
  AND?: InputMaybe<Array<BeneficiaryInviteCodeWhereInput>>;
  NOT?: InputMaybe<Array<BeneficiaryInviteCodeWhereInput>>;
  OR?: InputMaybe<Array<BeneficiaryInviteCodeWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isUsed?: InputMaybe<BoolFilter>;
  mainUserProfile?: InputMaybe<ProfileRelationFilter>;
  mainUserProfileId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usedForProfile?: InputMaybe<ProfileNullableRelationFilter>;
  usedForProfileId?: InputMaybe<IntNullableFilter>;
};

export type BeneficiaryInviteCodeWhereUniqueInput = {
  AND?: InputMaybe<Array<BeneficiaryInviteCodeWhereInput>>;
  NOT?: InputMaybe<Array<BeneficiaryInviteCodeWhereInput>>;
  OR?: InputMaybe<Array<BeneficiaryInviteCodeWhereInput>>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<BoolFilter>;
  mainUserProfile?: InputMaybe<ProfileRelationFilter>;
  mainUserProfileId?: InputMaybe<IntFilter>;
  uniqueBeneficiaryInviteCode?: InputMaybe<BeneficiaryInviteCodeUniqueBeneficiaryInviteCodeCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usedForProfile?: InputMaybe<ProfileNullableRelationFilter>;
  usedForProfileId?: InputMaybe<IntNullableFilter>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type ChangeCurrencyInput = {
  baseCurrency: Scalars['String']['input'];
};

export type ChangeItemGqlInput = {
  /** Example collection name */
  collectionName: Scalars['String']['input'];
  /** DTO ID of the item to change */
  dtoId: Scalars['String']['input'];
  /** JSON object with updated fields (signature will be replaced by backend) */
  item: Scalars['JSON']['input'];
  /** Platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Current signature of the item */
  signature: Scalars['String']['input'];
};

export type ChangeItemGqlPayload = {
  __typename?: 'ChangeItemGqlPayload';
  /** Example collection name */
  collectionName: Scalars['String']['output'];
  /** Latest version of the collection */
  collectionVersion: Scalars['Float']['output'];
  /** DTO ID of the changed item */
  dtoId: Scalars['String']['output'];
  /** Changed item (contains new signature) */
  item: Scalars['JSON']['output'];
  /** Newly generated signature (JWT) */
  signature: Scalars['String']['output'];
};

export type Collection = {
  __typename?: 'Collection';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  ver: Scalars['Int']['output'];
};

export type CollectionCreateManyProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ver: Scalars['Int']['input'];
};

export type CollectionCreateManyProfileInputEnvelope = {
  data: Array<CollectionCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<CollectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollectionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<CollectionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<CollectionCreateManyProfileInputEnvelope>;
};

export type CollectionCreateOrConnectWithoutProfileInput = {
  create: CollectionCreateWithoutProfileInput;
  where: CollectionWhereUniqueInput;
};

export type CollectionCreateWithoutProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ver: Scalars['Int']['input'];
};

export type CollectionListRelationFilter = {
  every?: InputMaybe<CollectionWhereInput>;
  none?: InputMaybe<CollectionWhereInput>;
  some?: InputMaybe<CollectionWhereInput>;
};

export type CollectionScalarWhereInput = {
  AND?: InputMaybe<Array<CollectionScalarWhereInput>>;
  NOT?: InputMaybe<Array<CollectionScalarWhereInput>>;
  OR?: InputMaybe<Array<CollectionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  profileId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  ver?: InputMaybe<IntFilter>;
};

export type CollectionUniqueVersionOfCollectionCompoundUniqueInput = {
  name: Scalars['String']['input'];
  profileId: Scalars['Int']['input'];
  ver: Scalars['Int']['input'];
};

export type CollectionUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ver?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionUpdateManyWithWhereWithoutProfileInput = {
  data: CollectionUpdateManyMutationInput;
  where: CollectionScalarWhereInput;
};

export type CollectionUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<CollectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollectionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<CollectionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<CollectionCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<CollectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CollectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CollectionWhereUniqueInput>>;
  set?: InputMaybe<Array<CollectionWhereUniqueInput>>;
  update?: InputMaybe<Array<CollectionUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<CollectionUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<CollectionUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type CollectionUpdateWithWhereUniqueWithoutProfileInput = {
  data: CollectionUpdateWithoutProfileInput;
  where: CollectionWhereUniqueInput;
};

export type CollectionUpdateWithoutProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ver?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionUpsertWithWhereUniqueWithoutProfileInput = {
  create: CollectionCreateWithoutProfileInput;
  update: CollectionUpdateWithoutProfileInput;
  where: CollectionWhereUniqueInput;
};

export type CollectionWhereInput = {
  AND?: InputMaybe<Array<CollectionWhereInput>>;
  NOT?: InputMaybe<Array<CollectionWhereInput>>;
  OR?: InputMaybe<Array<CollectionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  ver?: InputMaybe<IntFilter>;
};

export type CollectionWhereUniqueInput = {
  AND?: InputMaybe<Array<CollectionWhereInput>>;
  NOT?: InputMaybe<Array<CollectionWhereInput>>;
  OR?: InputMaybe<Array<CollectionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  uniqueVersionOfCollection?: InputMaybe<CollectionUniqueVersionOfCollectionCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  ver?: InputMaybe<IntFilter>;
};

export type CreateBeneficiaryResponse = {
  __typename?: 'CreateBeneficiaryResponse';
  account: Account;
  /** код приглашения */
  invitationCode: Scalars['String']['output'];
};

export type CreateEmailAccount = {
  __typename?: 'CreateEmailAccount';
  email: Scalars['String']['output'];
};

export type CreateRegionNameInput = {
  regionCode: Scalars['String']['input'];
  regionName: Scalars['String']['input'];
};

export type Currency = {
  __typename?: 'Currency';
  Profile?: Maybe<Array<Profile>>;
  _count: CurrencyCount;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type CurrencyCount = {
  __typename?: 'CurrencyCount';
  Profile: Scalars['Int']['output'];
};

export type CurrencyCreateNestedOneWithoutProfileInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutProfileInput>;
  create?: InputMaybe<CurrencyCreateWithoutProfileInput>;
};

export type CurrencyCreateOrConnectWithoutProfileInput = {
  create: CurrencyCreateWithoutProfileInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateWithoutProfileInput = {
  title: Scalars['String']['input'];
};

export type CurrencyInput = {
  baseCurrency: Scalars['String']['input'];
  quoteCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  baseCurrency: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  uniquePrefix: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type CurrencyRateResponse = {
  __typename?: 'CurrencyRateResponse';
  baseCurrency: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  quoteCurrency: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CurrencyRelationFilter = {
  is?: InputMaybe<CurrencyWhereInput>;
  isNot?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateOneRequiredWithoutProfileNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutProfileInput>;
  create?: InputMaybe<CurrencyCreateWithoutProfileInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutProfileInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutProfileInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutProfileInput = {
  data: CurrencyUpdateWithoutProfileInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateWithoutProfileInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyUpsertWithoutProfileInput = {
  create: CurrencyCreateWithoutProfileInput;
  update: CurrencyUpdateWithoutProfileInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyWhereInput = {
  AND?: InputMaybe<Array<CurrencyWhereInput>>;
  NOT?: InputMaybe<Array<CurrencyWhereInput>>;
  OR?: InputMaybe<Array<CurrencyWhereInput>>;
  Profile?: InputMaybe<ProfileListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type CurrencyWhereUniqueInput = {
  AND?: InputMaybe<Array<CurrencyWhereInput>>;
  NOT?: InputMaybe<Array<CurrencyWhereInput>>;
  OR?: InputMaybe<Array<CurrencyWhereInput>>;
  Profile?: InputMaybe<ProfileListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DeleteEmailAccount = {
  __typename?: 'DeleteEmailAccount';
  email: Scalars['String']['output'];
};

export const DeliveryMethod = {
  Email: 'Email',
  MobilePush: 'MobilePush',
  Sms: 'SMS',
  WebPush: 'WebPush'
} as const;

export type DeliveryMethod = typeof DeliveryMethod[keyof typeof DeliveryMethod];
export type EmailParametersInput = {
  html?: InputMaybe<Scalars['String']['input']>;
  subject?: Scalars['String']['input'];
  text: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type EmailPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type EncryptedFile = {
  __typename?: 'EncryptedFile';
  createdAt: Scalars['DateTime']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mainUser: Profile;
  mainUserId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EncryptedFileCreateManyMainUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EncryptedFileCreateManyMainUserInputEnvelope = {
  data: Array<EncryptedFileCreateManyMainUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncryptedFileCreateNestedManyWithoutMainUserInput = {
  connect?: InputMaybe<Array<EncryptedFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EncryptedFileCreateOrConnectWithoutMainUserInput>>;
  create?: InputMaybe<Array<EncryptedFileCreateWithoutMainUserInput>>;
  createMany?: InputMaybe<EncryptedFileCreateManyMainUserInputEnvelope>;
};

export type EncryptedFileCreateOrConnectWithoutMainUserInput = {
  create: EncryptedFileCreateWithoutMainUserInput;
  where: EncryptedFileWhereUniqueInput;
};

export type EncryptedFileCreateWithoutMainUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EncryptedFileListRelationFilter = {
  every?: InputMaybe<EncryptedFileWhereInput>;
  none?: InputMaybe<EncryptedFileWhereInput>;
  some?: InputMaybe<EncryptedFileWhereInput>;
};

export type EncryptedFileScalarWhereInput = {
  AND?: InputMaybe<Array<EncryptedFileScalarWhereInput>>;
  NOT?: InputMaybe<Array<EncryptedFileScalarWhereInput>>;
  OR?: InputMaybe<Array<EncryptedFileScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  filePath?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  mainUserId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EncryptedFileUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EncryptedFileUpdateManyWithWhereWithoutMainUserInput = {
  data: EncryptedFileUpdateManyMutationInput;
  where: EncryptedFileScalarWhereInput;
};

export type EncryptedFileUpdateManyWithoutMainUserNestedInput = {
  connect?: InputMaybe<Array<EncryptedFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EncryptedFileCreateOrConnectWithoutMainUserInput>>;
  create?: InputMaybe<Array<EncryptedFileCreateWithoutMainUserInput>>;
  createMany?: InputMaybe<EncryptedFileCreateManyMainUserInputEnvelope>;
  delete?: InputMaybe<Array<EncryptedFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EncryptedFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EncryptedFileWhereUniqueInput>>;
  set?: InputMaybe<Array<EncryptedFileWhereUniqueInput>>;
  update?: InputMaybe<Array<EncryptedFileUpdateWithWhereUniqueWithoutMainUserInput>>;
  updateMany?: InputMaybe<Array<EncryptedFileUpdateManyWithWhereWithoutMainUserInput>>;
  upsert?: InputMaybe<Array<EncryptedFileUpsertWithWhereUniqueWithoutMainUserInput>>;
};

export type EncryptedFileUpdateWithWhereUniqueWithoutMainUserInput = {
  data: EncryptedFileUpdateWithoutMainUserInput;
  where: EncryptedFileWhereUniqueInput;
};

export type EncryptedFileUpdateWithoutMainUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EncryptedFileUpsertWithWhereUniqueWithoutMainUserInput = {
  create: EncryptedFileCreateWithoutMainUserInput;
  update: EncryptedFileUpdateWithoutMainUserInput;
  where: EncryptedFileWhereUniqueInput;
};

export type EncryptedFileWhereInput = {
  AND?: InputMaybe<Array<EncryptedFileWhereInput>>;
  NOT?: InputMaybe<Array<EncryptedFileWhereInput>>;
  OR?: InputMaybe<Array<EncryptedFileWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  filePath?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  mainUser?: InputMaybe<ProfileRelationFilter>;
  mainUserId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EncryptedFileWhereUniqueInput = {
  AND?: InputMaybe<Array<EncryptedFileWhereInput>>;
  NOT?: InputMaybe<Array<EncryptedFileWhereInput>>;
  OR?: InputMaybe<Array<EncryptedFileWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mainUser?: InputMaybe<ProfileRelationFilter>;
  mainUserId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EncryptionType = {
  __typename?: 'EncryptionType';
  Profile?: Maybe<Array<Profile>>;
  _count: EncryptionTypeCount;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type EncryptionTypeCount = {
  __typename?: 'EncryptionTypeCount';
  Profile: Scalars['Int']['output'];
};

export type EncryptionTypeCreateNestedOneWithoutProfileInput = {
  connect?: InputMaybe<EncryptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EncryptionTypeCreateOrConnectWithoutProfileInput>;
  create?: InputMaybe<EncryptionTypeCreateWithoutProfileInput>;
};

export type EncryptionTypeCreateOrConnectWithoutProfileInput = {
  create: EncryptionTypeCreateWithoutProfileInput;
  where: EncryptionTypeWhereUniqueInput;
};

export type EncryptionTypeCreateWithoutProfileInput = {
  title: Scalars['String']['input'];
};

export type EncryptionTypeNullableRelationFilter = {
  is?: InputMaybe<EncryptionTypeWhereInput>;
  isNot?: InputMaybe<EncryptionTypeWhereInput>;
};

export type EncryptionTypeUpdateOneWithoutProfileNestedInput = {
  connect?: InputMaybe<EncryptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EncryptionTypeCreateOrConnectWithoutProfileInput>;
  create?: InputMaybe<EncryptionTypeCreateWithoutProfileInput>;
  delete?: InputMaybe<EncryptionTypeWhereInput>;
  disconnect?: InputMaybe<EncryptionTypeWhereInput>;
  update?: InputMaybe<EncryptionTypeUpdateToOneWithWhereWithoutProfileInput>;
  upsert?: InputMaybe<EncryptionTypeUpsertWithoutProfileInput>;
};

export type EncryptionTypeUpdateToOneWithWhereWithoutProfileInput = {
  data: EncryptionTypeUpdateWithoutProfileInput;
  where?: InputMaybe<EncryptionTypeWhereInput>;
};

export type EncryptionTypeUpdateWithoutProfileInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EncryptionTypeUpsertWithoutProfileInput = {
  create: EncryptionTypeCreateWithoutProfileInput;
  update: EncryptionTypeUpdateWithoutProfileInput;
  where?: InputMaybe<EncryptionTypeWhereInput>;
};

export type EncryptionTypeWhereInput = {
  AND?: InputMaybe<Array<EncryptionTypeWhereInput>>;
  NOT?: InputMaybe<Array<EncryptionTypeWhereInput>>;
  OR?: InputMaybe<Array<EncryptionTypeWhereInput>>;
  Profile?: InputMaybe<ProfileListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type EncryptionTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<EncryptionTypeWhereInput>>;
  NOT?: InputMaybe<Array<EncryptionTypeWhereInput>>;
  OR?: InputMaybe<Array<EncryptionTypeWhereInput>>;
  Profile?: InputMaybe<ProfileListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EnumAccountStatusFilter = {
  equals?: InputMaybe<AccountStatus>;
  in?: InputMaybe<Array<AccountStatus>>;
  not?: InputMaybe<NestedEnumAccountStatusFilter>;
  notIn?: InputMaybe<Array<AccountStatus>>;
};

export type EnumAttachmentTypeFilter = {
  equals?: InputMaybe<AttachmentType>;
  in?: InputMaybe<Array<AttachmentType>>;
  not?: InputMaybe<NestedEnumAttachmentTypeFilter>;
  notIn?: InputMaybe<Array<AttachmentType>>;
};

export type EnumExportStatusFilter = {
  equals?: InputMaybe<ExportStatus>;
  in?: InputMaybe<Array<ExportStatus>>;
  not?: InputMaybe<NestedEnumExportStatusFilter>;
  notIn?: InputMaybe<Array<ExportStatus>>;
};

export type EnumHubTypeFilter = {
  equals?: InputMaybe<HubType>;
  in?: InputMaybe<Array<HubType>>;
  not?: InputMaybe<NestedEnumHubTypeFilter>;
  notIn?: InputMaybe<Array<HubType>>;
};

export type EnumParticipantStatusFilter = {
  equals?: InputMaybe<ParticipantStatus>;
  in?: InputMaybe<Array<ParticipantStatus>>;
  not?: InputMaybe<NestedEnumParticipantStatusFilter>;
  notIn?: InputMaybe<Array<ParticipantStatus>>;
};

export type EnumProfileRoleNullableListFilter = {
  equals?: InputMaybe<Array<ProfileRole>>;
  has?: InputMaybe<ProfileRole>;
  hasEvery?: InputMaybe<Array<ProfileRole>>;
  hasSome?: InputMaybe<Array<ProfileRole>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumProfileTypeFilter = {
  equals?: InputMaybe<ProfileType>;
  in?: InputMaybe<Array<ProfileType>>;
  not?: InputMaybe<NestedEnumProfileTypeFilter>;
  notIn?: InputMaybe<Array<ProfileType>>;
};

export type EnumProviderFilter = {
  equals?: InputMaybe<Provider>;
  in?: InputMaybe<Array<Provider>>;
  not?: InputMaybe<NestedEnumProviderFilter>;
  notIn?: InputMaybe<Array<Provider>>;
};

export type EnumProviderNullableFilter = {
  equals?: InputMaybe<Provider>;
  in?: InputMaybe<Array<Provider>>;
  not?: InputMaybe<NestedEnumProviderNullableFilter>;
  notIn?: InputMaybe<Array<Provider>>;
};

export type EnumScenarioModeFilter = {
  equals?: InputMaybe<ScenarioMode>;
  in?: InputMaybe<Array<ScenarioMode>>;
  not?: InputMaybe<NestedEnumScenarioModeFilter>;
  notIn?: InputMaybe<Array<ScenarioMode>>;
};

export type EnumScenarioStatusFilter = {
  equals?: InputMaybe<ScenarioStatus>;
  in?: InputMaybe<Array<ScenarioStatus>>;
  not?: InputMaybe<NestedEnumScenarioStatusFilter>;
  notIn?: InputMaybe<Array<ScenarioStatus>>;
};

export type EnumScenarioTriggerTypeFilter = {
  equals?: InputMaybe<ScenarioTriggerType>;
  in?: InputMaybe<Array<ScenarioTriggerType>>;
  not?: InputMaybe<NestedEnumScenarioTriggerTypeFilter>;
  notIn?: InputMaybe<Array<ScenarioTriggerType>>;
};

export type EnumSubscriptionStatusFilter = {
  equals?: InputMaybe<SubscriptionStatus>;
  in?: InputMaybe<Array<SubscriptionStatus>>;
  not?: InputMaybe<NestedEnumSubscriptionStatusFilter>;
  notIn?: InputMaybe<Array<SubscriptionStatus>>;
};

export type EnumUrlForExportStatusFilter = {
  equals?: InputMaybe<UrlForExportStatus>;
  in?: InputMaybe<Array<UrlForExportStatus>>;
  not?: InputMaybe<NestedEnumUrlForExportStatusFilter>;
  notIn?: InputMaybe<Array<UrlForExportStatus>>;
};

export type EnumWillRoleFilter = {
  equals?: InputMaybe<WillRole>;
  in?: InputMaybe<Array<WillRole>>;
  not?: InputMaybe<NestedEnumWillRoleFilter>;
  notIn?: InputMaybe<Array<WillRole>>;
};

export type EnumWillStatusFilter = {
  equals?: InputMaybe<WillStatus>;
  in?: InputMaybe<Array<WillStatus>>;
  not?: InputMaybe<NestedEnumWillStatusFilter>;
  notIn?: InputMaybe<Array<WillStatus>>;
};

export type Export = {
  __typename?: 'Export';
  _count: ExportCount;
  awsAccessKeyId?: Maybe<Scalars['String']['output']>;
  awsSecretAccessKey?: Maybe<Scalars['String']['output']>;
  awsServerUid?: Maybe<Scalars['String']['output']>;
  awsUserId?: Maybe<Scalars['String']['output']>;
  basicAuthLogin: Scalars['String']['output'];
  basicAuthPasswordHash: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dependentExports?: Maybe<Array<Export>>;
  dockerImage?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalHub?: Maybe<Export>;
  externalHubId?: Maybe<Scalars['String']['output']>;
  hubAlert: Scalars['Boolean']['output'];
  hubType: HubType;
  id: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isDoubleMirrorHub?: Maybe<Scalars['Boolean']['output']>;
  lastErrorData?: Maybe<Scalars['String']['output']>;
  pipelineUrl?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  profileId: Scalars['Int']['output'];
  provider?: Maybe<Provider>;
  regionCode?: Maybe<Scalars['String']['output']>;
  sjdbJsonData: Scalars['JSON']['output'];
  status: ExportStatus;
  updatedAt: Scalars['DateTime']['output'];
  url: UrlForExport;
  urlForExportId: Scalars['String']['output'];
};

export type ExportCount = {
  __typename?: 'ExportCount';
  dependentExports: Scalars['Int']['output'];
};

export type ExportCreateManyExternalHubInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin: Scalars['String']['input'];
  basicAuthPasswordHash: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['Int']['input'];
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData: Scalars['JSON']['input'];
  status: ExportStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urlForExportId: Scalars['String']['input'];
};

export type ExportCreateManyExternalHubInputEnvelope = {
  data: Array<ExportCreateManyExternalHubInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportCreateManyProfileInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin: Scalars['String']['input'];
  basicAuthPasswordHash: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalHubId?: InputMaybe<Scalars['String']['input']>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData: Scalars['JSON']['input'];
  status: ExportStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urlForExportId: Scalars['String']['input'];
};

export type ExportCreateManyProfileInputEnvelope = {
  data: Array<ExportCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportCreateNestedManyWithoutExternalHubInput = {
  connect?: InputMaybe<Array<ExportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExportCreateOrConnectWithoutExternalHubInput>>;
  create?: InputMaybe<Array<ExportCreateWithoutExternalHubInput>>;
  createMany?: InputMaybe<ExportCreateManyExternalHubInputEnvelope>;
};

export type ExportCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<ExportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExportCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<ExportCreateWithoutProfileInput>>;
  createMany?: InputMaybe<ExportCreateManyProfileInputEnvelope>;
};

export type ExportCreateNestedOneWithoutDependentExportsInput = {
  connect?: InputMaybe<ExportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExportCreateOrConnectWithoutDependentExportsInput>;
  create?: InputMaybe<ExportCreateWithoutDependentExportsInput>;
};

export type ExportCreateOrConnectWithoutDependentExportsInput = {
  create: ExportCreateWithoutDependentExportsInput;
  where: ExportWhereUniqueInput;
};

export type ExportCreateOrConnectWithoutExternalHubInput = {
  create: ExportCreateWithoutExternalHubInput;
  where: ExportWhereUniqueInput;
};

export type ExportCreateOrConnectWithoutProfileInput = {
  create: ExportCreateWithoutProfileInput;
  where: ExportWhereUniqueInput;
};

export type ExportCreateWithoutDependentExportsInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin: Scalars['String']['input'];
  basicAuthPasswordHash: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalHub?: InputMaybe<ExportCreateNestedOneWithoutDependentExportsInput>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  profile: ProfileCreateNestedOneWithoutExportsInput;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData: Scalars['JSON']['input'];
  status: ExportStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: UrlForExportCreateNestedOneWithoutExportInput;
};

export type ExportCreateWithoutExternalHubInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin: Scalars['String']['input'];
  basicAuthPasswordHash: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentExports?: InputMaybe<ExportCreateNestedManyWithoutExternalHubInput>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  profile: ProfileCreateNestedOneWithoutExportsInput;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData: Scalars['JSON']['input'];
  status: ExportStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: UrlForExportCreateNestedOneWithoutExportInput;
};

export type ExportCreateWithoutProfileInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin: Scalars['String']['input'];
  basicAuthPasswordHash: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentExports?: InputMaybe<ExportCreateNestedManyWithoutExternalHubInput>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalHub?: InputMaybe<ExportCreateNestedOneWithoutDependentExportsInput>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData: Scalars['JSON']['input'];
  status: ExportStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: UrlForExportCreateNestedOneWithoutExportInput;
};

export type ExportListRelationFilter = {
  every?: InputMaybe<ExportWhereInput>;
  none?: InputMaybe<ExportWhereInput>;
  some?: InputMaybe<ExportWhereInput>;
};

export type ExportNullableRelationFilter = {
  is?: InputMaybe<ExportWhereInput>;
  isNot?: InputMaybe<ExportWhereInput>;
};

export type ExportScalarWhereInput = {
  AND?: InputMaybe<Array<ExportScalarWhereInput>>;
  NOT?: InputMaybe<Array<ExportScalarWhereInput>>;
  OR?: InputMaybe<Array<ExportScalarWhereInput>>;
  awsAccessKeyId?: InputMaybe<StringNullableFilter>;
  awsSecretAccessKey?: InputMaybe<StringNullableFilter>;
  awsServerUid?: InputMaybe<StringNullableFilter>;
  awsUserId?: InputMaybe<StringNullableFilter>;
  basicAuthLogin?: InputMaybe<StringFilter>;
  basicAuthPasswordHash?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dockerImage?: InputMaybe<StringNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  externalHubId?: InputMaybe<StringNullableFilter>;
  hubAlert?: InputMaybe<BoolFilter>;
  hubType?: InputMaybe<EnumHubTypeFilter>;
  id?: InputMaybe<StringFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  isDoubleMirrorHub?: InputMaybe<BoolNullableFilter>;
  lastErrorData?: InputMaybe<StringNullableFilter>;
  pipelineUrl?: InputMaybe<StringNullableFilter>;
  profileId?: InputMaybe<IntFilter>;
  provider?: InputMaybe<EnumProviderNullableFilter>;
  regionCode?: InputMaybe<StringNullableFilter>;
  sjdbJsonData?: InputMaybe<JsonFilter>;
  status?: InputMaybe<EnumExportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  urlForExportId?: InputMaybe<StringFilter>;
};

export const ExportStatus = {
  AssociateDomainNewHub: 'ASSOCIATE_DOMAIN_NEW_HUB',
  CreateInstanceNewHub: 'CREATE_INSTANCE_NEW_HUB',
  DataCollectedNewHub: 'DATA_COLLECTED_NEW_HUB',
  DoneCreateMoveHub: 'DONE_CREATE_MOVE_HUB',
  DoneCreateNewHub: 'DONE_CREATE_NEW_HUB',
  DoneUpdateHub: 'DONE_UPDATE_HUB',
  DoneUpdateImageHub: 'DONE_UPDATE_IMAGE_HUB',
  ErrorAssociateDomainNewHub: 'ERROR_ASSOCIATE_DOMAIN_NEW_HUB',
  ErrorCreateInstanceNewHub: 'ERROR_CREATE_INSTANCE_NEW_HUB',
  ErrorCreateMoveHub: 'ERROR_CREATE_MOVE_HUB',
  ErrorLoadingDataNewHub: 'ERROR_LOADING_DATA_NEW_HUB',
  ErrorPreparingImageNewHub: 'ERROR_PREPARING_IMAGE_NEW_HUB',
  ErrorProcessingDataNewHub: 'ERROR_PROCESSING_DATA_NEW_HUB',
  ErrorTransferDomainMoveHub: 'ERROR_TRANSFER_DOMAIN_MOVE_HUB',
  ErrorUpdateHub: 'ERROR_UPDATE_HUB',
  ErrorUpdateImageHub: 'ERROR_UPDATE_IMAGE_HUB',
  ErrorValidateAccessMoveHub: 'ERROR_VALIDATE_ACCESS_MOVE_HUB',
  LoadingDataMoveHub: 'LOADING_DATA_MOVE_HUB',
  LoadingDataNewHub: 'LOADING_DATA_NEW_HUB',
  NeedExportMoveHub: 'NEED_EXPORT_MOVE_HUB',
  NeedUpdateHub: 'NEED_UPDATE_HUB',
  NeedUpdateImageHub: 'NEED_UPDATE_IMAGE_HUB',
  PreparingImageNewHub: 'PREPARING_IMAGE_NEW_HUB',
  ProcessingDataNewHub: 'PROCESSING_DATA_NEW_HUB',
  TransferDomainMoveHub: 'TRANSFER_DOMAIN_MOVE_HUB',
  ValidateAccessMoveHub: 'VALIDATE_ACCESS_MOVE_HUB'
} as const;

export type ExportStatus = typeof ExportStatus[keyof typeof ExportStatus];
export type ExportUpdateManyMutationInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin?: InputMaybe<Scalars['String']['input']>;
  basicAuthPasswordHash?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ExportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExportUpdateManyWithWhereWithoutExternalHubInput = {
  data: ExportUpdateManyMutationInput;
  where: ExportScalarWhereInput;
};

export type ExportUpdateManyWithWhereWithoutProfileInput = {
  data: ExportUpdateManyMutationInput;
  where: ExportScalarWhereInput;
};

export type ExportUpdateManyWithoutExternalHubNestedInput = {
  connect?: InputMaybe<Array<ExportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExportCreateOrConnectWithoutExternalHubInput>>;
  create?: InputMaybe<Array<ExportCreateWithoutExternalHubInput>>;
  createMany?: InputMaybe<ExportCreateManyExternalHubInputEnvelope>;
  delete?: InputMaybe<Array<ExportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExportWhereUniqueInput>>;
  set?: InputMaybe<Array<ExportWhereUniqueInput>>;
  update?: InputMaybe<Array<ExportUpdateWithWhereUniqueWithoutExternalHubInput>>;
  updateMany?: InputMaybe<Array<ExportUpdateManyWithWhereWithoutExternalHubInput>>;
  upsert?: InputMaybe<Array<ExportUpsertWithWhereUniqueWithoutExternalHubInput>>;
};

export type ExportUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<ExportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExportCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<ExportCreateWithoutProfileInput>>;
  createMany?: InputMaybe<ExportCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<ExportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExportWhereUniqueInput>>;
  set?: InputMaybe<Array<ExportWhereUniqueInput>>;
  update?: InputMaybe<Array<ExportUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<ExportUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<ExportUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type ExportUpdateOneWithoutDependentExportsNestedInput = {
  connect?: InputMaybe<ExportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExportCreateOrConnectWithoutDependentExportsInput>;
  create?: InputMaybe<ExportCreateWithoutDependentExportsInput>;
  delete?: InputMaybe<ExportWhereInput>;
  disconnect?: InputMaybe<ExportWhereInput>;
  update?: InputMaybe<ExportUpdateToOneWithWhereWithoutDependentExportsInput>;
  upsert?: InputMaybe<ExportUpsertWithoutDependentExportsInput>;
};

export type ExportUpdateToOneWithWhereWithoutDependentExportsInput = {
  data: ExportUpdateWithoutDependentExportsInput;
  where?: InputMaybe<ExportWhereInput>;
};

export type ExportUpdateWithWhereUniqueWithoutExternalHubInput = {
  data: ExportUpdateWithoutExternalHubInput;
  where: ExportWhereUniqueInput;
};

export type ExportUpdateWithWhereUniqueWithoutProfileInput = {
  data: ExportUpdateWithoutProfileInput;
  where: ExportWhereUniqueInput;
};

export type ExportUpdateWithoutDependentExportsInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin?: InputMaybe<Scalars['String']['input']>;
  basicAuthPasswordHash?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalHub?: InputMaybe<ExportUpdateOneWithoutDependentExportsNestedInput>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ProfileUpdateOneRequiredWithoutExportsNestedInput>;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ExportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<UrlForExportUpdateOneRequiredWithoutExportNestedInput>;
};

export type ExportUpdateWithoutExternalHubInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin?: InputMaybe<Scalars['String']['input']>;
  basicAuthPasswordHash?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentExports?: InputMaybe<ExportUpdateManyWithoutExternalHubNestedInput>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ProfileUpdateOneRequiredWithoutExportsNestedInput>;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ExportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<UrlForExportUpdateOneRequiredWithoutExportNestedInput>;
};

export type ExportUpdateWithoutProfileInput = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  awsServerUid?: InputMaybe<Scalars['String']['input']>;
  awsUserId?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin?: InputMaybe<Scalars['String']['input']>;
  basicAuthPasswordHash?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentExports?: InputMaybe<ExportUpdateManyWithoutExternalHubNestedInput>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalHub?: InputMaybe<ExportUpdateOneWithoutDependentExportsNestedInput>;
  hubAlert?: InputMaybe<Scalars['Boolean']['input']>;
  hubType?: InputMaybe<HubType>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirrorHub?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorData?: InputMaybe<Scalars['String']['input']>;
  pipelineUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Provider>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sjdbJsonData?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ExportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<UrlForExportUpdateOneRequiredWithoutExportNestedInput>;
};

export type ExportUpsertWithWhereUniqueWithoutExternalHubInput = {
  create: ExportCreateWithoutExternalHubInput;
  update: ExportUpdateWithoutExternalHubInput;
  where: ExportWhereUniqueInput;
};

export type ExportUpsertWithWhereUniqueWithoutProfileInput = {
  create: ExportCreateWithoutProfileInput;
  update: ExportUpdateWithoutProfileInput;
  where: ExportWhereUniqueInput;
};

export type ExportUpsertWithoutDependentExportsInput = {
  create: ExportCreateWithoutDependentExportsInput;
  update: ExportUpdateWithoutDependentExportsInput;
  where?: InputMaybe<ExportWhereInput>;
};

export type ExportWhereInput = {
  AND?: InputMaybe<Array<ExportWhereInput>>;
  NOT?: InputMaybe<Array<ExportWhereInput>>;
  OR?: InputMaybe<Array<ExportWhereInput>>;
  awsAccessKeyId?: InputMaybe<StringNullableFilter>;
  awsSecretAccessKey?: InputMaybe<StringNullableFilter>;
  awsServerUid?: InputMaybe<StringNullableFilter>;
  awsUserId?: InputMaybe<StringNullableFilter>;
  basicAuthLogin?: InputMaybe<StringFilter>;
  basicAuthPasswordHash?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dependentExports?: InputMaybe<ExportListRelationFilter>;
  dockerImage?: InputMaybe<StringNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  externalHub?: InputMaybe<ExportNullableRelationFilter>;
  externalHubId?: InputMaybe<StringNullableFilter>;
  hubAlert?: InputMaybe<BoolFilter>;
  hubType?: InputMaybe<EnumHubTypeFilter>;
  id?: InputMaybe<StringFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  isDoubleMirrorHub?: InputMaybe<BoolNullableFilter>;
  lastErrorData?: InputMaybe<StringNullableFilter>;
  pipelineUrl?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  provider?: InputMaybe<EnumProviderNullableFilter>;
  regionCode?: InputMaybe<StringNullableFilter>;
  sjdbJsonData?: InputMaybe<JsonFilter>;
  status?: InputMaybe<EnumExportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<UrlForExportRelationFilter>;
  urlForExportId?: InputMaybe<StringFilter>;
};

export type ExportWhereUniqueInput = {
  AND?: InputMaybe<Array<ExportWhereInput>>;
  NOT?: InputMaybe<Array<ExportWhereInput>>;
  OR?: InputMaybe<Array<ExportWhereInput>>;
  awsAccessKeyId?: InputMaybe<StringNullableFilter>;
  awsSecretAccessKey?: InputMaybe<StringNullableFilter>;
  awsServerUid?: InputMaybe<StringNullableFilter>;
  awsUserId?: InputMaybe<StringNullableFilter>;
  basicAuthLogin?: InputMaybe<StringFilter>;
  basicAuthPasswordHash?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dependentExports?: InputMaybe<ExportListRelationFilter>;
  dockerImage?: InputMaybe<StringNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  externalHub?: InputMaybe<ExportNullableRelationFilter>;
  externalHubId?: InputMaybe<StringNullableFilter>;
  hubAlert?: InputMaybe<BoolFilter>;
  hubType?: InputMaybe<EnumHubTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  isDoubleMirrorHub?: InputMaybe<BoolNullableFilter>;
  lastErrorData?: InputMaybe<StringNullableFilter>;
  pipelineUrl?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  provider?: InputMaybe<EnumProviderNullableFilter>;
  regionCode?: InputMaybe<StringNullableFilter>;
  sjdbJsonData?: InputMaybe<JsonFilter>;
  status?: InputMaybe<EnumExportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<UrlForExportRelationFilter>;
  urlForExportId?: InputMaybe<Scalars['String']['input']>;
};

export type FamilyMemberScenarioGraphResponse = {
  __typename?: 'FamilyMemberScenarioGraphResponse';
  dtoIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type FileMetaInfoInputType = {
  encryptedData: Scalars['String']['input'];
  encryptedSymmetricKey: Scalars['String']['input'];
};

export type Form = {
  __typename?: 'Form';
  createdAt: Scalars['DateTime']['output'];
  entityType: Scalars['String']['output'];
  formJson: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GenerateEmailCodeInput = {
  email: Scalars['String']['input'];
  typeEmailCode: TypeEmailCode;
};

export type GenerateEmailCodeResponse = {
  __typename?: 'GenerateEmailCodeResponse';
  expiresAt: Scalars['DateTime']['output'];
  result: Scalars['Boolean']['output'];
};

export type GetMailBoxesResponseGGl = {
  __typename?: 'GetMailBoxesResponseGGl';
  /** domain */
  mailbox?: Maybe<MailBoxesResponseGGl>;
};

export type GetZendeskToken = {
  __typename?: 'GetZendeskToken';
  /** токен */
  token: Scalars['String']['output'];
};

export type HubSettings = {
  __typename?: 'HubSettings';
  abilityToDisconnect: Scalars['Boolean']['output'];
  connectedAt: Scalars['DateTime']['output'];
  country: Scalars['String']['output'];
  hubActive: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isDoubleMirror?: Maybe<Scalars['Boolean']['output']>;
  lastPingAt: Scalars['DateTime']['output'];
  ownedByUser: Scalars['Boolean']['output'];
  permanentAddress: Scalars['String']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  provider: Provider;
  temporaryAddress: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatingHub: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type HubSettingsCreateManyProfileInput = {
  abilityToDisconnect: Scalars['Boolean']['input'];
  connectedAt: Scalars['DateTime']['input'];
  country: Scalars['String']['input'];
  hubActive: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirror?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingAt: Scalars['DateTime']['input'];
  ownedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAddress: Scalars['String']['input'];
  provider: Provider;
  temporaryAddress: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatingHub: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type HubSettingsCreateManyProfileInputEnvelope = {
  data: Array<HubSettingsCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HubSettingsCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<HubSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<HubSettingsCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<HubSettingsCreateWithoutProfileInput>>;
  createMany?: InputMaybe<HubSettingsCreateManyProfileInputEnvelope>;
};

export type HubSettingsCreateOrConnectWithoutProfileInput = {
  create: HubSettingsCreateWithoutProfileInput;
  where: HubSettingsWhereUniqueInput;
};

export type HubSettingsCreateWithoutProfileInput = {
  abilityToDisconnect: Scalars['Boolean']['input'];
  connectedAt: Scalars['DateTime']['input'];
  country: Scalars['String']['input'];
  hubActive: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirror?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingAt: Scalars['DateTime']['input'];
  ownedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAddress: Scalars['String']['input'];
  provider: Provider;
  temporaryAddress: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatingHub: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type HubSettingsListRelationFilter = {
  every?: InputMaybe<HubSettingsWhereInput>;
  none?: InputMaybe<HubSettingsWhereInput>;
  some?: InputMaybe<HubSettingsWhereInput>;
};

export type HubSettingsResponse = {
  __typename?: 'HubSettingsResponse';
  /** Возможность отключить MyHub от Owner.One */
  abilityToDisconnect: Scalars['Boolean']['output'];
  /** Дата подключения сервера к нам */
  connectedAt: Scalars['DateTime']['output'];
  /** Страна сервера */
  country: Scalars['String']['output'];
  /** Активен ли хаб */
  hubActive: Scalars['Boolean']['output'];
  /** Адресс MyHub */
  hubUrl: Scalars['String']['output'];
  /** Ip адресс */
  ipAddress: Scalars['String']['output'];
  /** Double mirror hub */
  isDoubleMirror?: Maybe<Scalars['Boolean']['output']>;
  /** Время последнего пинга сервера */
  lastPingAt: Scalars['DateTime']['output'];
  /** MyHub в собственности у пользователя */
  ownedByUser: Scalars['Boolean']['output'];
  /** ID профиля */
  profileId: Scalars['Float']['output'];
  /** Провайдер облачного хранилища */
  provider: Scalars['String']['output'];
  /** Время последнего изменения в MyHub */
  updatedAt: Scalars['DateTime']['output'];
  /** Передача данных из Owner.One в MyHub */
  updatingHub: Scalars['Boolean']['output'];
};

export type HubSettingsScalarWhereInput = {
  AND?: InputMaybe<Array<HubSettingsScalarWhereInput>>;
  NOT?: InputMaybe<Array<HubSettingsScalarWhereInput>>;
  OR?: InputMaybe<Array<HubSettingsScalarWhereInput>>;
  abilityToDisconnect?: InputMaybe<BoolFilter>;
  connectedAt?: InputMaybe<DateTimeFilter>;
  country?: InputMaybe<StringFilter>;
  hubActive?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  isDoubleMirror?: InputMaybe<BoolNullableFilter>;
  lastPingAt?: InputMaybe<DateTimeFilter>;
  ownedByUser?: InputMaybe<BoolFilter>;
  permanentAddress?: InputMaybe<StringFilter>;
  profileId?: InputMaybe<IntFilter>;
  provider?: InputMaybe<EnumProviderFilter>;
  temporaryAddress?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatingHub?: InputMaybe<BoolFilter>;
  value?: InputMaybe<StringFilter>;
};

export type HubSettingsUpdateManyMutationInput = {
  abilityToDisconnect?: InputMaybe<Scalars['Boolean']['input']>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hubActive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirror?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingAt?: InputMaybe<Scalars['DateTime']['input']>;
  ownedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Provider>;
  temporaryAddress?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatingHub?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HubSettingsUpdateManyWithWhereWithoutProfileInput = {
  data: HubSettingsUpdateManyMutationInput;
  where: HubSettingsScalarWhereInput;
};

export type HubSettingsUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<HubSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<HubSettingsCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<HubSettingsCreateWithoutProfileInput>>;
  createMany?: InputMaybe<HubSettingsCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<HubSettingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<HubSettingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<HubSettingsWhereUniqueInput>>;
  set?: InputMaybe<Array<HubSettingsWhereUniqueInput>>;
  update?: InputMaybe<Array<HubSettingsUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<HubSettingsUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<HubSettingsUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type HubSettingsUpdateWithWhereUniqueWithoutProfileInput = {
  data: HubSettingsUpdateWithoutProfileInput;
  where: HubSettingsWhereUniqueInput;
};

export type HubSettingsUpdateWithoutProfileInput = {
  abilityToDisconnect?: InputMaybe<Scalars['Boolean']['input']>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hubActive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isDoubleMirror?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingAt?: InputMaybe<Scalars['DateTime']['input']>;
  ownedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Provider>;
  temporaryAddress?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatingHub?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HubSettingsUpsertWithWhereUniqueWithoutProfileInput = {
  create: HubSettingsCreateWithoutProfileInput;
  update: HubSettingsUpdateWithoutProfileInput;
  where: HubSettingsWhereUniqueInput;
};

export type HubSettingsWhereInput = {
  AND?: InputMaybe<Array<HubSettingsWhereInput>>;
  NOT?: InputMaybe<Array<HubSettingsWhereInput>>;
  OR?: InputMaybe<Array<HubSettingsWhereInput>>;
  abilityToDisconnect?: InputMaybe<BoolFilter>;
  connectedAt?: InputMaybe<DateTimeFilter>;
  country?: InputMaybe<StringFilter>;
  hubActive?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  isDoubleMirror?: InputMaybe<BoolNullableFilter>;
  lastPingAt?: InputMaybe<DateTimeFilter>;
  ownedByUser?: InputMaybe<BoolFilter>;
  permanentAddress?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  provider?: InputMaybe<EnumProviderFilter>;
  temporaryAddress?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatingHub?: InputMaybe<BoolFilter>;
  value?: InputMaybe<StringFilter>;
};

export type HubSettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<HubSettingsWhereInput>>;
  NOT?: InputMaybe<Array<HubSettingsWhereInput>>;
  OR?: InputMaybe<Array<HubSettingsWhereInput>>;
  abilityToDisconnect?: InputMaybe<BoolFilter>;
  connectedAt?: InputMaybe<DateTimeFilter>;
  country?: InputMaybe<StringFilter>;
  hubActive?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  isDoubleMirror?: InputMaybe<BoolNullableFilter>;
  lastPingAt?: InputMaybe<DateTimeFilter>;
  ownedByUser?: InputMaybe<BoolFilter>;
  permanentAddress?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  provider?: InputMaybe<EnumProviderFilter>;
  temporaryAddress?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatingHub?: InputMaybe<BoolFilter>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export const HubType = {
  External: 'EXTERNAL',
  Inner: 'INNER',
  Moved: 'MOVED'
} as const;

export type HubType = typeof HubType[keyof typeof HubType];
export type InformationRecipientAssignment = {
  __typename?: 'InformationRecipientAssignment';
  beneficiary: WillParticipant;
  beneficiaryId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  informationRecipient: WillParticipant;
  informationRecipientId: Scalars['String']['output'];
};

export type InformationRecipientAssignmentCreateManyBeneficiaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  informationRecipientId: Scalars['String']['input'];
};

export type InformationRecipientAssignmentCreateManyBeneficiaryInputEnvelope = {
  data: Array<InformationRecipientAssignmentCreateManyBeneficiaryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InformationRecipientAssignmentCreateManyInformationRecipientInput = {
  beneficiaryId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type InformationRecipientAssignmentCreateManyInformationRecipientInputEnvelope = {
  data: Array<InformationRecipientAssignmentCreateManyInformationRecipientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InformationRecipientAssignmentCreateNestedManyWithoutBeneficiaryInput = {
  connect?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InformationRecipientAssignmentCreateOrConnectWithoutBeneficiaryInput>>;
  create?: InputMaybe<Array<InformationRecipientAssignmentCreateWithoutBeneficiaryInput>>;
  createMany?: InputMaybe<InformationRecipientAssignmentCreateManyBeneficiaryInputEnvelope>;
};

export type InformationRecipientAssignmentCreateNestedManyWithoutInformationRecipientInput = {
  connect?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InformationRecipientAssignmentCreateOrConnectWithoutInformationRecipientInput>>;
  create?: InputMaybe<Array<InformationRecipientAssignmentCreateWithoutInformationRecipientInput>>;
  createMany?: InputMaybe<InformationRecipientAssignmentCreateManyInformationRecipientInputEnvelope>;
};

export type InformationRecipientAssignmentCreateOrConnectWithoutBeneficiaryInput = {
  create: InformationRecipientAssignmentCreateWithoutBeneficiaryInput;
  where: InformationRecipientAssignmentWhereUniqueInput;
};

export type InformationRecipientAssignmentCreateOrConnectWithoutInformationRecipientInput = {
  create: InformationRecipientAssignmentCreateWithoutInformationRecipientInput;
  where: InformationRecipientAssignmentWhereUniqueInput;
};

export type InformationRecipientAssignmentCreateWithoutBeneficiaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  informationRecipient: WillParticipantCreateNestedOneWithoutAsInformationRecipientInput;
};

export type InformationRecipientAssignmentCreateWithoutInformationRecipientInput = {
  beneficiary: WillParticipantCreateNestedOneWithoutAsBeneficiaryWithRecipientInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type InformationRecipientAssignmentInformationRecipientIdBeneficiaryIdCompoundUniqueInput = {
  beneficiaryId: Scalars['String']['input'];
  informationRecipientId: Scalars['String']['input'];
};

export type InformationRecipientAssignmentListRelationFilter = {
  every?: InputMaybe<InformationRecipientAssignmentWhereInput>;
  none?: InputMaybe<InformationRecipientAssignmentWhereInput>;
  some?: InputMaybe<InformationRecipientAssignmentWhereInput>;
};

export type InformationRecipientAssignmentScalarWhereInput = {
  AND?: InputMaybe<Array<InformationRecipientAssignmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<InformationRecipientAssignmentScalarWhereInput>>;
  OR?: InputMaybe<Array<InformationRecipientAssignmentScalarWhereInput>>;
  beneficiaryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  informationRecipientId?: InputMaybe<StringFilter>;
};

export type InformationRecipientAssignmentUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type InformationRecipientAssignmentUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: InformationRecipientAssignmentUpdateManyMutationInput;
  where: InformationRecipientAssignmentScalarWhereInput;
};

export type InformationRecipientAssignmentUpdateManyWithWhereWithoutInformationRecipientInput = {
  data: InformationRecipientAssignmentUpdateManyMutationInput;
  where: InformationRecipientAssignmentScalarWhereInput;
};

export type InformationRecipientAssignmentUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InformationRecipientAssignmentCreateOrConnectWithoutBeneficiaryInput>>;
  create?: InputMaybe<Array<InformationRecipientAssignmentCreateWithoutBeneficiaryInput>>;
  createMany?: InputMaybe<InformationRecipientAssignmentCreateManyBeneficiaryInputEnvelope>;
  delete?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InformationRecipientAssignmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  set?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  update?: InputMaybe<Array<InformationRecipientAssignmentUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: InputMaybe<Array<InformationRecipientAssignmentUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: InputMaybe<Array<InformationRecipientAssignmentUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type InformationRecipientAssignmentUpdateManyWithoutInformationRecipientNestedInput = {
  connect?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InformationRecipientAssignmentCreateOrConnectWithoutInformationRecipientInput>>;
  create?: InputMaybe<Array<InformationRecipientAssignmentCreateWithoutInformationRecipientInput>>;
  createMany?: InputMaybe<InformationRecipientAssignmentCreateManyInformationRecipientInputEnvelope>;
  delete?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InformationRecipientAssignmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  set?: InputMaybe<Array<InformationRecipientAssignmentWhereUniqueInput>>;
  update?: InputMaybe<Array<InformationRecipientAssignmentUpdateWithWhereUniqueWithoutInformationRecipientInput>>;
  updateMany?: InputMaybe<Array<InformationRecipientAssignmentUpdateManyWithWhereWithoutInformationRecipientInput>>;
  upsert?: InputMaybe<Array<InformationRecipientAssignmentUpsertWithWhereUniqueWithoutInformationRecipientInput>>;
};

export type InformationRecipientAssignmentUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: InformationRecipientAssignmentUpdateWithoutBeneficiaryInput;
  where: InformationRecipientAssignmentWhereUniqueInput;
};

export type InformationRecipientAssignmentUpdateWithWhereUniqueWithoutInformationRecipientInput = {
  data: InformationRecipientAssignmentUpdateWithoutInformationRecipientInput;
  where: InformationRecipientAssignmentWhereUniqueInput;
};

export type InformationRecipientAssignmentUpdateWithoutBeneficiaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  informationRecipient?: InputMaybe<WillParticipantUpdateOneRequiredWithoutAsInformationRecipientNestedInput>;
};

export type InformationRecipientAssignmentUpdateWithoutInformationRecipientInput = {
  beneficiary?: InputMaybe<WillParticipantUpdateOneRequiredWithoutAsBeneficiaryWithRecipientNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type InformationRecipientAssignmentUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: InformationRecipientAssignmentCreateWithoutBeneficiaryInput;
  update: InformationRecipientAssignmentUpdateWithoutBeneficiaryInput;
  where: InformationRecipientAssignmentWhereUniqueInput;
};

export type InformationRecipientAssignmentUpsertWithWhereUniqueWithoutInformationRecipientInput = {
  create: InformationRecipientAssignmentCreateWithoutInformationRecipientInput;
  update: InformationRecipientAssignmentUpdateWithoutInformationRecipientInput;
  where: InformationRecipientAssignmentWhereUniqueInput;
};

export type InformationRecipientAssignmentWhereInput = {
  AND?: InputMaybe<Array<InformationRecipientAssignmentWhereInput>>;
  NOT?: InputMaybe<Array<InformationRecipientAssignmentWhereInput>>;
  OR?: InputMaybe<Array<InformationRecipientAssignmentWhereInput>>;
  beneficiary?: InputMaybe<WillParticipantRelationFilter>;
  beneficiaryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  informationRecipient?: InputMaybe<WillParticipantRelationFilter>;
  informationRecipientId?: InputMaybe<StringFilter>;
};

export type InformationRecipientAssignmentWhereUniqueInput = {
  AND?: InputMaybe<Array<InformationRecipientAssignmentWhereInput>>;
  NOT?: InputMaybe<Array<InformationRecipientAssignmentWhereInput>>;
  OR?: InputMaybe<Array<InformationRecipientAssignmentWhereInput>>;
  beneficiary?: InputMaybe<WillParticipantRelationFilter>;
  beneficiaryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  informationRecipient?: InputMaybe<WillParticipantRelationFilter>;
  informationRecipientId?: InputMaybe<StringFilter>;
  informationRecipientIdBeneficiaryId?: InputMaybe<InformationRecipientAssignmentInformationRecipientIdBeneficiaryIdCompoundUniqueInput>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type KeysInput = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type MailBoxesResponseGGl = {
  __typename?: 'MailBoxesResponseGGl';
  /** Date create */
  createdAt: Scalars['DateTime']['output'];
  /** domain */
  domain: Scalars['String']['output'];
  /** domain */
  profileId: Scalars['String']['output'];
  /** Date update */
  updatedAt: Scalars['DateTime']['output'];
  /** username */
  username: Scalars['String']['output'];
};

export type Mailbox = {
  __typename?: 'Mailbox';
  createdAt: Scalars['DateTime']['output'];
  domain: Scalars['String']['output'];
  password: Scalars['String']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type MailboxCreateManyProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  domain: Scalars['String']['input'];
  password: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  username: Scalars['String']['input'];
};

export type MailboxCreateManyProfileInputEnvelope = {
  data: Array<MailboxCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MailboxCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<MailboxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MailboxCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<MailboxCreateWithoutProfileInput>>;
  createMany?: InputMaybe<MailboxCreateManyProfileInputEnvelope>;
};

export type MailboxCreateOrConnectWithoutProfileInput = {
  create: MailboxCreateWithoutProfileInput;
  where: MailboxWhereUniqueInput;
};

export type MailboxCreateWithoutProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  domain: Scalars['String']['input'];
  password: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  username: Scalars['String']['input'];
};

export type MailboxListRelationFilter = {
  every?: InputMaybe<MailboxWhereInput>;
  none?: InputMaybe<MailboxWhereInput>;
  some?: InputMaybe<MailboxWhereInput>;
};

export type MailboxScalarWhereInput = {
  AND?: InputMaybe<Array<MailboxScalarWhereInput>>;
  NOT?: InputMaybe<Array<MailboxScalarWhereInput>>;
  OR?: InputMaybe<Array<MailboxScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  domain?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
  profileId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringFilter>;
};

export type MailboxUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MailboxUpdateManyWithWhereWithoutProfileInput = {
  data: MailboxUpdateManyMutationInput;
  where: MailboxScalarWhereInput;
};

export type MailboxUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<MailboxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MailboxCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<MailboxCreateWithoutProfileInput>>;
  createMany?: InputMaybe<MailboxCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<MailboxWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MailboxScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MailboxWhereUniqueInput>>;
  set?: InputMaybe<Array<MailboxWhereUniqueInput>>;
  update?: InputMaybe<Array<MailboxUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<MailboxUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<MailboxUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type MailboxUpdateWithWhereUniqueWithoutProfileInput = {
  data: MailboxUpdateWithoutProfileInput;
  where: MailboxWhereUniqueInput;
};

export type MailboxUpdateWithoutProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MailboxUpsertWithWhereUniqueWithoutProfileInput = {
  create: MailboxCreateWithoutProfileInput;
  update: MailboxUpdateWithoutProfileInput;
  where: MailboxWhereUniqueInput;
};

export type MailboxWhereInput = {
  AND?: InputMaybe<Array<MailboxWhereInput>>;
  NOT?: InputMaybe<Array<MailboxWhereInput>>;
  OR?: InputMaybe<Array<MailboxWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  domain?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringFilter>;
};

export type MailboxWhereUniqueInput = {
  AND?: InputMaybe<Array<MailboxWhereInput>>;
  NOT?: InputMaybe<Array<MailboxWhereInput>>;
  OR?: InputMaybe<Array<MailboxWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  domain?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MetaInput = {
  language: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Активация аккаунта */
  activateAccount: Account;
  /** Активация аккаунта после сквозной регистрации */
  activateAccountAfterExternalRegistration: Scalars['Boolean']['output'];
  /** Активация профиля бенефициара */
  activateBeneficiaryProfile: Account;
  /** Активировать сценарий */
  activateScenario: ScenarioGraphResponse;
  /** Добавление дополнительных данных (ip адрес и awsUserId ) */
  addExportAdditionalFields: Scalars['Boolean']['output'];
  /** Добавить новый элемент в коллекцию (GQL) */
  addItemToCollectionGql: AddItemGqlPayload;
  /** Add multiple items to a collection (GQL) */
  addItemsToCollectionGql: AddItemsGqlPayload;
  /** Добавить в белый список */
  addToWhitelist: Whitelist;
  /** Создать две новые коллекци в коллекциях из для attachment файлов (GQL) */
  attachFilesFomInboxGgl: ChangeItemGqlPayload;
  /** Блокировка аккаунта */
  blockAccount: Scalars['Boolean']['output'];
  /** Deactivate all scenarios */
  cancelAllScenarios: Scalars['Boolean']['output'];
  /** Отменить сценарий */
  cancelScenario: ScenarioGraphResponse;
  /** Отменить подписку */
  cancelSubscription: Scalars['Boolean']['output'];
  /** Change base currency */
  changeBaseCurrency: Profile;
  /** Изменить существующий элемент в коллекции (GQL) */
  changeItemInCollectionGql: ChangeItemGqlPayload;
  /** Изменение пароля аккаунта */
  changePassword: Account;
  /** Управление активацие totp */
  changeTotpEnabled: Scalars['Boolean']['output'];
  /** Создание аккаунта ассистента */
  createAssistant: Account;
  /** Создание бенефициара */
  createBeneficiary: CreateBeneficiaryResponse;
  createBeneficiaryAnonymousPropForEmail: BeneficiaryAnonymousPropForEmail;
  /** Создание email аккаунта */
  createEmailAccount: CreateEmailAccount;
  createNextOwnerPropForEmail: NextOwnerPropForEmail;
  /** Create region name */
  createRegionName: RegionName;
  /** Создать сценарий */
  createScenario: ScenarioGraphResponse;
  /** Удаление email аккаунта */
  deleteEmailAccount: DeleteEmailAccount;
  /** Удалить файл */
  deleteFile: Scalars['Boolean']['output'];
  /** Delete user hub */
  deleteUserHub: Scalars['Boolean']['output'];
  echoMutation: Scalars['String']['output'];
  /** Отправка кода сброса пароля на email если забыли пароль */
  forgotPassword: Scalars['Boolean']['output'];
  /** Генерация и отправка письма с генерированным кодом верификации */
  generateEmailCode: GenerateEmailCodeResponse;
  /** Генерация зашифрованного сообщения */
  generateEncryptedMessage: Scalars['String']['output'];
  /** Генерация смс кода */
  generateSmsCodeResponse: Scalars['Boolean']['output'];
  /** Получить курс валют согласно базовой валюты */
  getCurrencyRates: Array<CurrencyRateResponse>;
  /** Вход в систему */
  login: AuthResponse;
  /** Вход в систему через расшифрованное сообщение */
  loginViaDecryptedMessage: AuthResponse;
  /**
   * Вход в систему через код из ЛК, происходит валидация кода ЛК.
   *     Во время которого создается пользователь новый если нет или обновляються данные по пользователю если есть.
   *     Также подгружаеться в базу текущая подписка если есть. Затем генерируеться токен  и создаеться запись в account-ssesion.
   *     Возвращает объект содержащий токен и аккаунт
   */
  loginViaPersonalAccountCode: AuthLoginResponse;
  /** Выход из системы */
  logout: Scalars['Boolean']['output'];
  /** Migrate encryption type to ecies */
  migrateToEcies: Profile;
  /** Уведомление пользователя что экспорт успешен */
  notifyUserThatExportDone: Scalars['Boolean']['output'];
  /** Отправить коллекцию (deprecated) */
  pushCollection: Scalars['Boolean']['output'];
  pushFileEncryptedSymmetricKey: Scalars['Boolean']['output'];
  /** Восстановить приглашение бенефициаров */
  regenerateBeneficiaryInvite: CreateBeneficiaryResponse;
  /** Регистрация пользователя */
  register: AuthResponse;
  /** Регистрация бенефициара по коду приглашения */
  registerBeneficiaryByInvitationCode: AuthResponse;
  removeBeneficiaryAnonymousPropForEmail: Scalars['Boolean']['output'];
  /** Удалить элемент из коллекции (GQL) */
  removeItemFromCollectionGql: RemoveItemGqlPayload;
  /** Remove multiple items from a collection (GQL) */
  removeItemsFromCollectionGql: RemoveItemsGqlPayload;
  removeNextOwnerPropForEmail: Scalars['Boolean']['output'];
  /** Удалить сценарий */
  removeScenario: Scalars['Boolean']['output'];
  /** Cоздание хаба пользователя */
  requestExport: Scalars['Boolean']['output'];
  /** Сброс пароля аккаунта */
  resetPassword: Account;
  /** Сброс пароля по коду */
  resetPasswordByCode: Account;
  /** Запустить все сценарии */
  runAllScenarios: Scalars['Boolean']['output'];
  /** Run scenario Immediately  */
  runScenarioImmediately: Scalars['Boolean']['output'];
  /** Отправка почты */
  sendEmail: Scalars['String']['output'];
  /** Отправка приглашения в бенефициары */
  sendNewInviteToBeneficiary: Profile;
  /** Пометить сценарий как просмотренный */
  setScenarioViewed: Scalars['Boolean']['output'];
  /** Создать подписку */
  subscribe: SubscriptionEntity;
  /** Update account schema version */
  updateAccountSchemaVersion: Account;
  updateBeneficiaryAnonymousPropForEmail: BeneficiaryAnonymousPropForEmail;
  /** Update multiple items in the specified collection (GQL) */
  updateItemsInCollectionGql: UpdateItemsGqlPayload;
  /** Update multiple collections at once (GQL) */
  updateManyCollectionsGql: UpdateManyCollectionsGqlPayload;
  updateNextOwnerPropForEmail: NextOwnerPropForEmail;
  /** Update  profile */
  updateProfile: Profile;
  /** Update region name by id */
  updateRegionNameById: RegionName;
  /** Обновить сценарий */
  updateScenario: ScenarioGraphResponse;
  /** Загрузка файла в хранилище */
  uploadFile: Scalars['String']['output'];
  /** Проверка пароля на валидность */
  verifyPassword: Scalars['Boolean']['output'];
  /** Подписаться на уведомления */
  webPushSubscribe: Scalars['Boolean']['output'];
  /** Отписаться от уведомлений */
  webPushUnsubscribe: Scalars['Boolean']['output'];
};


export type MutationActivateAccountArgs = {
  data: ActivateAccountInput;
};


export type MutationActivateAccountAfterExternalRegistrationArgs = {
  publicKey: Scalars['String']['input'];
};


export type MutationActivateBeneficiaryProfileArgs = {
  data: BeneficiaryActivationInput;
};


export type MutationActivateScenarioArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationAddExportAdditionalFieldsArgs = {
  awsUserId: Scalars['String']['input'];
  ipAddress: Scalars['String']['input'];
};


export type MutationAddItemToCollectionGqlArgs = {
  input: AddItemGqlInput;
};


export type MutationAddItemsToCollectionGqlArgs = {
  input: AddItemsGqlInput;
};


export type MutationAddToWhitelistArgs = {
  email: Scalars['String']['input'];
  planId: Scalars['String']['input'];
};


export type MutationAttachFilesFomInboxGglArgs = {
  input: AttachFileGqlInput;
};


export type MutationBlockAccountArgs = {
  emailCode: Scalars['String']['input'];
};


export type MutationCancelScenarioArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationCancelSubscriptionArgs = {
  subscriptionId: Scalars['Float']['input'];
};


export type MutationChangeBaseCurrencyArgs = {
  data: ChangeCurrencyInput;
};


export type MutationChangeItemInCollectionGqlArgs = {
  input: ChangeItemGqlInput;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationChangeTotpEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationCreateAssistantArgs = {
  data: AssistantInput;
};


export type MutationCreateBeneficiaryArgs = {
  data: BeneficiaryInput;
};


export type MutationCreateBeneficiaryAnonymousPropForEmailArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationCreateEmailAccountArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCreateNextOwnerPropForEmailArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationCreateRegionNameArgs = {
  data: CreateRegionNameInput;
};


export type MutationCreateScenarioArgs = {
  beneficiaryProfileId: Scalars['Float']['input'];
  dtoIds: Array<Scalars['String']['input']>;
  mode?: InputMaybe<ScenarioMode>;
  notificationPeriod: Scalars['Float']['input'];
  notificationTime: Scalars['DateTime']['input'];
  notificationValue: Scalars['Float']['input'];
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['Float']['input'];
};


export type MutationDeleteEmailAccountArgs = {
  username: Scalars['String']['input'];
};


export type MutationDeleteFileArgs = {
  filename: Scalars['String']['input'];
};


export type MutationEchoMutationArgs = {
  text: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateEmailCodeArgs = {
  data: GenerateEmailCodeInput;
};


export type MutationGenerateEncryptedMessageArgs = {
  publicKey: Scalars['String']['input'];
};


export type MutationGenerateSmsCodeResponseArgs = {
  number: Scalars['String']['input'];
};


export type MutationGetCurrencyRatesArgs = {
  data: CurrencyInput;
};


export type MutationLoginArgs = {
  data: EmailPasswordInput;
  totpToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginViaDecryptedMessageArgs = {
  decryptedMessage: Scalars['String']['input'];
};


export type MutationLoginViaPersonalAccountCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  sessionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMigrateToEciesArgs = {
  assistants?: InputMaybe<Array<UpdateAssistantKey>>;
  publicKey: Scalars['String']['input'];
};


export type MutationNotifyUserThatExportDoneArgs = {
  profileId: Scalars['Int']['input'];
};


export type MutationPushCollectionArgs = {
  data: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationPushFileEncryptedSymmetricKeyArgs = {
  encryptedFileSymmetricKey: Scalars['String']['input'];
  encryptedSymmetricKey: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  metaInfo: FileMetaInfoInputType;
  publicKey: Scalars['String']['input'];
};


export type MutationRegenerateBeneficiaryInviteArgs = {
  beneficiaryProfileId: Scalars['Int']['input'];
};


export type MutationRegisterArgs = {
  data: RegisterInput;
};


export type MutationRegisterBeneficiaryByInvitationCodeArgs = {
  input: BeneficiaryCreateByInviteCodeInput;
};


export type MutationRemoveBeneficiaryAnonymousPropForEmailArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveItemFromCollectionGqlArgs = {
  input: RemoveItemGqlInput;
};


export type MutationRemoveItemsFromCollectionGqlArgs = {
  input: RemoveItemsGqlInput;
};


export type MutationRemoveNextOwnerPropForEmailArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveScenarioArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationRequestExportArgs = {
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  basicAuthLogin: Scalars['String']['input'];
  basicAuthPassword: Scalars['String']['input'];
  hubType?: InputMaybe<Scalars['String']['input']>;
  idInnerHub?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationResetPasswordArgs = {
  data: ResetPasswordInput;
};


export type MutationResetPasswordByCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationRunScenarioImmediatelyArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationSendEmailArgs = {
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
  to: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationSendNewInviteToBeneficiaryArgs = {
  beneficiaryId: Scalars['Int']['input'];
};


export type MutationSetScenarioViewedArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationSubscribeArgs = {
  plan: Scalars['String']['input'];
};


export type MutationUpdateAccountSchemaVersionArgs = {
  input: UpdateSchemaVersionInput;
};


export type MutationUpdateBeneficiaryAnonymousPropForEmailArgs = {
  firstName: Scalars['String']['input'];
  id: Scalars['Float']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationUpdateItemsInCollectionGqlArgs = {
  input: UpdateItemsGqlInput;
};


export type MutationUpdateManyCollectionsGqlArgs = {
  input: UpdateManyCollectionsGqlInput;
};


export type MutationUpdateNextOwnerPropForEmailArgs = {
  firstName: Scalars['String']['input'];
  id: Scalars['Float']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationUpdateProfileArgs = {
  input: ProfileUpdateInput;
};


export type MutationUpdateRegionNameByIdArgs = {
  data: UpdateRegionNameInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateScenarioArgs = {
  beneficiaryProfileId?: InputMaybe<Scalars['Float']['input']>;
  input: ScenarioUpdateInput;
  scenarioId: Scalars['String']['input'];
};


export type MutationUploadFileArgs = {
  fileContent: Scalars['String']['input'];
};


export type MutationVerifyPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationWebPushSubscribeArgs = {
  subscription: WebPushSubscriptionInput;
};


export type MutationWebPushUnsubscribeArgs = {
  subscription: WebPushSubscriptionInput;
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumAccountStatusFilter = {
  equals?: InputMaybe<AccountStatus>;
  in?: InputMaybe<Array<AccountStatus>>;
  not?: InputMaybe<NestedEnumAccountStatusFilter>;
  notIn?: InputMaybe<Array<AccountStatus>>;
};

export type NestedEnumAttachmentTypeFilter = {
  equals?: InputMaybe<AttachmentType>;
  in?: InputMaybe<Array<AttachmentType>>;
  not?: InputMaybe<NestedEnumAttachmentTypeFilter>;
  notIn?: InputMaybe<Array<AttachmentType>>;
};

export type NestedEnumExportStatusFilter = {
  equals?: InputMaybe<ExportStatus>;
  in?: InputMaybe<Array<ExportStatus>>;
  not?: InputMaybe<NestedEnumExportStatusFilter>;
  notIn?: InputMaybe<Array<ExportStatus>>;
};

export type NestedEnumHubTypeFilter = {
  equals?: InputMaybe<HubType>;
  in?: InputMaybe<Array<HubType>>;
  not?: InputMaybe<NestedEnumHubTypeFilter>;
  notIn?: InputMaybe<Array<HubType>>;
};

export type NestedEnumParticipantStatusFilter = {
  equals?: InputMaybe<ParticipantStatus>;
  in?: InputMaybe<Array<ParticipantStatus>>;
  not?: InputMaybe<NestedEnumParticipantStatusFilter>;
  notIn?: InputMaybe<Array<ParticipantStatus>>;
};

export type NestedEnumProfileTypeFilter = {
  equals?: InputMaybe<ProfileType>;
  in?: InputMaybe<Array<ProfileType>>;
  not?: InputMaybe<NestedEnumProfileTypeFilter>;
  notIn?: InputMaybe<Array<ProfileType>>;
};

export type NestedEnumProviderFilter = {
  equals?: InputMaybe<Provider>;
  in?: InputMaybe<Array<Provider>>;
  not?: InputMaybe<NestedEnumProviderFilter>;
  notIn?: InputMaybe<Array<Provider>>;
};

export type NestedEnumProviderNullableFilter = {
  equals?: InputMaybe<Provider>;
  in?: InputMaybe<Array<Provider>>;
  not?: InputMaybe<NestedEnumProviderNullableFilter>;
  notIn?: InputMaybe<Array<Provider>>;
};

export type NestedEnumScenarioModeFilter = {
  equals?: InputMaybe<ScenarioMode>;
  in?: InputMaybe<Array<ScenarioMode>>;
  not?: InputMaybe<NestedEnumScenarioModeFilter>;
  notIn?: InputMaybe<Array<ScenarioMode>>;
};

export type NestedEnumScenarioStatusFilter = {
  equals?: InputMaybe<ScenarioStatus>;
  in?: InputMaybe<Array<ScenarioStatus>>;
  not?: InputMaybe<NestedEnumScenarioStatusFilter>;
  notIn?: InputMaybe<Array<ScenarioStatus>>;
};

export type NestedEnumScenarioTriggerTypeFilter = {
  equals?: InputMaybe<ScenarioTriggerType>;
  in?: InputMaybe<Array<ScenarioTriggerType>>;
  not?: InputMaybe<NestedEnumScenarioTriggerTypeFilter>;
  notIn?: InputMaybe<Array<ScenarioTriggerType>>;
};

export type NestedEnumSubscriptionStatusFilter = {
  equals?: InputMaybe<SubscriptionStatus>;
  in?: InputMaybe<Array<SubscriptionStatus>>;
  not?: InputMaybe<NestedEnumSubscriptionStatusFilter>;
  notIn?: InputMaybe<Array<SubscriptionStatus>>;
};

export type NestedEnumUrlForExportStatusFilter = {
  equals?: InputMaybe<UrlForExportStatus>;
  in?: InputMaybe<Array<UrlForExportStatus>>;
  not?: InputMaybe<NestedEnumUrlForExportStatusFilter>;
  notIn?: InputMaybe<Array<UrlForExportStatus>>;
};

export type NestedEnumWillRoleFilter = {
  equals?: InputMaybe<WillRole>;
  in?: InputMaybe<Array<WillRole>>;
  not?: InputMaybe<NestedEnumWillRoleFilter>;
  notIn?: InputMaybe<Array<WillRole>>;
};

export type NestedEnumWillStatusFilter = {
  equals?: InputMaybe<WillStatus>;
  in?: InputMaybe<Array<WillStatus>>;
  not?: InputMaybe<NestedEnumWillStatusFilter>;
  notIn?: InputMaybe<Array<WillStatus>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export const NewScenarioStatus = {
  Active: 'ACTIVE',
  Done: 'DONE',
  Draft: 'DRAFT'
} as const;

export type NewScenarioStatus = typeof NewScenarioStatus[keyof typeof NewScenarioStatus];
export type NextOwnerPropForEmail = {
  __typename?: 'NextOwnerPropForEmail';
  account: Account;
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NextOwnerPropForEmailCreateManyAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextOwnerPropForEmailCreateManyAccountInputEnvelope = {
  data: Array<NextOwnerPropForEmailCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextOwnerPropForEmailCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<NextOwnerPropForEmailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NextOwnerPropForEmailCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<NextOwnerPropForEmailCreateWithoutAccountInput>>;
  createMany?: InputMaybe<NextOwnerPropForEmailCreateManyAccountInputEnvelope>;
};

export type NextOwnerPropForEmailCreateOrConnectWithoutAccountInput = {
  create: NextOwnerPropForEmailCreateWithoutAccountInput;
  where: NextOwnerPropForEmailWhereUniqueInput;
};

export type NextOwnerPropForEmailCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextOwnerPropForEmailListRelationFilter = {
  every?: InputMaybe<NextOwnerPropForEmailWhereInput>;
  none?: InputMaybe<NextOwnerPropForEmailWhereInput>;
  some?: InputMaybe<NextOwnerPropForEmailWhereInput>;
};

export type NextOwnerPropForEmailScalarWhereInput = {
  AND?: InputMaybe<Array<NextOwnerPropForEmailScalarWhereInput>>;
  NOT?: InputMaybe<Array<NextOwnerPropForEmailScalarWhereInput>>;
  OR?: InputMaybe<Array<NextOwnerPropForEmailScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  lastName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NextOwnerPropForEmailUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextOwnerPropForEmailUpdateManyWithWhereWithoutAccountInput = {
  data: NextOwnerPropForEmailUpdateManyMutationInput;
  where: NextOwnerPropForEmailScalarWhereInput;
};

export type NextOwnerPropForEmailUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<NextOwnerPropForEmailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NextOwnerPropForEmailCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<NextOwnerPropForEmailCreateWithoutAccountInput>>;
  createMany?: InputMaybe<NextOwnerPropForEmailCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<NextOwnerPropForEmailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NextOwnerPropForEmailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NextOwnerPropForEmailWhereUniqueInput>>;
  set?: InputMaybe<Array<NextOwnerPropForEmailWhereUniqueInput>>;
  update?: InputMaybe<Array<NextOwnerPropForEmailUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<NextOwnerPropForEmailUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<NextOwnerPropForEmailUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type NextOwnerPropForEmailUpdateWithWhereUniqueWithoutAccountInput = {
  data: NextOwnerPropForEmailUpdateWithoutAccountInput;
  where: NextOwnerPropForEmailWhereUniqueInput;
};

export type NextOwnerPropForEmailUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextOwnerPropForEmailUpsertWithWhereUniqueWithoutAccountInput = {
  create: NextOwnerPropForEmailCreateWithoutAccountInput;
  update: NextOwnerPropForEmailUpdateWithoutAccountInput;
  where: NextOwnerPropForEmailWhereUniqueInput;
};

export type NextOwnerPropForEmailWhereInput = {
  AND?: InputMaybe<Array<NextOwnerPropForEmailWhereInput>>;
  NOT?: InputMaybe<Array<NextOwnerPropForEmailWhereInput>>;
  OR?: InputMaybe<Array<NextOwnerPropForEmailWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  lastName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NextOwnerPropForEmailWhereUniqueInput = {
  AND?: InputMaybe<Array<NextOwnerPropForEmailWhereInput>>;
  NOT?: InputMaybe<Array<NextOwnerPropForEmailWhereInput>>;
  OR?: InputMaybe<Array<NextOwnerPropForEmailWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OneTimeCodesResponse = {
  __typename?: 'OneTimeCodesResponse';
  emailCode?: Maybe<Scalars['String']['output']>;
  smsCode?: Maybe<Scalars['String']['output']>;
};

export const ParticipantStatus = {
  Accepted: 'ACCEPTED',
  Declined: 'DECLINED',
  Invited: 'INVITED',
  Signed: 'SIGNED'
} as const;

export type ParticipantStatus = typeof ParticipantStatus[keyof typeof ParticipantStatus];
export type Profile = {
  __typename?: 'Profile';
  _count: ProfileCount;
  accounts?: Maybe<Array<Account>>;
  allowMobilePush?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  baseCurrency: Currency;
  baseCurrencyId: Scalars['Int']['output'];
  beneficiaryInviteCodeAsMainUser?: Maybe<Array<BeneficiaryInviteCode>>;
  beneficiaryInviteCodeAsUsedForProfile?: Maybe<Array<BeneficiaryInviteCode>>;
  bio?: Maybe<Scalars['String']['output']>;
  collections?: Maybe<Array<Collection>>;
  createdAt: Scalars['DateTime']['output'];
  dependentUsers?: Maybe<Array<Profile>>;
  encryptedFiles?: Maybe<Array<EncryptedFile>>;
  encryptionType?: Maybe<EncryptionType>;
  encryptionTypeId?: Maybe<Scalars['Int']['output']>;
  exports?: Maybe<Array<Export>>;
  firstName?: Maybe<Scalars['String']['output']>;
  hubSettings?: Maybe<Array<HubSettings>>;
  id: Scalars['Int']['output'];
  invitationLastSentTime?: Maybe<Scalars['DateTime']['output']>;
  lastActivityAt: Scalars['DateTime']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mailboxes?: Maybe<Array<Mailbox>>;
  mainUser?: Maybe<Profile>;
  mainUserId?: Maybe<Scalars['Int']['output']>;
  ocrSuppressLetsTryConfirmation: Scalars['Boolean']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: Maybe<Array<Scenario>>;
  scenariosBelongingToMeAsMainUser?: Maybe<Array<Scenario>>;
  soweAppendixSuppressCancelConfirmation: Scalars['Boolean']['output'];
  status: AccountStatus;
  subscriptions?: Maybe<Array<SubscriptionEntity>>;
  totpEnabled: Scalars['Boolean']['output'];
  twoFactorQuestions?: Maybe<Array<TwoFactorQuestion>>;
  twoFactorQuestionsEnabled: Scalars['Boolean']['output'];
  type: ProfileType;
  updatedAt: Scalars['DateTime']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  webPushSubscriptions?: Maybe<Array<WebPushSubscription>>;
  willParticipations?: Maybe<Array<WillParticipant>>;
  willsAsCreator?: Maybe<Array<Will>>;
};

export type ProfileCount = {
  __typename?: 'ProfileCount';
  accounts: Scalars['Int']['output'];
  beneficiaryInviteCodeAsMainUser: Scalars['Int']['output'];
  beneficiaryInviteCodeAsUsedForProfile: Scalars['Int']['output'];
  collections: Scalars['Int']['output'];
  dependentUsers: Scalars['Int']['output'];
  encryptedFiles: Scalars['Int']['output'];
  exports: Scalars['Int']['output'];
  hubSettings: Scalars['Int']['output'];
  mailboxes: Scalars['Int']['output'];
  scenariosBelongingToMeAsBeneficiary: Scalars['Int']['output'];
  scenariosBelongingToMeAsMainUser: Scalars['Int']['output'];
  subscriptions: Scalars['Int']['output'];
  twoFactorQuestions: Scalars['Int']['output'];
  webPushSubscriptions: Scalars['Int']['output'];
  willParticipations: Scalars['Int']['output'];
  willsAsCreator: Scalars['Int']['output'];
};

export type ProfileCreateManyMainUserInput = {
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrencyId?: InputMaybe<Scalars['Int']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  encryptionTypeId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileCreateManyMainUserInputEnvelope = {
  data: Array<ProfileCreateManyMainUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileCreateNestedManyWithoutMainUserInput = {
  connect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileCreateOrConnectWithoutMainUserInput>>;
  create?: InputMaybe<Array<ProfileCreateWithoutMainUserInput>>;
  createMany?: InputMaybe<ProfileCreateManyMainUserInputEnvelope>;
};

export type ProfileCreateNestedOneWithoutBeneficiaryInviteCodeAsMainUserInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutBeneficiaryInviteCodeAsMainUserInput>;
  create?: InputMaybe<ProfileCreateWithoutBeneficiaryInviteCodeAsMainUserInput>;
};

export type ProfileCreateNestedOneWithoutBeneficiaryInviteCodeAsUsedForProfileInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutBeneficiaryInviteCodeAsUsedForProfileInput>;
  create?: InputMaybe<ProfileCreateWithoutBeneficiaryInviteCodeAsUsedForProfileInput>;
};

export type ProfileCreateNestedOneWithoutDependentUsersInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutDependentUsersInput>;
  create?: InputMaybe<ProfileCreateWithoutDependentUsersInput>;
};

export type ProfileCreateNestedOneWithoutExportsInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutExportsInput>;
  create?: InputMaybe<ProfileCreateWithoutExportsInput>;
};

export type ProfileCreateNestedOneWithoutScenariosBelongingToMeAsBeneficiaryInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutScenariosBelongingToMeAsBeneficiaryInput>;
  create?: InputMaybe<ProfileCreateWithoutScenariosBelongingToMeAsBeneficiaryInput>;
};

export type ProfileCreateNestedOneWithoutScenariosBelongingToMeAsMainUserInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutScenariosBelongingToMeAsMainUserInput>;
  create?: InputMaybe<ProfileCreateWithoutScenariosBelongingToMeAsMainUserInput>;
};

export type ProfileCreateNestedOneWithoutWillParticipationsInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutWillParticipationsInput>;
  create?: InputMaybe<ProfileCreateWithoutWillParticipationsInput>;
};

export type ProfileCreateNestedOneWithoutWillsAsCreatorInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutWillsAsCreatorInput>;
  create?: InputMaybe<ProfileCreateWithoutWillsAsCreatorInput>;
};

export type ProfileCreateOrConnectWithoutBeneficiaryInviteCodeAsMainUserInput = {
  create: ProfileCreateWithoutBeneficiaryInviteCodeAsMainUserInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutBeneficiaryInviteCodeAsUsedForProfileInput = {
  create: ProfileCreateWithoutBeneficiaryInviteCodeAsUsedForProfileInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutDependentUsersInput = {
  create: ProfileCreateWithoutDependentUsersInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutExportsInput = {
  create: ProfileCreateWithoutExportsInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutMainUserInput = {
  create: ProfileCreateWithoutMainUserInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutScenariosBelongingToMeAsBeneficiaryInput = {
  create: ProfileCreateWithoutScenariosBelongingToMeAsBeneficiaryInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutScenariosBelongingToMeAsMainUserInput = {
  create: ProfileCreateWithoutScenariosBelongingToMeAsMainUserInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutWillParticipationsInput = {
  create: ProfileCreateWithoutWillParticipationsInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutWillsAsCreatorInput = {
  create: ProfileCreateWithoutWillsAsCreatorInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateWithoutBeneficiaryInviteCodeAsMainUserInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutBeneficiaryInviteCodeAsUsedForProfileInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutDependentUsersInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutExportsInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutMainUserInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutScenariosBelongingToMeAsBeneficiaryInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutScenariosBelongingToMeAsMainUserInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutWillParticipationsInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willsAsCreator?: InputMaybe<WillCreateNestedManyWithoutCreatorInput>;
};

export type ProfileCreateWithoutWillsAsCreatorInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyCreateNestedOneWithoutProfileInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutMainUserProfileInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeCreateNestedManyWithoutUsedForProfileInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionCreateNestedManyWithoutProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileCreateNestedManyWithoutMainUserInput>;
  encryptedFiles?: InputMaybe<EncryptedFileCreateNestedManyWithoutMainUserInput>;
  encryptionType?: InputMaybe<EncryptionTypeCreateNestedOneWithoutProfileInput>;
  exports?: InputMaybe<ExportCreateNestedManyWithoutProfileInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsCreateNestedManyWithoutProfileInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxCreateNestedManyWithoutProfileInput>;
  mainUser?: InputMaybe<ProfileCreateNestedOneWithoutDependentUsersInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioCreateNestedManyWithoutBeneficiaryInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioCreateNestedManyWithoutMainUserInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status: AccountStatus;
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutProfileInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionCreateNestedManyWithoutProfileInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionCreateNestedManyWithoutProfileInput>;
  willParticipations?: InputMaybe<WillParticipantCreateNestedManyWithoutProfileInput>;
};

export type ProfileInput = {
  where: ProfileWhereInput;
};

export type ProfileListRelationFilter = {
  every?: InputMaybe<ProfileWhereInput>;
  none?: InputMaybe<ProfileWhereInput>;
  some?: InputMaybe<ProfileWhereInput>;
};

export type ProfileNullableRelationFilter = {
  is?: InputMaybe<ProfileWhereInput>;
  isNot?: InputMaybe<ProfileWhereInput>;
};

export type ProfileRelationFilter = {
  is?: InputMaybe<ProfileWhereInput>;
  isNot?: InputMaybe<ProfileWhereInput>;
};

export const ProfileRole = {
  Admin: 'ADMIN',
  User: 'USER'
} as const;

export type ProfileRole = typeof ProfileRole[keyof typeof ProfileRole];
export type ProfileScalarWhereInput = {
  AND?: InputMaybe<Array<ProfileScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProfileScalarWhereInput>>;
  OR?: InputMaybe<Array<ProfileScalarWhereInput>>;
  allowMobilePush?: InputMaybe<BoolNullableFilter>;
  avatarUrl?: InputMaybe<StringNullableFilter>;
  baseCurrencyId?: InputMaybe<IntFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  encryptionTypeId?: InputMaybe<IntNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  invitationLastSentTime?: InputMaybe<DateTimeNullableFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  mainUserId?: InputMaybe<IntNullableFilter>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<BoolFilter>;
  publicKey?: InputMaybe<StringNullableFilter>;
  roles?: InputMaybe<EnumProfileRoleNullableListFilter>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumAccountStatusFilter>;
  totpEnabled?: InputMaybe<BoolFilter>;
  totpSecret?: InputMaybe<StringNullableFilter>;
  twoFactorQuestionsEnabled?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumProfileTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userName?: InputMaybe<StringNullableFilter>;
};

export const ProfileType = {
  Assistant: 'ASSISTANT',
  Beneficiary: 'BENEFICIARY',
  MainUser: 'MAIN_USER'
} as const;

export type ProfileType = typeof ProfileType[keyof typeof ProfileType];
export type ProfileUpdateInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateManyMutationInput = {
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileUpdateManyWithWhereWithoutMainUserInput = {
  data: ProfileUpdateManyMutationInput;
  where: ProfileScalarWhereInput;
};

export type ProfileUpdateManyWithoutMainUserNestedInput = {
  connect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileCreateOrConnectWithoutMainUserInput>>;
  create?: InputMaybe<Array<ProfileCreateWithoutMainUserInput>>;
  createMany?: InputMaybe<ProfileCreateManyMainUserInputEnvelope>;
  delete?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<ProfileUpdateWithWhereUniqueWithoutMainUserInput>>;
  updateMany?: InputMaybe<Array<ProfileUpdateManyWithWhereWithoutMainUserInput>>;
  upsert?: InputMaybe<Array<ProfileUpsertWithWhereUniqueWithoutMainUserInput>>;
};

export type ProfileUpdateOneRequiredWithoutBeneficiaryInviteCodeAsMainUserNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutBeneficiaryInviteCodeAsMainUserInput>;
  create?: InputMaybe<ProfileCreateWithoutBeneficiaryInviteCodeAsMainUserInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutBeneficiaryInviteCodeAsMainUserInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutBeneficiaryInviteCodeAsMainUserInput>;
};

export type ProfileUpdateOneRequiredWithoutExportsNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutExportsInput>;
  create?: InputMaybe<ProfileCreateWithoutExportsInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutExportsInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutExportsInput>;
};

export type ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsBeneficiaryNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutScenariosBelongingToMeAsBeneficiaryInput>;
  create?: InputMaybe<ProfileCreateWithoutScenariosBelongingToMeAsBeneficiaryInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutScenariosBelongingToMeAsBeneficiaryInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutScenariosBelongingToMeAsBeneficiaryInput>;
};

export type ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsMainUserNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutScenariosBelongingToMeAsMainUserInput>;
  create?: InputMaybe<ProfileCreateWithoutScenariosBelongingToMeAsMainUserInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutScenariosBelongingToMeAsMainUserInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutScenariosBelongingToMeAsMainUserInput>;
};

export type ProfileUpdateOneRequiredWithoutWillParticipationsNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutWillParticipationsInput>;
  create?: InputMaybe<ProfileCreateWithoutWillParticipationsInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutWillParticipationsInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutWillParticipationsInput>;
};

export type ProfileUpdateOneRequiredWithoutWillsAsCreatorNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutWillsAsCreatorInput>;
  create?: InputMaybe<ProfileCreateWithoutWillsAsCreatorInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutWillsAsCreatorInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutWillsAsCreatorInput>;
};

export type ProfileUpdateOneWithoutBeneficiaryInviteCodeAsUsedForProfileNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutBeneficiaryInviteCodeAsUsedForProfileInput>;
  create?: InputMaybe<ProfileCreateWithoutBeneficiaryInviteCodeAsUsedForProfileInput>;
  delete?: InputMaybe<ProfileWhereInput>;
  disconnect?: InputMaybe<ProfileWhereInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutBeneficiaryInviteCodeAsUsedForProfileInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutBeneficiaryInviteCodeAsUsedForProfileInput>;
};

export type ProfileUpdateOneWithoutDependentUsersNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutDependentUsersInput>;
  create?: InputMaybe<ProfileCreateWithoutDependentUsersInput>;
  delete?: InputMaybe<ProfileWhereInput>;
  disconnect?: InputMaybe<ProfileWhereInput>;
  update?: InputMaybe<ProfileUpdateToOneWithWhereWithoutDependentUsersInput>;
  upsert?: InputMaybe<ProfileUpsertWithoutDependentUsersInput>;
};

export type ProfileUpdateToOneWithWhereWithoutBeneficiaryInviteCodeAsMainUserInput = {
  data: ProfileUpdateWithoutBeneficiaryInviteCodeAsMainUserInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateToOneWithWhereWithoutBeneficiaryInviteCodeAsUsedForProfileInput = {
  data: ProfileUpdateWithoutBeneficiaryInviteCodeAsUsedForProfileInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateToOneWithWhereWithoutDependentUsersInput = {
  data: ProfileUpdateWithoutDependentUsersInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateToOneWithWhereWithoutExportsInput = {
  data: ProfileUpdateWithoutExportsInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateToOneWithWhereWithoutScenariosBelongingToMeAsBeneficiaryInput = {
  data: ProfileUpdateWithoutScenariosBelongingToMeAsBeneficiaryInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateToOneWithWhereWithoutScenariosBelongingToMeAsMainUserInput = {
  data: ProfileUpdateWithoutScenariosBelongingToMeAsMainUserInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateToOneWithWhereWithoutWillParticipationsInput = {
  data: ProfileUpdateWithoutWillParticipationsInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateToOneWithWhereWithoutWillsAsCreatorInput = {
  data: ProfileUpdateWithoutWillsAsCreatorInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateWithWhereUniqueWithoutMainUserInput = {
  data: ProfileUpdateWithoutMainUserInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileUpdateWithoutBeneficiaryInviteCodeAsMainUserInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutBeneficiaryInviteCodeAsUsedForProfileInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutDependentUsersInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutExportsInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutMainUserInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutScenariosBelongingToMeAsBeneficiaryInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutScenariosBelongingToMeAsMainUserInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutWillParticipationsInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willsAsCreator?: InputMaybe<WillUpdateManyWithoutCreatorNestedInput>;
};

export type ProfileUpdateWithoutWillsAsCreatorInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutProfileNestedInput>;
  allowMobilePush?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProfileNestedInput>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutMainUserProfileNestedInput>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeUpdateManyWithoutUsedForProfileNestedInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<CollectionUpdateManyWithoutProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependentUsers?: InputMaybe<ProfileUpdateManyWithoutMainUserNestedInput>;
  encryptedFiles?: InputMaybe<EncryptedFileUpdateManyWithoutMainUserNestedInput>;
  encryptionType?: InputMaybe<EncryptionTypeUpdateOneWithoutProfileNestedInput>;
  exports?: InputMaybe<ExportUpdateManyWithoutProfileNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsUpdateManyWithoutProfileNestedInput>;
  invitationLastSentTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailboxes?: InputMaybe<MailboxUpdateManyWithoutProfileNestedInput>;
  mainUser?: InputMaybe<ProfileUpdateOneWithoutDependentUsersNestedInput>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<ProfileRole>>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioUpdateManyWithoutBeneficiaryNestedInput>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioUpdateManyWithoutMainUserNestedInput>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AccountStatus>;
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutProfileNestedInput>;
  totpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionUpdateManyWithoutProfileNestedInput>;
  twoFactorQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionUpdateManyWithoutProfileNestedInput>;
  willParticipations?: InputMaybe<WillParticipantUpdateManyWithoutProfileNestedInput>;
};

export type ProfileUpsertWithWhereUniqueWithoutMainUserInput = {
  create: ProfileCreateWithoutMainUserInput;
  update: ProfileUpdateWithoutMainUserInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileUpsertWithoutBeneficiaryInviteCodeAsMainUserInput = {
  create: ProfileCreateWithoutBeneficiaryInviteCodeAsMainUserInput;
  update: ProfileUpdateWithoutBeneficiaryInviteCodeAsMainUserInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpsertWithoutBeneficiaryInviteCodeAsUsedForProfileInput = {
  create: ProfileCreateWithoutBeneficiaryInviteCodeAsUsedForProfileInput;
  update: ProfileUpdateWithoutBeneficiaryInviteCodeAsUsedForProfileInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpsertWithoutDependentUsersInput = {
  create: ProfileCreateWithoutDependentUsersInput;
  update: ProfileUpdateWithoutDependentUsersInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpsertWithoutExportsInput = {
  create: ProfileCreateWithoutExportsInput;
  update: ProfileUpdateWithoutExportsInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpsertWithoutScenariosBelongingToMeAsBeneficiaryInput = {
  create: ProfileCreateWithoutScenariosBelongingToMeAsBeneficiaryInput;
  update: ProfileUpdateWithoutScenariosBelongingToMeAsBeneficiaryInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpsertWithoutScenariosBelongingToMeAsMainUserInput = {
  create: ProfileCreateWithoutScenariosBelongingToMeAsMainUserInput;
  update: ProfileUpdateWithoutScenariosBelongingToMeAsMainUserInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpsertWithoutWillParticipationsInput = {
  create: ProfileCreateWithoutWillParticipationsInput;
  update: ProfileUpdateWithoutWillParticipationsInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpsertWithoutWillsAsCreatorInput = {
  create: ProfileCreateWithoutWillsAsCreatorInput;
  update: ProfileUpdateWithoutWillsAsCreatorInput;
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileWhereInput = {
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  accounts?: InputMaybe<AccountListRelationFilter>;
  allowMobilePush?: InputMaybe<BoolNullableFilter>;
  avatarUrl?: InputMaybe<StringNullableFilter>;
  baseCurrency?: InputMaybe<CurrencyRelationFilter>;
  baseCurrencyId?: InputMaybe<IntFilter>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeListRelationFilter>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeListRelationFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  collections?: InputMaybe<CollectionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dependentUsers?: InputMaybe<ProfileListRelationFilter>;
  encryptedFiles?: InputMaybe<EncryptedFileListRelationFilter>;
  encryptionType?: InputMaybe<EncryptionTypeNullableRelationFilter>;
  encryptionTypeId?: InputMaybe<IntNullableFilter>;
  exports?: InputMaybe<ExportListRelationFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  hubSettings?: InputMaybe<HubSettingsListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  invitationLastSentTime?: InputMaybe<DateTimeNullableFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  mailboxes?: InputMaybe<MailboxListRelationFilter>;
  mainUser?: InputMaybe<ProfileNullableRelationFilter>;
  mainUserId?: InputMaybe<IntNullableFilter>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<BoolFilter>;
  publicKey?: InputMaybe<StringNullableFilter>;
  roles?: InputMaybe<EnumProfileRoleNullableListFilter>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioListRelationFilter>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioListRelationFilter>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumAccountStatusFilter>;
  subscriptions?: InputMaybe<SubscriptionListRelationFilter>;
  totpEnabled?: InputMaybe<BoolFilter>;
  totpSecret?: InputMaybe<StringNullableFilter>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionListRelationFilter>;
  twoFactorQuestionsEnabled?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumProfileTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userName?: InputMaybe<StringNullableFilter>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionListRelationFilter>;
  willParticipations?: InputMaybe<WillParticipantListRelationFilter>;
  willsAsCreator?: InputMaybe<WillListRelationFilter>;
};

export type ProfileWhereUniqueInput = {
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  accounts?: InputMaybe<AccountListRelationFilter>;
  allowMobilePush?: InputMaybe<BoolNullableFilter>;
  avatarUrl?: InputMaybe<StringNullableFilter>;
  baseCurrency?: InputMaybe<CurrencyRelationFilter>;
  baseCurrencyId?: InputMaybe<IntFilter>;
  beneficiaryInviteCodeAsMainUser?: InputMaybe<BeneficiaryInviteCodeListRelationFilter>;
  beneficiaryInviteCodeAsUsedForProfile?: InputMaybe<BeneficiaryInviteCodeListRelationFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  collections?: InputMaybe<CollectionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dependentUsers?: InputMaybe<ProfileListRelationFilter>;
  encryptedFiles?: InputMaybe<EncryptedFileListRelationFilter>;
  encryptionType?: InputMaybe<EncryptionTypeNullableRelationFilter>;
  encryptionTypeId?: InputMaybe<IntNullableFilter>;
  exports?: InputMaybe<ExportListRelationFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  hubSettings?: InputMaybe<HubSettingsListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invitationLastSentTime?: InputMaybe<DateTimeNullableFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  mailboxes?: InputMaybe<MailboxListRelationFilter>;
  mainUser?: InputMaybe<ProfileNullableRelationFilter>;
  mainUserId?: InputMaybe<IntNullableFilter>;
  ocrSuppressLetsTryConfirmation?: InputMaybe<BoolFilter>;
  publicKey?: InputMaybe<StringNullableFilter>;
  roles?: InputMaybe<EnumProfileRoleNullableListFilter>;
  scenariosBelongingToMeAsBeneficiary?: InputMaybe<ScenarioListRelationFilter>;
  scenariosBelongingToMeAsMainUser?: InputMaybe<ScenarioListRelationFilter>;
  soweAppendixSuppressCancelConfirmation?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumAccountStatusFilter>;
  subscriptions?: InputMaybe<SubscriptionListRelationFilter>;
  totpEnabled?: InputMaybe<BoolFilter>;
  totpSecret?: InputMaybe<StringNullableFilter>;
  twoFactorQuestions?: InputMaybe<TwoFactorQuestionListRelationFilter>;
  twoFactorQuestionsEnabled?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumProfileTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userName?: InputMaybe<StringNullableFilter>;
  webPushSubscriptions?: InputMaybe<WebPushSubscriptionListRelationFilter>;
  willParticipations?: InputMaybe<WillParticipantListRelationFilter>;
  willsAsCreator?: InputMaybe<WillListRelationFilter>;
};

export const Provider = {
  Aws: 'AWS',
  Alibaba: 'Alibaba',
  Yandex: 'Yandex'
} as const;

export type Provider = typeof Provider[keyof typeof Provider];
export type Query = {
  __typename?: 'Query';
  /** Генерация двух факторных вопросов */
  RandomTwoFactorQuestion: RandomTwoFactorQuestion;
  beneficiaryAnonymousPropForEmail: Array<BeneficiaryAnonymousPropForEmail>;
  /** Получить бенефециару url регистрации, доступно пользователю с ролью ADMIN для отладки */
  beneficiaryRegistrationUrl: Scalars['String']['output'];
  /** Получить курс валют */
  currencyRates: Array<CurrencyRate>;
  /** Получить данные по текущим хабам пользователя */
  currentExportRequest?: Maybe<Array<SafeExport>>;
  /** Возвращает текущую ссесию пользователя и аккаунт пользователя */
  currentSession: AccountSession;
  /** Получить  информацию для отладки */
  debug: Scalars['JSON']['output'];
  /** Delete region name by id */
  deleteRegionNameByIde: Scalars['Boolean']['output'];
  echoQuery: Scalars['String']['output'];
  /** Проверка нахождения почты в белом списке */
  existInWhitelist: Scalars['Boolean']['output'];
  /** Получить бенефициаром все сценарии, но не со всеми полями, где он получатель */
  familyMemberScenarios: Array<FamilyMemberScenarioGraphResponse>;
  /** Get a form by id */
  form: Form;
  /** Get all forms for a given entity type */
  forms: Array<Form>;
  /** Генерация totp secret */
  generateTotpSecret: Scalars['String']['output'];
  /** Возвращает статусы доступа в приложение по email пользователя */
  getAccessStatuses: AccessStatusesResponse;
  /** Получить настройки всех хабов пользователей */
  getAllHubSettings: Array<HubSettingsResponse>;
  /** Get assistants */
  getAssistants: Array<Profile>;
  /** Get available regions */
  getAvailableRegions: Array<RegionName>;
  /** Get beneficiaries */
  getBeneficiaries: Array<Profile>;
  /** Получить домен почтового ящика */
  getDomainMailBox: Scalars['String']['output'];
  /** Получить файл из хранилища */
  getFile: Scalars['String']['output'];
  /** @deprecated Получить файл как администратор */
  getFileAsAdmin: Scalars['String']['output'];
  /** Получить настройки хабов пользователя */
  getHubSettings: Array<HubSettingsResponse>;
  /** Получить настройки хаба по url адресу хаба */
  getHubSettingsbyUrl: HubSettingsResponse;
  /** Get region name by code */
  getRegionNameByCode: RegionName;
  /** Get region name by id */
  getRegionNameById: RegionName;
  /** Get current subscription status from Personal Account */
  getSubscriptionStatus: SubscriptionStatusResponseGGl;
  /** Получить все подписки пользователя */
  getSubscriptions: Array<SubscriptionEntity>;
  /** Возвращает zendesk token */
  getZendeskToken: GetZendeskToken;
  /** Проверка на наличие профиля бенефициара */
  isBeneficiaryProfileExists: Scalars['Boolean']['output'];
  /** Проверка занят ли email аккаунт */
  isEmailAccountTaken: Scalars['Boolean']['output'];
  /** Проверка на наличие уже зарегестрированного аккаунта на данную почту */
  isEmailExists: Scalars['Boolean']['output'];
  /** Получить почтовый ящик пользователя */
  mailboxes: GetMailBoxesResponseGGl;
  nextOwnersPropsForEmail: Array<NextOwnerPropForEmail>;
  /** Получить единоразовые коды, доступно пользователю с ролью ADMIN для отладки */
  oneTimeCodes: OneTimeCodesResponse;
  /** Получить профиль */
  profile: Profile;
  /** Получить коллекцию по имени */
  pullCollection?: Maybe<Collection>;
  /** Получить все коллекции */
  pullCollections: Array<Collection>;
  /** Получить сценарий */
  scenario?: Maybe<ScenarioGraphResponse>;
  /** Получить все сценарии */
  scenarios: Array<ScenarioGraphResponse>;
  /** Отправка уведомления посредством sms или электронной почтой */
  sendNotification: Scalars['Boolean']['output'];
  /** Тест отправки уведомлений */
  testBroadcast: Scalars['Boolean']['output'];
  /** Тест перевода для отладки */
  testTranslation: Scalars['String']['output'];
  /** Проверка кода верификации высланного на указанный email */
  verifyEmailCode: Scalars['Boolean']['output'];
  /** Проверка кода верификации из sms собщения отправленного на указанный номер телефона */
  verifySmsCode: Scalars['Boolean']['output'];
  /** Верификация ответов для  вопросов из двухфакторной аутентификации */
  verifyTwoFactorQuestion: Scalars['Boolean']['output'];
  /** Возвращает аккаунт по authorization token  */
  whoami: Account;
};


export type QueryRandomTwoFactorQuestionArgs = {
  email: Scalars['String']['input'];
};


export type QueryBeneficiaryRegistrationUrlArgs = {
  beneficiaryEmail: Scalars['String']['input'];
};


export type QueryDeleteRegionNameByIdeArgs = {
  id: Scalars['Float']['input'];
};


export type QueryEchoQueryArgs = {
  text: Scalars['String']['input'];
};


export type QueryExistInWhitelistArgs = {
  email: Scalars['String']['input'];
};


export type QueryFormArgs = {
  id: Scalars['Float']['input'];
};


export type QueryFormsArgs = {
  entityType: Scalars['String']['input'];
};


export type QueryGenerateTotpSecretArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAccessStatusesArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetAssistantsArgs = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileArgs = {
  filename: Scalars['String']['input'];
};


export type QueryGetFileAsAdminArgs = {
  filename: Scalars['String']['input'];
};


export type QueryGetHubSettingsbyUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryGetRegionNameByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetRegionNameByIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryIsBeneficiaryProfileExistsArgs = {
  email: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
};


export type QueryIsEmailAccountTakenArgs = {
  search: Scalars['String']['input'];
};


export type QueryIsEmailExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryOneTimeCodesArgs = {
  emailOrPhoneNumber: Scalars['String']['input'];
};


export type QueryProfileArgs = {
  input: ProfileInput;
};


export type QueryPullCollectionArgs = {
  name: Scalars['String']['input'];
};


export type QueryScenarioArgs = {
  scenarioId: Scalars['String']['input'];
};


export type QuerySendNotificationArgs = {
  deliveryMethod: DeliveryMethod;
  emailData?: InputMaybe<EmailParametersInput>;
  smsData?: InputMaybe<SmsParametersInput>;
};


export type QueryTestTranslationArgs = {
  username: Scalars['String']['input'];
};


export type QueryVerifyEmailCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type QueryVerifySmsCodeArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type QueryVerifyTwoFactorQuestionArgs = {
  email: Scalars['String']['input'];
  emailCode: Scalars['String']['input'];
  twoFactorQuestionAnswer: Scalars['String']['input'];
  twoFactorQuestionId: Scalars['Int']['input'];
};

export const QueryMode = {
  Default: 'default',
  Insensitive: 'insensitive'
} as const;

export type QueryMode = typeof QueryMode[keyof typeof QueryMode];
export type RandomTwoFactorQuestion = {
  __typename?: 'RandomTwoFactorQuestion';
  id: Scalars['Float']['output'];
  question: Scalars['String']['output'];
};

export type RegionName = {
  __typename?: 'RegionName';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  regionCode: Scalars['String']['output'];
  regionName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  meta?: InputMaybe<MetaInput>;
  password: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  schemaVersion?: InputMaybe<Scalars['Float']['input']>;
  twoFactorQuestions: Array<TwoFactorQuestionPlainObject>;
};

export type RemoveItemGqlInput = {
  /** Example collection name */
  collectionName: Scalars['String']['input'];
  /** DTO ID of the item to remove */
  dtoId: Scalars['String']['input'];
  /** Platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Current signature of the item */
  signature: Scalars['String']['input'];
};

export type RemoveItemGqlPayload = {
  __typename?: 'RemoveItemGqlPayload';
  /** Example collection name */
  collectionName: Scalars['String']['output'];
  /** DTO ID of the removed item */
  dtoId: Scalars['String']['output'];
};

export type RemoveItemsGqlInput = {
  /** Example collection name */
  collectionName: Scalars['String']['input'];
  /** List of DTO IDs with their signatures to be removed */
  items: Array<Scalars['JSON']['input']>;
  /** Platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveItemsGqlPayload = {
  __typename?: 'RemoveItemsGqlPayload';
  /** Example collection name */
  collectionName: Scalars['String']['output'];
  /** Latest collection version */
  collectionVersion: Scalars['Float']['output'];
  /** List of successfully removed DTO IDs */
  removedDtoIds: Array<Scalars['String']['output']>;
};

export type ResetPasswordInput = {
  email: Scalars['String']['input'];
  emailCode: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type SafeExport = {
  __typename?: 'SafeExport';
  createdAt: Scalars['DateTime']['output'];
  hubType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type Scenario = {
  __typename?: 'Scenario';
  _count: ScenarioCount;
  beneficiary: Profile;
  beneficiaryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentNotificationValue: Scalars['BigInt']['output'];
  dtoIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isViewed: Scalars['Boolean']['output'];
  mainUser: Profile;
  mainUserId: Scalars['Int']['output'];
  mode: ScenarioMode;
  notificationPeriod: Scalars['BigInt']['output'];
  notificationTime: Scalars['DateTime']['output'];
  notificationValue: Scalars['BigInt']['output'];
  status: ScenarioStatus;
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['BigInt']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wills?: Maybe<Array<Will>>;
};

export type ScenarioCount = {
  __typename?: 'ScenarioCount';
  wills: Scalars['Int']['output'];
};

export type ScenarioCreateManyBeneficiaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue: Scalars['BigInt']['input'];
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUserId: Scalars['Int']['input'];
  mode: ScenarioMode;
  notificationPeriod: Scalars['BigInt']['input'];
  notificationTime: Scalars['DateTime']['input'];
  notificationValue: Scalars['BigInt']['input'];
  status?: InputMaybe<ScenarioStatus>;
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioCreateManyBeneficiaryInputEnvelope = {
  data: Array<ScenarioCreateManyBeneficiaryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScenarioCreateManyMainUserInput = {
  beneficiaryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue: Scalars['BigInt']['input'];
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mode: ScenarioMode;
  notificationPeriod: Scalars['BigInt']['input'];
  notificationTime: Scalars['DateTime']['input'];
  notificationValue: Scalars['BigInt']['input'];
  status?: InputMaybe<ScenarioStatus>;
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioCreateManyMainUserInputEnvelope = {
  data: Array<ScenarioCreateManyMainUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScenarioCreateNestedManyWithoutBeneficiaryInput = {
  connect?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ScenarioCreateOrConnectWithoutBeneficiaryInput>>;
  create?: InputMaybe<Array<ScenarioCreateWithoutBeneficiaryInput>>;
  createMany?: InputMaybe<ScenarioCreateManyBeneficiaryInputEnvelope>;
};

export type ScenarioCreateNestedManyWithoutMainUserInput = {
  connect?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ScenarioCreateOrConnectWithoutMainUserInput>>;
  create?: InputMaybe<Array<ScenarioCreateWithoutMainUserInput>>;
  createMany?: InputMaybe<ScenarioCreateManyMainUserInputEnvelope>;
};

export type ScenarioCreateNestedOneWithoutWillsInput = {
  connect?: InputMaybe<ScenarioWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ScenarioCreateOrConnectWithoutWillsInput>;
  create?: InputMaybe<ScenarioCreateWithoutWillsInput>;
};

export type ScenarioCreateOrConnectWithoutBeneficiaryInput = {
  create: ScenarioCreateWithoutBeneficiaryInput;
  where: ScenarioWhereUniqueInput;
};

export type ScenarioCreateOrConnectWithoutMainUserInput = {
  create: ScenarioCreateWithoutMainUserInput;
  where: ScenarioWhereUniqueInput;
};

export type ScenarioCreateOrConnectWithoutWillsInput = {
  create: ScenarioCreateWithoutWillsInput;
  where: ScenarioWhereUniqueInput;
};

export type ScenarioCreateWithoutBeneficiaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue: Scalars['BigInt']['input'];
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUser: ProfileCreateNestedOneWithoutScenariosBelongingToMeAsMainUserInput;
  mode: ScenarioMode;
  notificationPeriod: Scalars['BigInt']['input'];
  notificationTime: Scalars['DateTime']['input'];
  notificationValue: Scalars['BigInt']['input'];
  status?: InputMaybe<ScenarioStatus>;
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  wills?: InputMaybe<WillCreateNestedManyWithoutScenarioInput>;
};

export type ScenarioCreateWithoutMainUserInput = {
  beneficiary: ProfileCreateNestedOneWithoutScenariosBelongingToMeAsBeneficiaryInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue: Scalars['BigInt']['input'];
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mode: ScenarioMode;
  notificationPeriod: Scalars['BigInt']['input'];
  notificationTime: Scalars['DateTime']['input'];
  notificationValue: Scalars['BigInt']['input'];
  status?: InputMaybe<ScenarioStatus>;
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  wills?: InputMaybe<WillCreateNestedManyWithoutScenarioInput>;
};

export type ScenarioCreateWithoutWillsInput = {
  beneficiary: ProfileCreateNestedOneWithoutScenariosBelongingToMeAsBeneficiaryInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue: Scalars['BigInt']['input'];
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUser: ProfileCreateNestedOneWithoutScenariosBelongingToMeAsMainUserInput;
  mode: ScenarioMode;
  notificationPeriod: Scalars['BigInt']['input'];
  notificationTime: Scalars['DateTime']['input'];
  notificationValue: Scalars['BigInt']['input'];
  status?: InputMaybe<ScenarioStatus>;
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioGraphResponse = {
  __typename?: 'ScenarioGraphResponse';
  beneficiary?: Maybe<Profile>;
  beneficiaryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentNotificationValue: Scalars['String']['output'];
  dtoIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isViewed: Scalars['Boolean']['output'];
  mainUser?: Maybe<Profile>;
  mainUserId: Scalars['Int']['output'];
  mode: ScenarioMode;
  notificationPeriod: Scalars['String']['output'];
  notificationTime: Scalars['DateTime']['output'];
  notificationValue: Scalars['String']['output'];
  status: NewScenarioStatus;
  triggerType: ScenarioTriggerType;
  triggerValue: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScenarioListRelationFilter = {
  every?: InputMaybe<ScenarioWhereInput>;
  none?: InputMaybe<ScenarioWhereInput>;
  some?: InputMaybe<ScenarioWhereInput>;
};

export const ScenarioMode = {
  Normal: 'NORMAL',
  Test: 'TEST'
} as const;

export type ScenarioMode = typeof ScenarioMode[keyof typeof ScenarioMode];
export type ScenarioNullableRelationFilter = {
  is?: InputMaybe<ScenarioWhereInput>;
  isNot?: InputMaybe<ScenarioWhereInput>;
};

export type ScenarioScalarWhereInput = {
  AND?: InputMaybe<Array<ScenarioScalarWhereInput>>;
  NOT?: InputMaybe<Array<ScenarioScalarWhereInput>>;
  OR?: InputMaybe<Array<ScenarioScalarWhereInput>>;
  beneficiaryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentNotificationValue?: InputMaybe<BigIntFilter>;
  dtoIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  isViewed?: InputMaybe<BoolFilter>;
  mainUserId?: InputMaybe<IntFilter>;
  mode?: InputMaybe<EnumScenarioModeFilter>;
  notificationPeriod?: InputMaybe<BigIntFilter>;
  notificationTime?: InputMaybe<DateTimeFilter>;
  notificationValue?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<EnumScenarioStatusFilter>;
  triggerType?: InputMaybe<EnumScenarioTriggerTypeFilter>;
  triggerValue?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export const ScenarioStatus = {
  Cancelled: 'CANCELLED',
  Done: 'DONE',
  Idle: 'IDLE',
  InProgress: 'IN_PROGRESS',
  NotActive: 'NOT_ACTIVE',
  OnHold: 'ON_HOLD'
} as const;

export type ScenarioStatus = typeof ScenarioStatus[keyof typeof ScenarioStatus];
export const ScenarioTriggerType = {
  AfterDatetime: 'AFTER_DATETIME',
  AfterInactivity: 'AFTER_INACTIVITY'
} as const;

export type ScenarioTriggerType = typeof ScenarioTriggerType[keyof typeof ScenarioTriggerType];
export type ScenarioUpdateInput = {
  beneficiary?: InputMaybe<ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsBeneficiaryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUser?: InputMaybe<ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsMainUserNestedInput>;
  mode?: InputMaybe<ScenarioMode>;
  notificationPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  notificationTime?: InputMaybe<Scalars['DateTime']['input']>;
  notificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<ScenarioStatus>;
  triggerType?: InputMaybe<ScenarioTriggerType>;
  triggerValue?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  wills?: InputMaybe<WillUpdateManyWithoutScenarioNestedInput>;
};

export type ScenarioUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<ScenarioMode>;
  notificationPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  notificationTime?: InputMaybe<Scalars['DateTime']['input']>;
  notificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<ScenarioStatus>;
  triggerType?: InputMaybe<ScenarioTriggerType>;
  triggerValue?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: ScenarioUpdateManyMutationInput;
  where: ScenarioScalarWhereInput;
};

export type ScenarioUpdateManyWithWhereWithoutMainUserInput = {
  data: ScenarioUpdateManyMutationInput;
  where: ScenarioScalarWhereInput;
};

export type ScenarioUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ScenarioCreateOrConnectWithoutBeneficiaryInput>>;
  create?: InputMaybe<Array<ScenarioCreateWithoutBeneficiaryInput>>;
  createMany?: InputMaybe<ScenarioCreateManyBeneficiaryInputEnvelope>;
  delete?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ScenarioScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  set?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  update?: InputMaybe<Array<ScenarioUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: InputMaybe<Array<ScenarioUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: InputMaybe<Array<ScenarioUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type ScenarioUpdateManyWithoutMainUserNestedInput = {
  connect?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ScenarioCreateOrConnectWithoutMainUserInput>>;
  create?: InputMaybe<Array<ScenarioCreateWithoutMainUserInput>>;
  createMany?: InputMaybe<ScenarioCreateManyMainUserInputEnvelope>;
  delete?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ScenarioScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  set?: InputMaybe<Array<ScenarioWhereUniqueInput>>;
  update?: InputMaybe<Array<ScenarioUpdateWithWhereUniqueWithoutMainUserInput>>;
  updateMany?: InputMaybe<Array<ScenarioUpdateManyWithWhereWithoutMainUserInput>>;
  upsert?: InputMaybe<Array<ScenarioUpsertWithWhereUniqueWithoutMainUserInput>>;
};

export type ScenarioUpdateOneWithoutWillsNestedInput = {
  connect?: InputMaybe<ScenarioWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ScenarioCreateOrConnectWithoutWillsInput>;
  create?: InputMaybe<ScenarioCreateWithoutWillsInput>;
  delete?: InputMaybe<ScenarioWhereInput>;
  disconnect?: InputMaybe<ScenarioWhereInput>;
  update?: InputMaybe<ScenarioUpdateToOneWithWhereWithoutWillsInput>;
  upsert?: InputMaybe<ScenarioUpsertWithoutWillsInput>;
};

export type ScenarioUpdateToOneWithWhereWithoutWillsInput = {
  data: ScenarioUpdateWithoutWillsInput;
  where?: InputMaybe<ScenarioWhereInput>;
};

export type ScenarioUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: ScenarioUpdateWithoutBeneficiaryInput;
  where: ScenarioWhereUniqueInput;
};

export type ScenarioUpdateWithWhereUniqueWithoutMainUserInput = {
  data: ScenarioUpdateWithoutMainUserInput;
  where: ScenarioWhereUniqueInput;
};

export type ScenarioUpdateWithoutBeneficiaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUser?: InputMaybe<ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsMainUserNestedInput>;
  mode?: InputMaybe<ScenarioMode>;
  notificationPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  notificationTime?: InputMaybe<Scalars['DateTime']['input']>;
  notificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<ScenarioStatus>;
  triggerType?: InputMaybe<ScenarioTriggerType>;
  triggerValue?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  wills?: InputMaybe<WillUpdateManyWithoutScenarioNestedInput>;
};

export type ScenarioUpdateWithoutMainUserInput = {
  beneficiary?: InputMaybe<ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsBeneficiaryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<ScenarioMode>;
  notificationPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  notificationTime?: InputMaybe<Scalars['DateTime']['input']>;
  notificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<ScenarioStatus>;
  triggerType?: InputMaybe<ScenarioTriggerType>;
  triggerValue?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  wills?: InputMaybe<WillUpdateManyWithoutScenarioNestedInput>;
};

export type ScenarioUpdateWithoutWillsInput = {
  beneficiary?: InputMaybe<ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsBeneficiaryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentNotificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  dtoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  mainUser?: InputMaybe<ProfileUpdateOneRequiredWithoutScenariosBelongingToMeAsMainUserNestedInput>;
  mode?: InputMaybe<ScenarioMode>;
  notificationPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  notificationTime?: InputMaybe<Scalars['DateTime']['input']>;
  notificationValue?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<ScenarioStatus>;
  triggerType?: InputMaybe<ScenarioTriggerType>;
  triggerValue?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: ScenarioCreateWithoutBeneficiaryInput;
  update: ScenarioUpdateWithoutBeneficiaryInput;
  where: ScenarioWhereUniqueInput;
};

export type ScenarioUpsertWithWhereUniqueWithoutMainUserInput = {
  create: ScenarioCreateWithoutMainUserInput;
  update: ScenarioUpdateWithoutMainUserInput;
  where: ScenarioWhereUniqueInput;
};

export type ScenarioUpsertWithoutWillsInput = {
  create: ScenarioCreateWithoutWillsInput;
  update: ScenarioUpdateWithoutWillsInput;
  where?: InputMaybe<ScenarioWhereInput>;
};

export type ScenarioWhereInput = {
  AND?: InputMaybe<Array<ScenarioWhereInput>>;
  NOT?: InputMaybe<Array<ScenarioWhereInput>>;
  OR?: InputMaybe<Array<ScenarioWhereInput>>;
  beneficiary?: InputMaybe<ProfileRelationFilter>;
  beneficiaryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentNotificationValue?: InputMaybe<BigIntFilter>;
  dtoIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  isViewed?: InputMaybe<BoolFilter>;
  mainUser?: InputMaybe<ProfileRelationFilter>;
  mainUserId?: InputMaybe<IntFilter>;
  mode?: InputMaybe<EnumScenarioModeFilter>;
  notificationPeriod?: InputMaybe<BigIntFilter>;
  notificationTime?: InputMaybe<DateTimeFilter>;
  notificationValue?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<EnumScenarioStatusFilter>;
  triggerType?: InputMaybe<EnumScenarioTriggerTypeFilter>;
  triggerValue?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  wills?: InputMaybe<WillListRelationFilter>;
};

export type ScenarioWhereUniqueInput = {
  AND?: InputMaybe<Array<ScenarioWhereInput>>;
  NOT?: InputMaybe<Array<ScenarioWhereInput>>;
  OR?: InputMaybe<Array<ScenarioWhereInput>>;
  beneficiary?: InputMaybe<ProfileRelationFilter>;
  beneficiaryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentNotificationValue?: InputMaybe<BigIntFilter>;
  dtoIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isViewed?: InputMaybe<BoolFilter>;
  mainUser?: InputMaybe<ProfileRelationFilter>;
  mainUserId?: InputMaybe<IntFilter>;
  mode?: InputMaybe<EnumScenarioModeFilter>;
  notificationPeriod?: InputMaybe<BigIntFilter>;
  notificationTime?: InputMaybe<DateTimeFilter>;
  notificationValue?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<EnumScenarioStatusFilter>;
  triggerType?: InputMaybe<EnumScenarioTriggerTypeFilter>;
  triggerValue?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  wills?: InputMaybe<WillListRelationFilter>;
};

export type SmsParametersInput = {
  number: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionActivationHistoryItem = {
  __typename?: 'SubscriptionActivationHistoryItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isTrial: Scalars['Boolean']['output'];
  subscription: SubscriptionEntity;
  subscriptionId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SubscriptionActivationHistoryItemCreateManySubscriptionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTrial: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionActivationHistoryItemCreateManySubscriptionInputEnvelope = {
  data: Array<SubscriptionActivationHistoryItemCreateManySubscriptionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionActivationHistoryItemCreateNestedManyWithoutSubscriptionInput = {
  connect?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubscriptionActivationHistoryItemCreateOrConnectWithoutSubscriptionInput>>;
  create?: InputMaybe<Array<SubscriptionActivationHistoryItemCreateWithoutSubscriptionInput>>;
  createMany?: InputMaybe<SubscriptionActivationHistoryItemCreateManySubscriptionInputEnvelope>;
};

export type SubscriptionActivationHistoryItemCreateOrConnectWithoutSubscriptionInput = {
  create: SubscriptionActivationHistoryItemCreateWithoutSubscriptionInput;
  where: SubscriptionActivationHistoryItemWhereUniqueInput;
};

export type SubscriptionActivationHistoryItemCreateWithoutSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isTrial: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionActivationHistoryItemListRelationFilter = {
  every?: InputMaybe<SubscriptionActivationHistoryItemWhereInput>;
  none?: InputMaybe<SubscriptionActivationHistoryItemWhereInput>;
  some?: InputMaybe<SubscriptionActivationHistoryItemWhereInput>;
};

export type SubscriptionActivationHistoryItemScalarWhereInput = {
  AND?: InputMaybe<Array<SubscriptionActivationHistoryItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<SubscriptionActivationHistoryItemScalarWhereInput>>;
  OR?: InputMaybe<Array<SubscriptionActivationHistoryItemScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isTrial?: InputMaybe<BoolFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubscriptionActivationHistoryItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionActivationHistoryItemUpdateManyWithWhereWithoutSubscriptionInput = {
  data: SubscriptionActivationHistoryItemUpdateManyMutationInput;
  where: SubscriptionActivationHistoryItemScalarWhereInput;
};

export type SubscriptionActivationHistoryItemUpdateManyWithoutSubscriptionNestedInput = {
  connect?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubscriptionActivationHistoryItemCreateOrConnectWithoutSubscriptionInput>>;
  create?: InputMaybe<Array<SubscriptionActivationHistoryItemCreateWithoutSubscriptionInput>>;
  createMany?: InputMaybe<SubscriptionActivationHistoryItemCreateManySubscriptionInputEnvelope>;
  delete?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubscriptionActivationHistoryItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereUniqueInput>>;
  set?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereUniqueInput>>;
  update?: InputMaybe<Array<SubscriptionActivationHistoryItemUpdateWithWhereUniqueWithoutSubscriptionInput>>;
  updateMany?: InputMaybe<Array<SubscriptionActivationHistoryItemUpdateManyWithWhereWithoutSubscriptionInput>>;
  upsert?: InputMaybe<Array<SubscriptionActivationHistoryItemUpsertWithWhereUniqueWithoutSubscriptionInput>>;
};

export type SubscriptionActivationHistoryItemUpdateWithWhereUniqueWithoutSubscriptionInput = {
  data: SubscriptionActivationHistoryItemUpdateWithoutSubscriptionInput;
  where: SubscriptionActivationHistoryItemWhereUniqueInput;
};

export type SubscriptionActivationHistoryItemUpdateWithoutSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionActivationHistoryItemUpsertWithWhereUniqueWithoutSubscriptionInput = {
  create: SubscriptionActivationHistoryItemCreateWithoutSubscriptionInput;
  update: SubscriptionActivationHistoryItemUpdateWithoutSubscriptionInput;
  where: SubscriptionActivationHistoryItemWhereUniqueInput;
};

export type SubscriptionActivationHistoryItemWhereInput = {
  AND?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereInput>>;
  NOT?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereInput>>;
  OR?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isTrial?: InputMaybe<BoolFilter>;
  subscription?: InputMaybe<SubscriptionRelationFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubscriptionActivationHistoryItemWhereUniqueInput = {
  AND?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereInput>>;
  NOT?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereInput>>;
  OR?: InputMaybe<Array<SubscriptionActivationHistoryItemWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTrial?: InputMaybe<BoolFilter>;
  subscription?: InputMaybe<SubscriptionRelationFilter>;
  subscriptionId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubscriptionCount = {
  __typename?: 'SubscriptionCount';
  activationHistoryItems: Scalars['Int']['output'];
};

export type SubscriptionCreateManyProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd: Scalars['DateTime']['input'];
  dateStart: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  status: SubscriptionStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionCreateManyProfileInputEnvelope = {
  data: Array<SubscriptionCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<SubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubscriptionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<SubscriptionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<SubscriptionCreateManyProfileInputEnvelope>;
};

export type SubscriptionCreateOrConnectWithoutProfileInput = {
  create: SubscriptionCreateWithoutProfileInput;
  where: SubscriptionWhereUniqueInput;
};

export type SubscriptionCreateWithoutProfileInput = {
  activationHistoryItems?: InputMaybe<SubscriptionActivationHistoryItemCreateNestedManyWithoutSubscriptionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd: Scalars['DateTime']['input'];
  dateStart: Scalars['DateTime']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  status: SubscriptionStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionEntity = {
  __typename?: 'SubscriptionEntity';
  _count: SubscriptionCount;
  activationHistoryItems?: Maybe<Array<SubscriptionActivationHistoryItem>>;
  createdAt: Scalars['DateTime']['output'];
  dateEnd: Scalars['DateTime']['output'];
  dateStart: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  profileId: Scalars['Int']['output'];
  status: SubscriptionStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type SubscriptionListRelationFilter = {
  every?: InputMaybe<SubscriptionWhereInput>;
  none?: InputMaybe<SubscriptionWhereInput>;
  some?: InputMaybe<SubscriptionWhereInput>;
};

export type SubscriptionRelationFilter = {
  is?: InputMaybe<SubscriptionWhereInput>;
  isNot?: InputMaybe<SubscriptionWhereInput>;
};

export type SubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<SubscriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<SubscriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<SubscriptionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateEnd?: InputMaybe<DateTimeFilter>;
  dateStart?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  plan?: InputMaybe<StringNullableFilter>;
  profileId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumSubscriptionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export const SubscriptionStatus = {
  Active: 'ACTIVE',
  NotActive: 'NOT_ACTIVE'
} as const;

export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];
export type SubscriptionStatusResponseGGl = {
  __typename?: 'SubscriptionStatusResponseGGl';
  /** plan */
  plan?: Maybe<Scalars['String']['output']>;
  /** active */
  status: Scalars['String']['output'];
};

export type SubscriptionUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionUpdateManyWithWhereWithoutProfileInput = {
  data: SubscriptionUpdateManyMutationInput;
  where: SubscriptionScalarWhereInput;
};

export type SubscriptionUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<SubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubscriptionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<SubscriptionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<SubscriptionCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<SubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<SubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<SubscriptionUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<SubscriptionUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<SubscriptionUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type SubscriptionUpdateWithWhereUniqueWithoutProfileInput = {
  data: SubscriptionUpdateWithoutProfileInput;
  where: SubscriptionWhereUniqueInput;
};

export type SubscriptionUpdateWithoutProfileInput = {
  activationHistoryItems?: InputMaybe<SubscriptionActivationHistoryItemUpdateManyWithoutSubscriptionNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionUpsertWithWhereUniqueWithoutProfileInput = {
  create: SubscriptionCreateWithoutProfileInput;
  update: SubscriptionUpdateWithoutProfileInput;
  where: SubscriptionWhereUniqueInput;
};

export type SubscriptionWhereInput = {
  AND?: InputMaybe<Array<SubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<SubscriptionWhereInput>>;
  OR?: InputMaybe<Array<SubscriptionWhereInput>>;
  activationHistoryItems?: InputMaybe<SubscriptionActivationHistoryItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateEnd?: InputMaybe<DateTimeFilter>;
  dateStart?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  plan?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumSubscriptionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubscriptionWhereUniqueInput = {
  AND?: InputMaybe<Array<SubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<SubscriptionWhereInput>>;
  OR?: InputMaybe<Array<SubscriptionWhereInput>>;
  activationHistoryItems?: InputMaybe<SubscriptionActivationHistoryItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateEnd?: InputMaybe<DateTimeFilter>;
  dateStart?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumSubscriptionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TwoFactorQuestion = {
  __typename?: 'TwoFactorQuestion';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TwoFactorQuestionCreateManyProfileInput = {
  answerHash: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwoFactorQuestionCreateManyProfileInputEnvelope = {
  data: Array<TwoFactorQuestionCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TwoFactorQuestionCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<TwoFactorQuestionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TwoFactorQuestionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<TwoFactorQuestionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<TwoFactorQuestionCreateManyProfileInputEnvelope>;
};

export type TwoFactorQuestionCreateOrConnectWithoutProfileInput = {
  create: TwoFactorQuestionCreateWithoutProfileInput;
  where: TwoFactorQuestionWhereUniqueInput;
};

export type TwoFactorQuestionCreateWithoutProfileInput = {
  answerHash: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  question: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwoFactorQuestionListRelationFilter = {
  every?: InputMaybe<TwoFactorQuestionWhereInput>;
  none?: InputMaybe<TwoFactorQuestionWhereInput>;
  some?: InputMaybe<TwoFactorQuestionWhereInput>;
};

export type TwoFactorQuestionPlainObject = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type TwoFactorQuestionScalarWhereInput = {
  AND?: InputMaybe<Array<TwoFactorQuestionScalarWhereInput>>;
  NOT?: InputMaybe<Array<TwoFactorQuestionScalarWhereInput>>;
  OR?: InputMaybe<Array<TwoFactorQuestionScalarWhereInput>>;
  answerHash?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  profileId?: InputMaybe<IntFilter>;
  question?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TwoFactorQuestionUpdateManyMutationInput = {
  answerHash?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwoFactorQuestionUpdateManyWithWhereWithoutProfileInput = {
  data: TwoFactorQuestionUpdateManyMutationInput;
  where: TwoFactorQuestionScalarWhereInput;
};

export type TwoFactorQuestionUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<TwoFactorQuestionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TwoFactorQuestionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<TwoFactorQuestionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<TwoFactorQuestionCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<TwoFactorQuestionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TwoFactorQuestionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TwoFactorQuestionWhereUniqueInput>>;
  set?: InputMaybe<Array<TwoFactorQuestionWhereUniqueInput>>;
  update?: InputMaybe<Array<TwoFactorQuestionUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<TwoFactorQuestionUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<TwoFactorQuestionUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type TwoFactorQuestionUpdateWithWhereUniqueWithoutProfileInput = {
  data: TwoFactorQuestionUpdateWithoutProfileInput;
  where: TwoFactorQuestionWhereUniqueInput;
};

export type TwoFactorQuestionUpdateWithoutProfileInput = {
  answerHash?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwoFactorQuestionUpsertWithWhereUniqueWithoutProfileInput = {
  create: TwoFactorQuestionCreateWithoutProfileInput;
  update: TwoFactorQuestionUpdateWithoutProfileInput;
  where: TwoFactorQuestionWhereUniqueInput;
};

export type TwoFactorQuestionWhereInput = {
  AND?: InputMaybe<Array<TwoFactorQuestionWhereInput>>;
  NOT?: InputMaybe<Array<TwoFactorQuestionWhereInput>>;
  OR?: InputMaybe<Array<TwoFactorQuestionWhereInput>>;
  answerHash?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  question?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TwoFactorQuestionWhereUniqueInput = {
  AND?: InputMaybe<Array<TwoFactorQuestionWhereInput>>;
  NOT?: InputMaybe<Array<TwoFactorQuestionWhereInput>>;
  OR?: InputMaybe<Array<TwoFactorQuestionWhereInput>>;
  answerHash?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  question?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export const TypeEmailCode = {
  Create: 'CREATE',
  Delete: 'DELETE'
} as const;

export type TypeEmailCode = typeof TypeEmailCode[keyof typeof TypeEmailCode];
export type UpdateAssistantKey = {
  profileId: Scalars['Float']['input'];
  publicKey: Scalars['String']['input'];
};

export type UpdateItemsGqlInput = {
  /** Example collection name */
  collectionName: Scalars['String']['input'];
  /** List of items to update, each containing dtoId, signature, and item data */
  items: Array<Scalars['JSON']['input']>;
  /** Platform (web, ios, android) */
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateItemsGqlPayload = {
  __typename?: 'UpdateItemsGqlPayload';
  /** Example collection name */
  collectionName: Scalars['String']['output'];
  /** Latest collection version */
  collectionVersion: Scalars['Float']['output'];
  /** List of successfully updated items with their signatures */
  updatedItems: Array<Scalars['JSON']['output']>;
};

export type UpdateManyCollectionsGqlInput = {
  /** List of collections to update */
  collections: Array<UpdateItemsGqlInput>;
};

export type UpdateManyCollectionsGqlPayload = {
  __typename?: 'UpdateManyCollectionsGqlPayload';
  /** List of update results for each collection */
  results: Array<UpdateItemsGqlPayload>;
};

export type UpdateRegionNameInput = {
  regionCode?: InputMaybe<Scalars['String']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchemaVersionInput = {
  schemaVersion: Scalars['Float']['input'];
};

export type UrlForExport = {
  __typename?: 'UrlForExport';
  createdAt: Scalars['DateTime']['output'];
  export?: Maybe<Export>;
  id: Scalars['String']['output'];
  status: UrlForExportStatus;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type UrlForExportCreateNestedOneWithoutExportInput = {
  connect?: InputMaybe<UrlForExportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UrlForExportCreateOrConnectWithoutExportInput>;
  create?: InputMaybe<UrlForExportCreateWithoutExportInput>;
};

export type UrlForExportCreateOrConnectWithoutExportInput = {
  create: UrlForExportCreateWithoutExportInput;
  where: UrlForExportWhereUniqueInput;
};

export type UrlForExportCreateWithoutExportInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status: UrlForExportStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type UrlForExportRelationFilter = {
  is?: InputMaybe<UrlForExportWhereInput>;
  isNot?: InputMaybe<UrlForExportWhereInput>;
};

export const UrlForExportStatus = {
  Available: 'AVAILABLE',
  Used: 'USED'
} as const;

export type UrlForExportStatus = typeof UrlForExportStatus[keyof typeof UrlForExportStatus];
export type UrlForExportUpdateOneRequiredWithoutExportNestedInput = {
  connect?: InputMaybe<UrlForExportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UrlForExportCreateOrConnectWithoutExportInput>;
  create?: InputMaybe<UrlForExportCreateWithoutExportInput>;
  update?: InputMaybe<UrlForExportUpdateToOneWithWhereWithoutExportInput>;
  upsert?: InputMaybe<UrlForExportUpsertWithoutExportInput>;
};

export type UrlForExportUpdateToOneWithWhereWithoutExportInput = {
  data: UrlForExportUpdateWithoutExportInput;
  where?: InputMaybe<UrlForExportWhereInput>;
};

export type UrlForExportUpdateWithoutExportInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UrlForExportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UrlForExportUpsertWithoutExportInput = {
  create: UrlForExportCreateWithoutExportInput;
  update: UrlForExportUpdateWithoutExportInput;
  where?: InputMaybe<UrlForExportWhereInput>;
};

export type UrlForExportWhereInput = {
  AND?: InputMaybe<Array<UrlForExportWhereInput>>;
  NOT?: InputMaybe<Array<UrlForExportWhereInput>>;
  OR?: InputMaybe<Array<UrlForExportWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  export?: InputMaybe<ExportNullableRelationFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumUrlForExportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<StringFilter>;
};

export type UrlForExportWhereUniqueInput = {
  AND?: InputMaybe<Array<UrlForExportWhereInput>>;
  NOT?: InputMaybe<Array<UrlForExportWhereInput>>;
  OR?: InputMaybe<Array<UrlForExportWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  export?: InputMaybe<ExportNullableRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUrlForExportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WebPushSubscription = {
  __typename?: 'WebPushSubscription';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  subscriptionData: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type WebPushSubscriptionCreateManyProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriptionData: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WebPushSubscriptionCreateManyProfileInputEnvelope = {
  data: Array<WebPushSubscriptionCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WebPushSubscriptionCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<WebPushSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WebPushSubscriptionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<WebPushSubscriptionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<WebPushSubscriptionCreateManyProfileInputEnvelope>;
};

export type WebPushSubscriptionCreateOrConnectWithoutProfileInput = {
  create: WebPushSubscriptionCreateWithoutProfileInput;
  where: WebPushSubscriptionWhereUniqueInput;
};

export type WebPushSubscriptionCreateWithoutProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionData: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WebPushSubscriptionInput = {
  endpoint: Scalars['String']['input'];
  keys: KeysInput;
};

export type WebPushSubscriptionListRelationFilter = {
  every?: InputMaybe<WebPushSubscriptionWhereInput>;
  none?: InputMaybe<WebPushSubscriptionWhereInput>;
  some?: InputMaybe<WebPushSubscriptionWhereInput>;
};

export type WebPushSubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<WebPushSubscriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<WebPushSubscriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<WebPushSubscriptionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  profileId?: InputMaybe<IntFilter>;
  subscriptionData?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type WebPushSubscriptionUniqueSubscriptionForProfileCompoundUniqueInput = {
  profileId: Scalars['Int']['input'];
  subscriptionData: Scalars['String']['input'];
};

export type WebPushSubscriptionUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionData?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WebPushSubscriptionUpdateManyWithWhereWithoutProfileInput = {
  data: WebPushSubscriptionUpdateManyMutationInput;
  where: WebPushSubscriptionScalarWhereInput;
};

export type WebPushSubscriptionUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<WebPushSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WebPushSubscriptionCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<WebPushSubscriptionCreateWithoutProfileInput>>;
  createMany?: InputMaybe<WebPushSubscriptionCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<WebPushSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WebPushSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WebPushSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<WebPushSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<WebPushSubscriptionUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<WebPushSubscriptionUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<WebPushSubscriptionUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type WebPushSubscriptionUpdateWithWhereUniqueWithoutProfileInput = {
  data: WebPushSubscriptionUpdateWithoutProfileInput;
  where: WebPushSubscriptionWhereUniqueInput;
};

export type WebPushSubscriptionUpdateWithoutProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionData?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WebPushSubscriptionUpsertWithWhereUniqueWithoutProfileInput = {
  create: WebPushSubscriptionCreateWithoutProfileInput;
  update: WebPushSubscriptionUpdateWithoutProfileInput;
  where: WebPushSubscriptionWhereUniqueInput;
};

export type WebPushSubscriptionWhereInput = {
  AND?: InputMaybe<Array<WebPushSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<WebPushSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<WebPushSubscriptionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  subscriptionData?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type WebPushSubscriptionWhereUniqueInput = {
  AND?: InputMaybe<Array<WebPushSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<WebPushSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<WebPushSubscriptionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  subscriptionData?: InputMaybe<StringFilter>;
  uniqueSubscriptionForProfile?: InputMaybe<WebPushSubscriptionUniqueSubscriptionForProfileCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Whitelist = {
  __typename?: 'Whitelist';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  planId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Will = {
  __typename?: 'Will';
  _count: WillCount;
  attachments?: Maybe<Array<WillAttachment>>;
  createdAt: Scalars['DateTime']['output'];
  creator: Profile;
  creatorId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  participants?: Maybe<Array<WillParticipant>>;
  scenario?: Maybe<Scenario>;
  scenarioId?: Maybe<Scalars['String']['output']>;
  status: WillStatus;
  updatedAt: Scalars['DateTime']['output'];
  willNumber: Scalars['String']['output'];
};

export type WillAttachment = {
  __typename?: 'WillAttachment';
  attachmentNumber: Scalars['String']['output'];
  certificateId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  type: AttachmentType;
  updatedAt: Scalars['DateTime']['output'];
  will: Will;
  willId: Scalars['String']['output'];
};

export type WillAttachmentCreateManyWillInput = {
  attachmentNumber: Scalars['String']['input'];
  certificateId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type: AttachmentType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WillAttachmentCreateManyWillInputEnvelope = {
  data: Array<WillAttachmentCreateManyWillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WillAttachmentCreateNestedManyWithoutWillInput = {
  connect?: InputMaybe<Array<WillAttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillAttachmentCreateOrConnectWithoutWillInput>>;
  create?: InputMaybe<Array<WillAttachmentCreateWithoutWillInput>>;
  createMany?: InputMaybe<WillAttachmentCreateManyWillInputEnvelope>;
};

export type WillAttachmentCreateOrConnectWithoutWillInput = {
  create: WillAttachmentCreateWithoutWillInput;
  where: WillAttachmentWhereUniqueInput;
};

export type WillAttachmentCreateWithoutWillInput = {
  attachmentNumber: Scalars['String']['input'];
  certificateId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type: AttachmentType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WillAttachmentListRelationFilter = {
  every?: InputMaybe<WillAttachmentWhereInput>;
  none?: InputMaybe<WillAttachmentWhereInput>;
  some?: InputMaybe<WillAttachmentWhereInput>;
};

export type WillAttachmentScalarWhereInput = {
  AND?: InputMaybe<Array<WillAttachmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<WillAttachmentScalarWhereInput>>;
  OR?: InputMaybe<Array<WillAttachmentScalarWhereInput>>;
  attachmentNumber?: InputMaybe<StringFilter>;
  certificateId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  filePath?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumAttachmentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  willId?: InputMaybe<StringFilter>;
};

export type WillAttachmentUpdateManyMutationInput = {
  attachmentNumber?: InputMaybe<Scalars['String']['input']>;
  certificateId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<AttachmentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WillAttachmentUpdateManyWithWhereWithoutWillInput = {
  data: WillAttachmentUpdateManyMutationInput;
  where: WillAttachmentScalarWhereInput;
};

export type WillAttachmentUpdateManyWithoutWillNestedInput = {
  connect?: InputMaybe<Array<WillAttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillAttachmentCreateOrConnectWithoutWillInput>>;
  create?: InputMaybe<Array<WillAttachmentCreateWithoutWillInput>>;
  createMany?: InputMaybe<WillAttachmentCreateManyWillInputEnvelope>;
  delete?: InputMaybe<Array<WillAttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WillAttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WillAttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<WillAttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<WillAttachmentUpdateWithWhereUniqueWithoutWillInput>>;
  updateMany?: InputMaybe<Array<WillAttachmentUpdateManyWithWhereWithoutWillInput>>;
  upsert?: InputMaybe<Array<WillAttachmentUpsertWithWhereUniqueWithoutWillInput>>;
};

export type WillAttachmentUpdateWithWhereUniqueWithoutWillInput = {
  data: WillAttachmentUpdateWithoutWillInput;
  where: WillAttachmentWhereUniqueInput;
};

export type WillAttachmentUpdateWithoutWillInput = {
  attachmentNumber?: InputMaybe<Scalars['String']['input']>;
  certificateId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<AttachmentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WillAttachmentUpsertWithWhereUniqueWithoutWillInput = {
  create: WillAttachmentCreateWithoutWillInput;
  update: WillAttachmentUpdateWithoutWillInput;
  where: WillAttachmentWhereUniqueInput;
};

export type WillAttachmentWhereInput = {
  AND?: InputMaybe<Array<WillAttachmentWhereInput>>;
  NOT?: InputMaybe<Array<WillAttachmentWhereInput>>;
  OR?: InputMaybe<Array<WillAttachmentWhereInput>>;
  attachmentNumber?: InputMaybe<StringFilter>;
  certificateId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  filePath?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumAttachmentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  will?: InputMaybe<WillRelationFilter>;
  willId?: InputMaybe<StringFilter>;
};

export type WillAttachmentWhereUniqueInput = {
  AND?: InputMaybe<Array<WillAttachmentWhereInput>>;
  NOT?: InputMaybe<Array<WillAttachmentWhereInput>>;
  OR?: InputMaybe<Array<WillAttachmentWhereInput>>;
  attachmentNumber?: InputMaybe<Scalars['String']['input']>;
  certificateId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  filePath?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumAttachmentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  will?: InputMaybe<WillRelationFilter>;
  willId?: InputMaybe<StringFilter>;
};

export type WillCount = {
  __typename?: 'WillCount';
  attachments: Scalars['Int']['output'];
  participants: Scalars['Int']['output'];
};

export type WillCreateManyCreatorInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber: Scalars['String']['input'];
};

export type WillCreateManyCreatorInputEnvelope = {
  data: Array<WillCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WillCreateManyScenarioInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creatorId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber: Scalars['String']['input'];
};

export type WillCreateManyScenarioInputEnvelope = {
  data: Array<WillCreateManyScenarioInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WillCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<WillWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<WillCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<WillCreateManyCreatorInputEnvelope>;
};

export type WillCreateNestedManyWithoutScenarioInput = {
  connect?: InputMaybe<Array<WillWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillCreateOrConnectWithoutScenarioInput>>;
  create?: InputMaybe<Array<WillCreateWithoutScenarioInput>>;
  createMany?: InputMaybe<WillCreateManyScenarioInputEnvelope>;
};

export type WillCreateNestedOneWithoutParticipantsInput = {
  connect?: InputMaybe<WillWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WillCreateOrConnectWithoutParticipantsInput>;
  create?: InputMaybe<WillCreateWithoutParticipantsInput>;
};

export type WillCreateOrConnectWithoutCreatorInput = {
  create: WillCreateWithoutCreatorInput;
  where: WillWhereUniqueInput;
};

export type WillCreateOrConnectWithoutParticipantsInput = {
  create: WillCreateWithoutParticipantsInput;
  where: WillWhereUniqueInput;
};

export type WillCreateOrConnectWithoutScenarioInput = {
  create: WillCreateWithoutScenarioInput;
  where: WillWhereUniqueInput;
};

export type WillCreateWithoutCreatorInput = {
  attachments?: InputMaybe<WillAttachmentCreateNestedManyWithoutWillInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<WillParticipantCreateNestedManyWithoutWillInput>;
  scenario?: InputMaybe<ScenarioCreateNestedOneWithoutWillsInput>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber: Scalars['String']['input'];
};

export type WillCreateWithoutParticipantsInput = {
  attachments?: InputMaybe<WillAttachmentCreateNestedManyWithoutWillInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: ProfileCreateNestedOneWithoutWillsAsCreatorInput;
  id?: InputMaybe<Scalars['String']['input']>;
  scenario?: InputMaybe<ScenarioCreateNestedOneWithoutWillsInput>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber: Scalars['String']['input'];
};

export type WillCreateWithoutScenarioInput = {
  attachments?: InputMaybe<WillAttachmentCreateNestedManyWithoutWillInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: ProfileCreateNestedOneWithoutWillsAsCreatorInput;
  id?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<WillParticipantCreateNestedManyWithoutWillInput>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber: Scalars['String']['input'];
};

export type WillListRelationFilter = {
  every?: InputMaybe<WillWhereInput>;
  none?: InputMaybe<WillWhereInput>;
  some?: InputMaybe<WillWhereInput>;
};

export type WillParticipant = {
  __typename?: 'WillParticipant';
  _count: WillParticipantCount;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  asBeneficiaryWithRecipient?: Maybe<Array<InformationRecipientAssignment>>;
  asInformationRecipient?: Maybe<Array<InformationRecipientAssignment>>;
  id: Scalars['String']['output'];
  invitedAt: Scalars['DateTime']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  role: WillRole;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ParticipantStatus;
  will: Will;
  willId: Scalars['String']['output'];
};

export type WillParticipantCount = {
  __typename?: 'WillParticipantCount';
  asBeneficiaryWithRecipient: Scalars['Int']['output'];
  asInformationRecipient: Scalars['Int']['output'];
};

export type WillParticipantCreateManyProfileInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: WillRole;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  willId: Scalars['String']['input'];
};

export type WillParticipantCreateManyProfileInputEnvelope = {
  data: Array<WillParticipantCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WillParticipantCreateManyWillInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  profileId: Scalars['Int']['input'];
  role: WillRole;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
};

export type WillParticipantCreateManyWillInputEnvelope = {
  data: Array<WillParticipantCreateManyWillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WillParticipantCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillParticipantCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<WillParticipantCreateWithoutProfileInput>>;
  createMany?: InputMaybe<WillParticipantCreateManyProfileInputEnvelope>;
};

export type WillParticipantCreateNestedManyWithoutWillInput = {
  connect?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillParticipantCreateOrConnectWithoutWillInput>>;
  create?: InputMaybe<Array<WillParticipantCreateWithoutWillInput>>;
  createMany?: InputMaybe<WillParticipantCreateManyWillInputEnvelope>;
};

export type WillParticipantCreateNestedOneWithoutAsBeneficiaryWithRecipientInput = {
  connect?: InputMaybe<WillParticipantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WillParticipantCreateOrConnectWithoutAsBeneficiaryWithRecipientInput>;
  create?: InputMaybe<WillParticipantCreateWithoutAsBeneficiaryWithRecipientInput>;
};

export type WillParticipantCreateNestedOneWithoutAsInformationRecipientInput = {
  connect?: InputMaybe<WillParticipantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WillParticipantCreateOrConnectWithoutAsInformationRecipientInput>;
  create?: InputMaybe<WillParticipantCreateWithoutAsInformationRecipientInput>;
};

export type WillParticipantCreateOrConnectWithoutAsBeneficiaryWithRecipientInput = {
  create: WillParticipantCreateWithoutAsBeneficiaryWithRecipientInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantCreateOrConnectWithoutAsInformationRecipientInput = {
  create: WillParticipantCreateWithoutAsInformationRecipientInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantCreateOrConnectWithoutProfileInput = {
  create: WillParticipantCreateWithoutProfileInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantCreateOrConnectWithoutWillInput = {
  create: WillParticipantCreateWithoutWillInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantCreateWithoutAsBeneficiaryWithRecipientInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentCreateNestedManyWithoutInformationRecipientInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  profile: ProfileCreateNestedOneWithoutWillParticipationsInput;
  role: WillRole;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  will: WillCreateNestedOneWithoutParticipantsInput;
};

export type WillParticipantCreateWithoutAsInformationRecipientInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentCreateNestedManyWithoutBeneficiaryInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  profile: ProfileCreateNestedOneWithoutWillParticipationsInput;
  role: WillRole;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  will: WillCreateNestedOneWithoutParticipantsInput;
};

export type WillParticipantCreateWithoutProfileInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentCreateNestedManyWithoutBeneficiaryInput>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentCreateNestedManyWithoutInformationRecipientInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: WillRole;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  will: WillCreateNestedOneWithoutParticipantsInput;
};

export type WillParticipantCreateWithoutWillInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentCreateNestedManyWithoutBeneficiaryInput>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentCreateNestedManyWithoutInformationRecipientInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  profile: ProfileCreateNestedOneWithoutWillParticipationsInput;
  role: WillRole;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
};

export type WillParticipantListRelationFilter = {
  every?: InputMaybe<WillParticipantWhereInput>;
  none?: InputMaybe<WillParticipantWhereInput>;
  some?: InputMaybe<WillParticipantWhereInput>;
};

export type WillParticipantRelationFilter = {
  is?: InputMaybe<WillParticipantWhereInput>;
  isNot?: InputMaybe<WillParticipantWhereInput>;
};

export type WillParticipantScalarWhereInput = {
  AND?: InputMaybe<Array<WillParticipantScalarWhereInput>>;
  NOT?: InputMaybe<Array<WillParticipantScalarWhereInput>>;
  OR?: InputMaybe<Array<WillParticipantScalarWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invitedAt?: InputMaybe<DateTimeFilter>;
  profileId?: InputMaybe<IntFilter>;
  role?: InputMaybe<EnumWillRoleFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumParticipantStatusFilter>;
  willId?: InputMaybe<StringFilter>;
};

export type WillParticipantUpdateManyMutationInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<WillRole>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
};

export type WillParticipantUpdateManyWithWhereWithoutProfileInput = {
  data: WillParticipantUpdateManyMutationInput;
  where: WillParticipantScalarWhereInput;
};

export type WillParticipantUpdateManyWithWhereWithoutWillInput = {
  data: WillParticipantUpdateManyMutationInput;
  where: WillParticipantScalarWhereInput;
};

export type WillParticipantUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillParticipantCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<WillParticipantCreateWithoutProfileInput>>;
  createMany?: InputMaybe<WillParticipantCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WillParticipantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  update?: InputMaybe<Array<WillParticipantUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<WillParticipantUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<WillParticipantUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type WillParticipantUpdateManyWithoutWillNestedInput = {
  connect?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillParticipantCreateOrConnectWithoutWillInput>>;
  create?: InputMaybe<Array<WillParticipantCreateWithoutWillInput>>;
  createMany?: InputMaybe<WillParticipantCreateManyWillInputEnvelope>;
  delete?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WillParticipantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<WillParticipantWhereUniqueInput>>;
  update?: InputMaybe<Array<WillParticipantUpdateWithWhereUniqueWithoutWillInput>>;
  updateMany?: InputMaybe<Array<WillParticipantUpdateManyWithWhereWithoutWillInput>>;
  upsert?: InputMaybe<Array<WillParticipantUpsertWithWhereUniqueWithoutWillInput>>;
};

export type WillParticipantUpdateOneRequiredWithoutAsBeneficiaryWithRecipientNestedInput = {
  connect?: InputMaybe<WillParticipantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WillParticipantCreateOrConnectWithoutAsBeneficiaryWithRecipientInput>;
  create?: InputMaybe<WillParticipantCreateWithoutAsBeneficiaryWithRecipientInput>;
  update?: InputMaybe<WillParticipantUpdateToOneWithWhereWithoutAsBeneficiaryWithRecipientInput>;
  upsert?: InputMaybe<WillParticipantUpsertWithoutAsBeneficiaryWithRecipientInput>;
};

export type WillParticipantUpdateOneRequiredWithoutAsInformationRecipientNestedInput = {
  connect?: InputMaybe<WillParticipantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WillParticipantCreateOrConnectWithoutAsInformationRecipientInput>;
  create?: InputMaybe<WillParticipantCreateWithoutAsInformationRecipientInput>;
  update?: InputMaybe<WillParticipantUpdateToOneWithWhereWithoutAsInformationRecipientInput>;
  upsert?: InputMaybe<WillParticipantUpsertWithoutAsInformationRecipientInput>;
};

export type WillParticipantUpdateToOneWithWhereWithoutAsBeneficiaryWithRecipientInput = {
  data: WillParticipantUpdateWithoutAsBeneficiaryWithRecipientInput;
  where?: InputMaybe<WillParticipantWhereInput>;
};

export type WillParticipantUpdateToOneWithWhereWithoutAsInformationRecipientInput = {
  data: WillParticipantUpdateWithoutAsInformationRecipientInput;
  where?: InputMaybe<WillParticipantWhereInput>;
};

export type WillParticipantUpdateWithWhereUniqueWithoutProfileInput = {
  data: WillParticipantUpdateWithoutProfileInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantUpdateWithWhereUniqueWithoutWillInput = {
  data: WillParticipantUpdateWithoutWillInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantUpdateWithoutAsBeneficiaryWithRecipientInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentUpdateManyWithoutInformationRecipientNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  profile?: InputMaybe<ProfileUpdateOneRequiredWithoutWillParticipationsNestedInput>;
  role?: InputMaybe<WillRole>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  will?: InputMaybe<WillUpdateOneRequiredWithoutParticipantsNestedInput>;
};

export type WillParticipantUpdateWithoutAsInformationRecipientInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentUpdateManyWithoutBeneficiaryNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  profile?: InputMaybe<ProfileUpdateOneRequiredWithoutWillParticipationsNestedInput>;
  role?: InputMaybe<WillRole>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  will?: InputMaybe<WillUpdateOneRequiredWithoutParticipantsNestedInput>;
};

export type WillParticipantUpdateWithoutProfileInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentUpdateManyWithoutBeneficiaryNestedInput>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentUpdateManyWithoutInformationRecipientNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<WillRole>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  will?: InputMaybe<WillUpdateOneRequiredWithoutParticipantsNestedInput>;
};

export type WillParticipantUpdateWithoutWillInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentUpdateManyWithoutBeneficiaryNestedInput>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentUpdateManyWithoutInformationRecipientNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  profile?: InputMaybe<ProfileUpdateOneRequiredWithoutWillParticipationsNestedInput>;
  role?: InputMaybe<WillRole>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ParticipantStatus>;
};

export type WillParticipantUpsertWithWhereUniqueWithoutProfileInput = {
  create: WillParticipantCreateWithoutProfileInput;
  update: WillParticipantUpdateWithoutProfileInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantUpsertWithWhereUniqueWithoutWillInput = {
  create: WillParticipantCreateWithoutWillInput;
  update: WillParticipantUpdateWithoutWillInput;
  where: WillParticipantWhereUniqueInput;
};

export type WillParticipantUpsertWithoutAsBeneficiaryWithRecipientInput = {
  create: WillParticipantCreateWithoutAsBeneficiaryWithRecipientInput;
  update: WillParticipantUpdateWithoutAsBeneficiaryWithRecipientInput;
  where?: InputMaybe<WillParticipantWhereInput>;
};

export type WillParticipantUpsertWithoutAsInformationRecipientInput = {
  create: WillParticipantCreateWithoutAsInformationRecipientInput;
  update: WillParticipantUpdateWithoutAsInformationRecipientInput;
  where?: InputMaybe<WillParticipantWhereInput>;
};

export type WillParticipantWhereInput = {
  AND?: InputMaybe<Array<WillParticipantWhereInput>>;
  NOT?: InputMaybe<Array<WillParticipantWhereInput>>;
  OR?: InputMaybe<Array<WillParticipantWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentListRelationFilter>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  invitedAt?: InputMaybe<DateTimeFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  role?: InputMaybe<EnumWillRoleFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumParticipantStatusFilter>;
  will?: InputMaybe<WillRelationFilter>;
  willId?: InputMaybe<StringFilter>;
};

export type WillParticipantWhereUniqueInput = {
  AND?: InputMaybe<Array<WillParticipantWhereInput>>;
  NOT?: InputMaybe<Array<WillParticipantWhereInput>>;
  OR?: InputMaybe<Array<WillParticipantWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  asBeneficiaryWithRecipient?: InputMaybe<InformationRecipientAssignmentListRelationFilter>;
  asInformationRecipient?: InputMaybe<InformationRecipientAssignmentListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<DateTimeFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<IntFilter>;
  role?: InputMaybe<EnumWillRoleFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumParticipantStatusFilter>;
  will?: InputMaybe<WillRelationFilter>;
  willId?: InputMaybe<StringFilter>;
  willIdProfileIdRole?: InputMaybe<WillParticipantWillIdProfileIdRoleCompoundUniqueInput>;
};

export type WillParticipantWillIdProfileIdRoleCompoundUniqueInput = {
  profileId: Scalars['Int']['input'];
  role: WillRole;
  willId: Scalars['String']['input'];
};

export type WillRelationFilter = {
  is?: InputMaybe<WillWhereInput>;
  isNot?: InputMaybe<WillWhereInput>;
};

export const WillRole = {
  AlternativeExecutor: 'ALTERNATIVE_EXECUTOR',
  Beneficiary: 'BENEFICIARY',
  Executor: 'EXECUTOR',
  InformationRecipient: 'INFORMATION_RECIPIENT',
  Witness: 'WITNESS'
} as const;

export type WillRole = typeof WillRole[keyof typeof WillRole];
export type WillScalarWhereInput = {
  AND?: InputMaybe<Array<WillScalarWhereInput>>;
  NOT?: InputMaybe<Array<WillScalarWhereInput>>;
  OR?: InputMaybe<Array<WillScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  scenarioId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumWillStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  willNumber?: InputMaybe<StringFilter>;
};

export const WillStatus = {
  Draft: 'DRAFT',
  Executed: 'EXECUTED',
  PendingSignatures: 'PENDING_SIGNATURES',
  Signed: 'SIGNED'
} as const;

export type WillStatus = typeof WillStatus[keyof typeof WillStatus];
export type WillUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber?: InputMaybe<Scalars['String']['input']>;
};

export type WillUpdateManyWithWhereWithoutCreatorInput = {
  data: WillUpdateManyMutationInput;
  where: WillScalarWhereInput;
};

export type WillUpdateManyWithWhereWithoutScenarioInput = {
  data: WillUpdateManyMutationInput;
  where: WillScalarWhereInput;
};

export type WillUpdateManyWithoutCreatorNestedInput = {
  connect?: InputMaybe<Array<WillWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<WillCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<WillCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<WillWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WillScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WillWhereUniqueInput>>;
  set?: InputMaybe<Array<WillWhereUniqueInput>>;
  update?: InputMaybe<Array<WillUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<WillUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<WillUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type WillUpdateManyWithoutScenarioNestedInput = {
  connect?: InputMaybe<Array<WillWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WillCreateOrConnectWithoutScenarioInput>>;
  create?: InputMaybe<Array<WillCreateWithoutScenarioInput>>;
  createMany?: InputMaybe<WillCreateManyScenarioInputEnvelope>;
  delete?: InputMaybe<Array<WillWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WillScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WillWhereUniqueInput>>;
  set?: InputMaybe<Array<WillWhereUniqueInput>>;
  update?: InputMaybe<Array<WillUpdateWithWhereUniqueWithoutScenarioInput>>;
  updateMany?: InputMaybe<Array<WillUpdateManyWithWhereWithoutScenarioInput>>;
  upsert?: InputMaybe<Array<WillUpsertWithWhereUniqueWithoutScenarioInput>>;
};

export type WillUpdateOneRequiredWithoutParticipantsNestedInput = {
  connect?: InputMaybe<WillWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WillCreateOrConnectWithoutParticipantsInput>;
  create?: InputMaybe<WillCreateWithoutParticipantsInput>;
  update?: InputMaybe<WillUpdateToOneWithWhereWithoutParticipantsInput>;
  upsert?: InputMaybe<WillUpsertWithoutParticipantsInput>;
};

export type WillUpdateToOneWithWhereWithoutParticipantsInput = {
  data: WillUpdateWithoutParticipantsInput;
  where?: InputMaybe<WillWhereInput>;
};

export type WillUpdateWithWhereUniqueWithoutCreatorInput = {
  data: WillUpdateWithoutCreatorInput;
  where: WillWhereUniqueInput;
};

export type WillUpdateWithWhereUniqueWithoutScenarioInput = {
  data: WillUpdateWithoutScenarioInput;
  where: WillWhereUniqueInput;
};

export type WillUpdateWithoutCreatorInput = {
  attachments?: InputMaybe<WillAttachmentUpdateManyWithoutWillNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<WillParticipantUpdateManyWithoutWillNestedInput>;
  scenario?: InputMaybe<ScenarioUpdateOneWithoutWillsNestedInput>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber?: InputMaybe<Scalars['String']['input']>;
};

export type WillUpdateWithoutParticipantsInput = {
  attachments?: InputMaybe<WillAttachmentUpdateManyWithoutWillNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<ProfileUpdateOneRequiredWithoutWillsAsCreatorNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  scenario?: InputMaybe<ScenarioUpdateOneWithoutWillsNestedInput>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber?: InputMaybe<Scalars['String']['input']>;
};

export type WillUpdateWithoutScenarioInput = {
  attachments?: InputMaybe<WillAttachmentUpdateManyWithoutWillNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<ProfileUpdateOneRequiredWithoutWillsAsCreatorNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<WillParticipantUpdateManyWithoutWillNestedInput>;
  status?: InputMaybe<WillStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  willNumber?: InputMaybe<Scalars['String']['input']>;
};

export type WillUpsertWithWhereUniqueWithoutCreatorInput = {
  create: WillCreateWithoutCreatorInput;
  update: WillUpdateWithoutCreatorInput;
  where: WillWhereUniqueInput;
};

export type WillUpsertWithWhereUniqueWithoutScenarioInput = {
  create: WillCreateWithoutScenarioInput;
  update: WillUpdateWithoutScenarioInput;
  where: WillWhereUniqueInput;
};

export type WillUpsertWithoutParticipantsInput = {
  create: WillCreateWithoutParticipantsInput;
  update: WillUpdateWithoutParticipantsInput;
  where?: InputMaybe<WillWhereInput>;
};

export type WillWhereInput = {
  AND?: InputMaybe<Array<WillWhereInput>>;
  NOT?: InputMaybe<Array<WillWhereInput>>;
  OR?: InputMaybe<Array<WillWhereInput>>;
  attachments?: InputMaybe<WillAttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<ProfileRelationFilter>;
  creatorId?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  participants?: InputMaybe<WillParticipantListRelationFilter>;
  scenario?: InputMaybe<ScenarioNullableRelationFilter>;
  scenarioId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumWillStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  willNumber?: InputMaybe<StringFilter>;
};

export type WillWhereUniqueInput = {
  AND?: InputMaybe<Array<WillWhereInput>>;
  NOT?: InputMaybe<Array<WillWhereInput>>;
  OR?: InputMaybe<Array<WillWhereInput>>;
  attachments?: InputMaybe<WillAttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<ProfileRelationFilter>;
  creatorId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<WillParticipantListRelationFilter>;
  scenario?: InputMaybe<ScenarioNullableRelationFilter>;
  scenarioId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumWillStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  willNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RequestExportMutationVariables = Exact<{
  basicAuthLogin: Scalars['String']['input'];
  basicAuthPassword: Scalars['String']['input'];
  awsAccessKeyId?: InputMaybe<Scalars['String']['input']>;
  awsSecretAccessKey?: InputMaybe<Scalars['String']['input']>;
  hubType?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  idInnerHub?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestExportMutation = { __typename?: 'Mutation', requestExport: boolean };

export type CurrentExportRequestQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentExportRequestQuery = { __typename?: 'Query', currentExportRequest?: Array<{ __typename?: 'SafeExport', id: string, createdAt: any, updatedAt: any, url: string, status: string, hubType?: string | undefined }> | undefined };

export type GetHubSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHubSettingsQuery = { __typename?: 'Query', getHubSettings: Array<{ __typename?: 'HubSettingsResponse', hubUrl: string, ipAddress: string, provider: string, country: string, connectedAt: any, lastPingAt: any, updatedAt: any, ownedByUser: boolean }> };

export type GetAvailableRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableRegionsQuery = { __typename?: 'Query', getAvailableRegions: Array<{ __typename?: 'RegionName', id: number, regionCode: string, regionName: string }> };

export type GetSubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionInfoQuery = { __typename?: 'Query', getSubscriptionStatus: { __typename?: 'SubscriptionStatusResponseGGl', plan?: string | undefined, status: string } };

export type CreateSubscriptionMutationVariables = Exact<{
  plan: Scalars['String']['input'];
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', subscribe: { __typename?: 'SubscriptionEntity', id: number, status: SubscriptionStatus, dateStart: any, dateEnd: any, profileId: number } };

export type CreateAssistantMutationVariables = Exact<{
  name: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
}>;


export type CreateAssistantMutation = { __typename?: 'Mutation', createAssistant: { __typename?: 'Account', id: number } };

export type CreateBeneficiaryMutationVariables = Exact<{
  email: Scalars['String']['input'];
  dontSendInviteEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateBeneficiaryMutation = { __typename?: 'Mutation', createBeneficiary: { __typename?: 'CreateBeneficiaryResponse', invitationCode: string, account: { __typename?: 'Account', id: number, profileId?: number | undefined } } };

export type SendNewInviteToBeneficiaryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SendNewInviteToBeneficiaryMutation = { __typename?: 'Mutation', sendNewInviteToBeneficiary: { __typename?: 'Profile', id: number, status: AccountStatus, invitationLastSentTime?: any | undefined } };

export type RegisterBeneficiaryByInvitationCodeMutationVariables = Exact<{
  input: BeneficiaryCreateByInviteCodeInput;
}>;


export type RegisterBeneficiaryByInvitationCodeMutation = { __typename?: 'Mutation', registerBeneficiaryByInvitationCode: { __typename?: 'AuthResponse', token: string, account: { __typename?: 'Account', id: number, email: string } } };

export type RegenerateBeneficiaryInviteMutationVariables = Exact<{
  beneficiaryProfileId: Scalars['Int']['input'];
}>;


export type RegenerateBeneficiaryInviteMutation = { __typename?: 'Mutation', regenerateBeneficiaryInvite: { __typename?: 'CreateBeneficiaryResponse', invitationCode: string, account: { __typename?: 'Account', id: number } } };

export type CollectionAddItemMutationVariables = Exact<{
  data: AddItemGqlInput;
}>;


export type CollectionAddItemMutation = { __typename?: 'Mutation', addItemToCollectionGql: { __typename?: 'AddItemGqlPayload', collectionName: string, signature: string } };

export type CollectionChangeItemMutationVariables = Exact<{
  data: ChangeItemGqlInput;
}>;


export type CollectionChangeItemMutation = { __typename?: 'Mutation', changeItemInCollectionGql: { __typename?: 'ChangeItemGqlPayload', collectionName: string, signature: string } };

export type CollectionRemoveItemMutationVariables = Exact<{
  data: RemoveItemGqlInput;
}>;


export type CollectionRemoveItemMutation = { __typename?: 'Mutation', removeItemFromCollectionGql: { __typename?: 'RemoveItemGqlPayload', collectionName: string } };

export type UpdateManyCollectionsMutationVariables = Exact<{
  data: UpdateManyCollectionsGqlInput;
}>;


export type UpdateManyCollectionsMutation = { __typename?: 'Mutation', updateManyCollectionsGql: { __typename?: 'UpdateManyCollectionsGqlPayload', results: Array<{ __typename?: 'UpdateItemsGqlPayload', collectionName: string, updatedItems: Array<any> }> } };

export type GenerateEncryptedMessageMutationVariables = Exact<{
  publicKey: Scalars['String']['input'];
}>;


export type GenerateEncryptedMessageMutation = { __typename?: 'Mutation', generateEncryptedMessage: string };

export type GetCurrencyRatesMutationVariables = Exact<{
  baseCurrency: Scalars['String']['input'];
  quoteCurrencies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCurrencyRatesMutation = { __typename?: 'Mutation', getCurrencyRates: Array<{ __typename?: 'CurrencyRateResponse', baseCurrency: string, quoteCurrency: string, rate: number }> };

export type UploadFileMutationVariables = Exact<{
  fileContent: Scalars['String']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: string };

export type DeleteFileMutationVariables = Exact<{
  filename: Scalars['String']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: boolean };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  totpToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthResponse', token: string, account: { __typename?: 'Account', id: number, email: string } } };

export type LoginViaPersonalAccountCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type LoginViaPersonalAccountCodeMutation = { __typename?: 'Mutation', loginViaPersonalAccountCode: { __typename?: 'AuthLoginResponse', token: string, account: { __typename?: 'Account', id: number, email: string, schemaVersion: number }, profile: { __typename?: 'Profile', status: AccountStatus, encryptionType?: { __typename?: 'EncryptionType', title: string } | undefined } } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ResetPasswordByCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordByCodeMutation = { __typename?: 'Mutation', resetPasswordByCode: { __typename?: 'Account', id: number } };

export type LoginViaDecryptedMessageMutationVariables = Exact<{
  decryptedMessage: Scalars['String']['input'];
}>;


export type LoginViaDecryptedMessageMutation = { __typename?: 'Mutation', loginViaDecryptedMessage: { __typename?: 'AuthResponse', token: string, account: { __typename?: 'Account', id: number, email: string } } };

export type LogoutMutationVariables = Exact<{
  sessionIds: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type GenerateSmsCodeResponseMutationVariables = Exact<{
  number: Scalars['String']['input'];
}>;


export type GenerateSmsCodeResponseMutation = { __typename?: 'Mutation', generateSmsCodeResponse: boolean };

export type CreateEmailAccountMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type CreateEmailAccountMutation = { __typename?: 'Mutation', createEmailAccount: { __typename?: 'CreateEmailAccount', email: string } };

export type DeleteEmailAccountMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type DeleteEmailAccountMutation = { __typename?: 'Mutation', deleteEmailAccount: { __typename?: 'DeleteEmailAccount', email: string } };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'Account', id: number } };

export type ChangeSoweAppendixSuppressCancelConfirmationMutationVariables = Exact<{
  soweAppendixSuppressCancelConfirmation: Scalars['Boolean']['input'];
}>;


export type ChangeSoweAppendixSuppressCancelConfirmationMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', soweAppendixSuppressCancelConfirmation: boolean } };

export type ChangeOcrSuppressLetsTryConfirmationMutationVariables = Exact<{
  ocrSuppressLetsTryConfirmation: Scalars['Boolean']['input'];
}>;


export type ChangeOcrSuppressLetsTryConfirmationMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', ocrSuppressLetsTryConfirmation: boolean } };

export type UpdateProfileNamesMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProfileNamesMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', firstName?: string | undefined, lastName?: string | undefined } };

export type VerifyPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type VerifyPasswordMutation = { __typename?: 'Mutation', verifyPassword: boolean };

export type BlockAccountMutationVariables = Exact<{
  emailCode: Scalars['String']['input'];
}>;


export type BlockAccountMutation = { __typename?: 'Mutation', blockAccount: boolean };

export type MigrateToEciesMutationVariables = Exact<{
  publicKey: Scalars['String']['input'];
  assistants?: InputMaybe<Array<UpdateAssistantKey> | UpdateAssistantKey>;
}>;


export type MigrateToEciesMutation = { __typename?: 'Mutation', migrateToEcies: { __typename?: 'Profile', id: number, encryptionType?: { __typename?: 'EncryptionType', title: string } | undefined } };

export type ChangeBaseCurrencyMutationVariables = Exact<{
  baseCurrency: Scalars['String']['input'];
}>;


export type ChangeBaseCurrencyMutation = { __typename?: 'Mutation', changeBaseCurrency: { __typename?: 'Profile', baseCurrency: { __typename?: 'Currency', title: string } } };

export type UpdateAccountSchemaVersionMutationVariables = Exact<{
  input: UpdateSchemaVersionInput;
}>;


export type UpdateAccountSchemaVersionMutation = { __typename?: 'Mutation', updateAccountSchemaVersion: { __typename?: 'Account', schemaVersion: number } };

export type PushCollectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  data: Scalars['String']['input'];
}>;


export type PushCollectionMutation = { __typename?: 'Mutation', pushCollection: boolean };

export type PushFileEncryptedSymmetricKeyMutationVariables = Exact<{
  filePath: Scalars['String']['input'];
  metaInfo: FileMetaInfoInputType;
  encryptedFileSymmetricKey: Scalars['String']['input'];
  encryptedSymmetricKey: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
}>;


export type PushFileEncryptedSymmetricKeyMutation = { __typename?: 'Mutation', pushFileEncryptedSymmetricKey: boolean };

export type RegisterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  twoFactorQuestions: Array<TwoFactorQuestionPlainObject> | TwoFactorQuestionPlainObject;
  language: Scalars['String']['input'];
  schemaVersion: Scalars['Float']['input'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthResponse', token: string, account: { __typename?: 'Account', id: number, email: string } } };

export type GenerateEmailCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  typeEmailCode: TypeEmailCode;
}>;


export type GenerateEmailCodeMutation = { __typename?: 'Mutation', generateEmailCode: { __typename?: 'GenerateEmailCodeResponse', result: boolean, expiresAt: any } };

export type ActivateAccountMutationVariables = Exact<{
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
}>;


export type ActivateAccountMutation = { __typename?: 'Mutation', activateAccount: { __typename?: 'Account', email: string, twoFactorQuestions: Array<{ __typename?: 'TwoFactorQuestion', question: string }> } };

export type ActivateBeneficiaryProfileMutationVariables = Exact<{
  jwt: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  password: Scalars['String']['input'];
  twoFactorQuestions: Array<TwoFactorQuestionPlainObject> | TwoFactorQuestionPlainObject;
}>;


export type ActivateBeneficiaryProfileMutation = { __typename?: 'Mutation', activateBeneficiaryProfile: { __typename?: 'Account', email: string } };

export type ActivateAccountAfterExternalRegistrationMutationVariables = Exact<{
  publicKey: Scalars['String']['input'];
}>;


export type ActivateAccountAfterExternalRegistrationMutation = { __typename?: 'Mutation', activateAccountAfterExternalRegistration: boolean };

export type IsBeneficiaryProfileExistsQueryVariables = Exact<{
  jwt: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type IsBeneficiaryProfileExistsQuery = { __typename?: 'Query', isBeneficiaryProfileExists: boolean };

export type CreateScenarioMutationVariables = Exact<{
  beneficiaryProfileId: Scalars['Float']['input'];
  triggerValue: Scalars['Float']['input'];
  dtoIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  triggerType: ScenarioTriggerType;
  mode?: InputMaybe<ScenarioMode>;
  notificationValue: Scalars['Float']['input'];
  notificationPeriod: Scalars['Float']['input'];
  notificationTime: Scalars['DateTime']['input'];
}>;


export type CreateScenarioMutation = { __typename?: 'Mutation', createScenario: { __typename?: 'ScenarioGraphResponse', id: string, createdAt: any, updatedAt: any, mainUserId: number, beneficiaryId: number, mode: ScenarioMode, triggerType: ScenarioTriggerType, triggerValue: string, status: NewScenarioStatus, mainUser?: { __typename?: 'Profile', id: number, firstName?: string | undefined, lastName?: string | undefined } | undefined, beneficiary?: { __typename?: 'Profile', id: number, firstName?: string | undefined, lastName?: string | undefined } | undefined } };

export type UpdateScenarioMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
  input: ScenarioUpdateInput;
  beneficiaryProfileId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateScenarioMutation = { __typename?: 'Mutation', updateScenario: { __typename?: 'ScenarioGraphResponse', id: string, createdAt: any, updatedAt: any, mainUserId: number, beneficiaryId: number, dtoIds?: Array<string> | undefined, mode: ScenarioMode, triggerType: ScenarioTriggerType, triggerValue: string, status: NewScenarioStatus, mainUser?: { __typename?: 'Profile', id: number, firstName?: string | undefined, lastName?: string | undefined } | undefined, beneficiary?: { __typename?: 'Profile', id: number, firstName?: string | undefined, lastName?: string | undefined } | undefined } };

export type ActivateScenarioMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type ActivateScenarioMutation = { __typename?: 'Mutation', activateScenario: { __typename?: 'ScenarioGraphResponse', id: string } };

export type CancelScenarioMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type CancelScenarioMutation = { __typename?: 'Mutation', cancelScenario: { __typename?: 'ScenarioGraphResponse', id: string } };

export type RemoveScenarioMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type RemoveScenarioMutation = { __typename?: 'Mutation', removeScenario: boolean };

export type MarkScenarioAsViewedMutationVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type MarkScenarioAsViewedMutation = { __typename?: 'Mutation', setScenarioViewed: boolean };

export type WebPushSubscribeMutationVariables = Exact<{
  subscription: WebPushSubscriptionInput;
}>;


export type WebPushSubscribeMutation = { __typename?: 'Mutation', webPushSubscribe: boolean };

export type WebPushUnsubscribeMutationVariables = Exact<{
  subscription: WebPushSubscriptionInput;
}>;


export type WebPushUnsubscribeMutation = { __typename?: 'Mutation', webPushUnsubscribe: boolean };

export type AddToWhitelistMutationVariables = Exact<{
  email: Scalars['String']['input'];
  planId: Scalars['String']['input'];
}>;


export type AddToWhitelistMutation = { __typename?: 'Mutation', addToWhitelist: { __typename?: 'Whitelist', id: string } };

export type GetAssistantsQueryVariables = Exact<{
  filterByName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssistantsQuery = { __typename?: 'Query', getAssistants: Array<{ __typename?: 'Profile', id: number, firstName?: string | undefined, lastName?: string | undefined, userName?: string | undefined, accounts?: Array<{ __typename?: 'Account', email: string }> | undefined }> };

export type CurrenciesListQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesListQuery = { __typename?: 'Query', currencyRates: Array<{ __typename?: 'CurrencyRate', id: string, currencyCode: string, value: number, baseCurrency: string }> };

export type DebugQueryVariables = Exact<{ [key: string]: never; }>;


export type DebugQuery = { __typename?: 'Query', debug: any };

export type GetFileQueryVariables = Exact<{
  filename: Scalars['String']['input'];
}>;


export type GetFileQuery = { __typename?: 'Query', getFile: string };

export type GetZendeskTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetZendeskTokenQuery = { __typename?: 'Query', getZendeskToken: { __typename?: 'GetZendeskToken', token: string } };

export type VerifyEmailCodeQueryVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyEmailCodeQuery = { __typename?: 'Query', verifyEmailCode: boolean };

export type VerifyTwoFactorQuestionQueryVariables = Exact<{
  email: Scalars['String']['input'];
  emailCode: Scalars['String']['input'];
  twoFactorQuestionId: Scalars['Int']['input'];
  twoFactorQuestionAnswer: Scalars['String']['input'];
}>;


export type VerifyTwoFactorQuestionQuery = { __typename?: 'Query', verifyTwoFactorQuestion: boolean };

export type IsEmailExistQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type IsEmailExistQuery = { __typename?: 'Query', isEmailExists: boolean };

export type IsEmailAccountTakenQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type IsEmailAccountTakenQuery = { __typename?: 'Query', isEmailAccountTaken: boolean };

export type SendEmailMutationVariables = Exact<{
  username: Scalars['String']['input'];
  to: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type SendEmailMutation = { __typename?: 'Mutation', sendEmail: string };

export type MailboxesQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxesQuery = { __typename?: 'Query', mailboxes: { __typename?: 'GetMailBoxesResponseGGl', mailbox?: { __typename?: 'MailBoxesResponseGGl', username: string, domain: string } | undefined } };

export type ProfileQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', id: number, publicKey?: string | undefined, encryptionType?: { __typename?: 'EncryptionType', title: string } | undefined } };

export type OneTimeCodesQueryVariables = Exact<{
  emailOrPhoneNumber: Scalars['String']['input'];
}>;


export type OneTimeCodesQuery = { __typename?: 'Query', oneTimeCodes: { __typename?: 'OneTimeCodesResponse', emailCode?: string | undefined, smsCode?: string | undefined } };

export type WhoamiQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoamiQuery = { __typename?: 'Query', whoami: { __typename?: 'Account', id: number, email: string, schemaVersion: number, profile?: { __typename?: 'Profile', id: number, type: ProfileType, status: AccountStatus, publicKey?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, avatarUrl?: string | undefined, mainUserId?: number | undefined, encryptionType?: { __typename?: 'EncryptionType', title: string } | undefined, baseCurrency: { __typename?: 'Currency', title: string } } | undefined, sessions?: Array<{ __typename?: 'AccountSession', id: number }> | undefined } };

export type GetBeneficiariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBeneficiariesQuery = { __typename?: 'Query', getBeneficiaries: Array<{ __typename?: 'Profile', id: number, status: AccountStatus, invitationLastSentTime?: any | undefined, publicKey?: string | undefined, encryptionType?: { __typename?: 'EncryptionType', title: string } | undefined }> };

export type GetSoweAppendixSuppressCancelConfirmationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSoweAppendixSuppressCancelConfirmationQuery = { __typename?: 'Query', whoami: { __typename?: 'Account', profile?: { __typename?: 'Profile', soweAppendixSuppressCancelConfirmation: boolean } | undefined } };

export type GetOcrSuppressLetsTryConfirmationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOcrSuppressLetsTryConfirmationQuery = { __typename?: 'Query', whoami: { __typename?: 'Account', profile?: { __typename?: 'Profile', ocrSuppressLetsTryConfirmation: boolean } | undefined } };

export type GetProfileQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', id: number, createdAt: any, invitationLastSentTime?: any | undefined, firstName?: string | undefined, lastName?: string | undefined, status: AccountStatus, accounts?: Array<{ __typename?: 'Account', email: string }> | undefined, beneficiaryInviteCodeAsUsedForProfile?: Array<{ __typename?: 'BeneficiaryInviteCode', id: string, code: string, isUsed: boolean }> | undefined, beneficiaryInviteCodeAsMainUser?: Array<{ __typename?: 'BeneficiaryInviteCode', id: string, isUsed: boolean }> | undefined } };

export type PullCollectionQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type PullCollectionQuery = { __typename?: 'Query', collection1?: { __typename?: 'Collection', id: number, createdAt: any, updatedAt: any, name: string, data: string, ver: number, profileId: number } | undefined };

export type ScenarioQueryVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type ScenarioQuery = { __typename?: 'Query', scenario?: { __typename?: 'ScenarioGraphResponse', id: string, createdAt: any, updatedAt: any, mainUserId: number, beneficiaryId: number, dtoIds?: Array<string> | undefined, mode: ScenarioMode, triggerType: ScenarioTriggerType, triggerValue: string, notificationValue: string, notificationPeriod: string, notificationTime: any, status: NewScenarioStatus, isViewed: boolean, mainUser?: { __typename?: 'Profile', id: number, firstName?: string | undefined, lastName?: string | undefined } | undefined, beneficiary?: { __typename?: 'Profile', id: number, firstName?: string | undefined, lastName?: string | undefined } | undefined } | undefined };

export type FamilyMemberScenariosQueryVariables = Exact<{ [key: string]: never; }>;


export type FamilyMemberScenariosQuery = { __typename?: 'Query', familyMemberScenarios: Array<{ __typename?: 'FamilyMemberScenarioGraphResponse', id: string, mode: string, dtoIds: Array<string> }> };

export type GetSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionsQuery = { __typename?: 'Query', getSubscriptions: Array<{ __typename?: 'SubscriptionEntity', id: number, status: SubscriptionStatus, plan?: string | undefined, dateStart: any, dateEnd: any }> };

export type GetSubscriptionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionStatusQuery = { __typename?: 'Query', getSubscriptionStatus: { __typename?: 'SubscriptionStatusResponseGGl', status: string } };

export type ExistInWhitelistQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ExistInWhitelistQuery = { __typename?: 'Query', existInWhitelist: boolean };


export const RequestExportDocument = /*#__PURE__*/ gql`
    mutation RequestExport($basicAuthLogin: String!, $basicAuthPassword: String!, $awsAccessKeyId: String, $awsSecretAccessKey: String, $hubType: String, $regionId: Int, $idInnerHub: String) {
  requestExport(
    basicAuthLogin: $basicAuthLogin
    basicAuthPassword: $basicAuthPassword
    awsAccessKeyId: $awsAccessKeyId
    awsSecretAccessKey: $awsSecretAccessKey
    hubType: $hubType
    regionId: $regionId
    idInnerHub: $idInnerHub
  )
}
    `;
export const CurrentExportRequestDocument = /*#__PURE__*/ gql`
    query currentExportRequest {
  currentExportRequest {
    id
    createdAt
    updatedAt
    url
    status
    hubType
  }
}
    `;
export const GetHubSettingsDocument = /*#__PURE__*/ gql`
    query getHubSettings {
  getHubSettings {
    hubUrl
    ipAddress
    provider
    country
    connectedAt
    lastPingAt
    updatedAt
    ownedByUser
  }
}
    `;
export const GetAvailableRegionsDocument = /*#__PURE__*/ gql`
    query getAvailableRegions {
  getAvailableRegions {
    id
    regionCode
    regionName
  }
}
    `;
export const GetSubscriptionInfoDocument = /*#__PURE__*/ gql`
    query getSubscriptionInfo {
  getSubscriptionStatus {
    plan
    status
  }
}
    `;
export const CreateSubscriptionDocument = /*#__PURE__*/ gql`
    mutation createSubscription($plan: String!) {
  subscribe(plan: $plan) {
    id
    status
    dateStart
    dateEnd
    profileId
  }
}
    `;
export const CreateAssistantDocument = /*#__PURE__*/ gql`
    mutation createAssistant($name: String!, $publicKey: String!) {
  createAssistant(data: {name: $name, publicKey: $publicKey}) {
    id
  }
}
    `;
export const CreateBeneficiaryDocument = /*#__PURE__*/ gql`
    mutation createBeneficiary($email: String!, $dontSendInviteEmail: Boolean = false) {
  createBeneficiary(
    data: {email: $email, dontSendInviteEmail: $dontSendInviteEmail}
  ) {
    account {
      id
      profileId
    }
    invitationCode
  }
}
    `;
export const SendNewInviteToBeneficiaryDocument = /*#__PURE__*/ gql`
    mutation sendNewInviteToBeneficiary($id: Int!) {
  sendNewInviteToBeneficiary(beneficiaryId: $id) {
    id
    status
    invitationLastSentTime
  }
}
    `;
export const RegisterBeneficiaryByInvitationCodeDocument = /*#__PURE__*/ gql`
    mutation registerBeneficiaryByInvitationCode($input: BeneficiaryCreateByInviteCodeInput!) {
  registerBeneficiaryByInvitationCode(input: $input) {
    token
    account {
      id
      email
    }
  }
}
    `;
export const RegenerateBeneficiaryInviteDocument = /*#__PURE__*/ gql`
    mutation regenerateBeneficiaryInvite($beneficiaryProfileId: Int!) {
  regenerateBeneficiaryInvite(beneficiaryProfileId: $beneficiaryProfileId) {
    account {
      id
    }
    invitationCode
  }
}
    `;
export const CollectionAddItemDocument = /*#__PURE__*/ gql`
    mutation collectionAddItem($data: AddItemGqlInput!) {
  addItemToCollectionGql(input: $data) {
    collectionName
    signature
  }
}
    `;
export const CollectionChangeItemDocument = /*#__PURE__*/ gql`
    mutation collectionChangeItem($data: ChangeItemGqlInput!) {
  changeItemInCollectionGql(input: $data) {
    collectionName
    signature
  }
}
    `;
export const CollectionRemoveItemDocument = /*#__PURE__*/ gql`
    mutation collectionRemoveItem($data: RemoveItemGqlInput!) {
  removeItemFromCollectionGql(input: $data) {
    collectionName
  }
}
    `;
export const UpdateManyCollectionsDocument = /*#__PURE__*/ gql`
    mutation updateManyCollections($data: UpdateManyCollectionsGqlInput!) {
  updateManyCollectionsGql(input: $data) {
    results {
      collectionName
      updatedItems
    }
  }
}
    `;
export const GenerateEncryptedMessageDocument = /*#__PURE__*/ gql`
    mutation generateEncryptedMessage($publicKey: String!) {
  generateEncryptedMessage(publicKey: $publicKey)
}
    `;
export const GetCurrencyRatesDocument = /*#__PURE__*/ gql`
    mutation getCurrencyRates($baseCurrency: String!, $quoteCurrencies: [String!]) {
  getCurrencyRates(
    data: {baseCurrency: $baseCurrency, quoteCurrencies: $quoteCurrencies}
  ) {
    baseCurrency
    quoteCurrency
    rate
  }
}
    `;
export const UploadFileDocument = /*#__PURE__*/ gql`
    mutation uploadFile($fileContent: String!) {
  uploadFile(fileContent: $fileContent)
}
    `;
export const DeleteFileDocument = /*#__PURE__*/ gql`
    mutation deleteFile($filename: String!) {
  deleteFile(filename: $filename)
}
    `;
export const LoginDocument = /*#__PURE__*/ gql`
    mutation login($email: String!, $password: String!, $totpToken: String) {
  login(data: {email: $email, password: $password}, totpToken: $totpToken) {
    token
    account {
      id
      email
    }
  }
}
    `;
export const LoginViaPersonalAccountCodeDocument = /*#__PURE__*/ gql`
    mutation loginViaPersonalAccountCode($code: String!) {
  loginViaPersonalAccountCode(code: $code) {
    token
    account {
      id
      email
      schemaVersion
    }
    profile {
      status
      encryptionType {
        title
      }
    }
  }
}
    `;
export const ForgotPasswordDocument = /*#__PURE__*/ gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export const ResetPasswordByCodeDocument = /*#__PURE__*/ gql`
    mutation resetPasswordByCode($email: String!, $code: String!, $newPassword: String!) {
  resetPasswordByCode(email: $email, code: $code, newPassword: $newPassword) {
    id
  }
}
    `;
export const LoginViaDecryptedMessageDocument = /*#__PURE__*/ gql`
    mutation loginViaDecryptedMessage($decryptedMessage: String!) {
  loginViaDecryptedMessage(decryptedMessage: $decryptedMessage) {
    token
    account {
      id
      email
    }
  }
}
    `;
export const LogoutDocument = /*#__PURE__*/ gql`
    mutation logout($sessionIds: [Float!]!) {
  logout(sessionIds: $sessionIds)
}
    `;
export const GenerateSmsCodeResponseDocument = /*#__PURE__*/ gql`
    mutation generateSmsCodeResponse($number: String!) {
  generateSmsCodeResponse(number: $number)
}
    `;
export const CreateEmailAccountDocument = /*#__PURE__*/ gql`
    mutation createEmailAccount($username: String!, $password: String!) {
  createEmailAccount(username: $username, password: $password) {
    email
  }
}
    `;
export const DeleteEmailAccountDocument = /*#__PURE__*/ gql`
    mutation deleteEmailAccount($username: String!) {
  deleteEmailAccount(username: $username) {
    email
  }
}
    `;
export const ChangePasswordDocument = /*#__PURE__*/ gql`
    mutation changePassword($password: String!, $newPassword: String!) {
  changePassword(password: $password, newPassword: $newPassword) {
    id
  }
}
    `;
export const ChangeSoweAppendixSuppressCancelConfirmationDocument = /*#__PURE__*/ gql`
    mutation changeSoweAppendixSuppressCancelConfirmation($soweAppendixSuppressCancelConfirmation: Boolean!) {
  updateProfile(
    input: {soweAppendixSuppressCancelConfirmation: $soweAppendixSuppressCancelConfirmation}
  ) {
    soweAppendixSuppressCancelConfirmation
  }
}
    `;
export const ChangeOcrSuppressLetsTryConfirmationDocument = /*#__PURE__*/ gql`
    mutation changeOcrSuppressLetsTryConfirmation($ocrSuppressLetsTryConfirmation: Boolean!) {
  updateProfile(
    input: {ocrSuppressLetsTryConfirmation: $ocrSuppressLetsTryConfirmation}
  ) {
    ocrSuppressLetsTryConfirmation
  }
}
    `;
export const UpdateProfileNamesDocument = /*#__PURE__*/ gql`
    mutation updateProfileNames($firstName: String, $lastName: String) {
  updateProfile(input: {firstName: $firstName, lastName: $lastName}) {
    firstName
    lastName
  }
}
    `;
export const VerifyPasswordDocument = /*#__PURE__*/ gql`
    mutation verifyPassword($password: String!) {
  verifyPassword(password: $password)
}
    `;
export const BlockAccountDocument = /*#__PURE__*/ gql`
    mutation blockAccount($emailCode: String!) {
  blockAccount(emailCode: $emailCode)
}
    `;
export const MigrateToEciesDocument = /*#__PURE__*/ gql`
    mutation migrateToEcies($publicKey: String!, $assistants: [UpdateAssistantKey!]) {
  migrateToEcies(publicKey: $publicKey, assistants: $assistants) {
    id
    encryptionType {
      title
    }
  }
}
    `;
export const ChangeBaseCurrencyDocument = /*#__PURE__*/ gql`
    mutation changeBaseCurrency($baseCurrency: String!) {
  changeBaseCurrency(data: {baseCurrency: $baseCurrency}) {
    baseCurrency {
      title
    }
  }
}
    `;
export const UpdateAccountSchemaVersionDocument = /*#__PURE__*/ gql`
    mutation updateAccountSchemaVersion($input: UpdateSchemaVersionInput!) {
  updateAccountSchemaVersion(input: $input) {
    schemaVersion
  }
}
    `;
export const PushCollectionDocument = /*#__PURE__*/ gql`
    mutation PushCollection($name: String!, $data: String!) {
  pushCollection(name: $name, data: $data)
}
    `;
export const PushFileEncryptedSymmetricKeyDocument = /*#__PURE__*/ gql`
    mutation pushFileEncryptedSymmetricKey($filePath: String!, $metaInfo: FileMetaInfoInputType!, $encryptedFileSymmetricKey: String!, $encryptedSymmetricKey: String!, $publicKey: String!) {
  pushFileEncryptedSymmetricKey(
    filePath: $filePath
    metaInfo: $metaInfo
    encryptedFileSymmetricKey: $encryptedFileSymmetricKey
    encryptedSymmetricKey: $encryptedSymmetricKey
    publicKey: $publicKey
  )
}
    `;
export const RegisterDocument = /*#__PURE__*/ gql`
    mutation Register($email: String!, $password: String!, $publicKey: String!, $firstName: String!, $lastName: String!, $twoFactorQuestions: [TwoFactorQuestionPlainObject!]!, $language: String!, $schemaVersion: Float!) {
  register(
    data: {email: $email, password: $password, publicKey: $publicKey, firstName: $firstName, lastName: $lastName, twoFactorQuestions: $twoFactorQuestions, meta: {language: $language}, schemaVersion: $schemaVersion}
  ) {
    token
    account {
      id
      email
    }
  }
}
    `;
export const GenerateEmailCodeDocument = /*#__PURE__*/ gql`
    mutation generateEmailCode($email: String!, $typeEmailCode: TypeEmailCode!) {
  generateEmailCode(data: {email: $email, typeEmailCode: $typeEmailCode}) {
    result
    expiresAt
  }
}
    `;
export const ActivateAccountDocument = /*#__PURE__*/ gql`
    mutation activateAccount($email: String!, $code: String!) {
  activateAccount(
    data: {email: $email, code: $code}
  ) {
    email
    twoFactorQuestions {
      question
    }
  }
}
    `;
export const ActivateBeneficiaryProfileDocument = /*#__PURE__*/ gql`
    mutation activateBeneficiaryProfile($jwt: String!, $publicKey: String!, $password: String!, $twoFactorQuestions: [TwoFactorQuestionPlainObject!]!) {
  activateBeneficiaryProfile(
    data: {jwt: $jwt, publicKey: $publicKey, password: $password, twoFactorQuestions: $twoFactorQuestions}
  ) {
    email
  }
}
    `;
export const ActivateAccountAfterExternalRegistrationDocument = /*#__PURE__*/ gql`
    mutation activateAccountAfterExternalRegistration($publicKey: String!) {
  activateAccountAfterExternalRegistration(publicKey: $publicKey)
}
    `;
export const IsBeneficiaryProfileExistsDocument = /*#__PURE__*/ gql`
    query isBeneficiaryProfileExists($jwt: String!, $email: String!) {
  isBeneficiaryProfileExists(jwt: $jwt, email: $email)
}
    `;
export const CreateScenarioDocument = /*#__PURE__*/ gql`
    mutation createScenario($beneficiaryProfileId: Float!, $triggerValue: Float!, $dtoIds: [String!]!, $triggerType: ScenarioTriggerType!, $mode: ScenarioMode, $notificationValue: Float!, $notificationPeriod: Float!, $notificationTime: DateTime!) {
  createScenario(
    beneficiaryProfileId: $beneficiaryProfileId
    triggerValue: $triggerValue
    dtoIds: $dtoIds
    triggerType: $triggerType
    mode: $mode
    notificationValue: $notificationValue
    notificationPeriod: $notificationPeriod
    notificationTime: $notificationTime
  ) {
    id
    createdAt
    updatedAt
    mainUserId
    beneficiaryId
    mode
    triggerType
    triggerValue
    status
    mainUser {
      id
      firstName
      lastName
    }
    beneficiary {
      id
      firstName
      lastName
    }
  }
}
    `;
export const UpdateScenarioDocument = /*#__PURE__*/ gql`
    mutation updateScenario($scenarioId: String!, $input: ScenarioUpdateInput!, $beneficiaryProfileId: Float) {
  updateScenario(
    scenarioId: $scenarioId
    input: $input
    beneficiaryProfileId: $beneficiaryProfileId
  ) {
    id
    createdAt
    updatedAt
    mainUserId
    beneficiaryId
    dtoIds
    mode
    triggerType
    triggerValue
    status
    mainUser {
      id
      firstName
      lastName
    }
    beneficiary {
      id
      firstName
      lastName
    }
  }
}
    `;
export const ActivateScenarioDocument = /*#__PURE__*/ gql`
    mutation activateScenario($scenarioId: String!) {
  activateScenario(scenarioId: $scenarioId) {
    id
  }
}
    `;
export const CancelScenarioDocument = /*#__PURE__*/ gql`
    mutation cancelScenario($scenarioId: String!) {
  cancelScenario(scenarioId: $scenarioId) {
    id
  }
}
    `;
export const RemoveScenarioDocument = /*#__PURE__*/ gql`
    mutation removeScenario($scenarioId: String!) {
  removeScenario(scenarioId: $scenarioId)
}
    `;
export const MarkScenarioAsViewedDocument = /*#__PURE__*/ gql`
    mutation markScenarioAsViewed($scenarioId: String!) {
  setScenarioViewed(scenarioId: $scenarioId)
}
    `;
export const WebPushSubscribeDocument = /*#__PURE__*/ gql`
    mutation webPushSubscribe($subscription: WebPushSubscriptionInput!) {
  webPushSubscribe(subscription: $subscription)
}
    `;
export const WebPushUnsubscribeDocument = /*#__PURE__*/ gql`
    mutation webPushUnsubscribe($subscription: WebPushSubscriptionInput!) {
  webPushUnsubscribe(subscription: $subscription)
}
    `;
export const AddToWhitelistDocument = /*#__PURE__*/ gql`
    mutation addToWhitelist($email: String!, $planId: String!) {
  addToWhitelist(email: $email, planId: $planId) {
    id
  }
}
    `;
export const GetAssistantsDocument = /*#__PURE__*/ gql`
    query getAssistants($filterByName: String) {
  getAssistants(filterByName: $filterByName) {
    id
    firstName
    lastName
    userName
    accounts {
      email
    }
  }
}
    `;
export const CurrenciesListDocument = /*#__PURE__*/ gql`
    query currenciesList {
  currencyRates {
    id
    currencyCode
    value
    baseCurrency
  }
}
    `;
export const DebugDocument = /*#__PURE__*/ gql`
    query Debug {
  debug
}
    `;
export const GetFileDocument = /*#__PURE__*/ gql`
    query getFile($filename: String!) {
  getFile(filename: $filename)
}
    `;
export const GetZendeskTokenDocument = /*#__PURE__*/ gql`
    query getZendeskToken {
  getZendeskToken {
    token
  }
}
    `;
export const VerifyEmailCodeDocument = /*#__PURE__*/ gql`
    query verifyEmailCode($email: String!, $code: String!) {
  verifyEmailCode(email: $email, code: $code)
}
    `;
export const VerifyTwoFactorQuestionDocument = /*#__PURE__*/ gql`
    query verifyTwoFactorQuestion($email: String!, $emailCode: String!, $twoFactorQuestionId: Int!, $twoFactorQuestionAnswer: String!) {
  verifyTwoFactorQuestion(
    email: $email
    emailCode: $emailCode
    twoFactorQuestionId: $twoFactorQuestionId
    twoFactorQuestionAnswer: $twoFactorQuestionAnswer
  )
}
    `;
export const IsEmailExistDocument = /*#__PURE__*/ gql`
    query isEmailExist($email: String!) {
  isEmailExists(email: $email)
}
    `;
export const IsEmailAccountTakenDocument = /*#__PURE__*/ gql`
    query isEmailAccountTaken($search: String!) {
  isEmailAccountTaken(search: $search)
}
    `;
export const SendEmailDocument = /*#__PURE__*/ gql`
    mutation sendEmail($username: String!, $to: String!, $subject: String!, $text: String!) {
  sendEmail(username: $username, to: $to, subject: $subject, text: $text)
}
    `;
export const MailboxesDocument = /*#__PURE__*/ gql`
    query mailboxes {
  mailboxes {
    mailbox {
      username
      domain
    }
  }
}
    `;
export const ProfileDocument = /*#__PURE__*/ gql`
    query profile($username: String!) {
  profile(input: {where: {mailboxes: {some: {username: {equals: $username}}}}}) {
    id
    encryptionType {
      title
    }
    publicKey
  }
}
    `;
export const OneTimeCodesDocument = /*#__PURE__*/ gql`
    query OneTimeCodes($emailOrPhoneNumber: String!) {
  oneTimeCodes(emailOrPhoneNumber: $emailOrPhoneNumber) {
    emailCode
    smsCode
  }
}
    `;
export const WhoamiDocument = /*#__PURE__*/ gql`
    query whoami {
  whoami {
    id
    email
    profile {
      id
      type
      status
      encryptionType {
        title
      }
      publicKey
      firstName
      lastName
      avatarUrl
      mainUserId
      baseCurrency {
        title
      }
    }
    schemaVersion
    sessions {
      id
    }
  }
}
    `;
export const GetBeneficiariesDocument = /*#__PURE__*/ gql`
    query getBeneficiaries {
  getBeneficiaries {
    id
    status
    invitationLastSentTime
    publicKey
    encryptionType {
      title
    }
  }
}
    `;
export const GetSoweAppendixSuppressCancelConfirmationDocument = /*#__PURE__*/ gql`
    query getSoweAppendixSuppressCancelConfirmation {
  whoami {
    profile {
      soweAppendixSuppressCancelConfirmation
    }
  }
}
    `;
export const GetOcrSuppressLetsTryConfirmationDocument = /*#__PURE__*/ gql`
    query getOcrSuppressLetsTryConfirmation {
  whoami {
    profile {
      ocrSuppressLetsTryConfirmation
    }
  }
}
    `;
export const GetProfileDocument = /*#__PURE__*/ gql`
    query getProfile($id: Int!) {
  profile(input: {where: {id: {equals: $id}}}) {
    id
    createdAt
    invitationLastSentTime
    firstName
    lastName
    status
    accounts {
      email
    }
    beneficiaryInviteCodeAsUsedForProfile {
      id
      code
      isUsed
    }
    beneficiaryInviteCodeAsMainUser {
      id
      isUsed
    }
  }
}
    `;
export const PullCollectionDocument = /*#__PURE__*/ gql`
    query PullCollection($name: String!) {
  collection1: pullCollection(name: $name) {
    id
    createdAt
    updatedAt
    name
    data
    ver
    profileId
  }
}
    `;
export const ScenarioDocument = /*#__PURE__*/ gql`
    query scenario($scenarioId: String!) {
  scenario(scenarioId: $scenarioId) {
    id
    createdAt
    updatedAt
    mainUserId
    beneficiaryId
    dtoIds
    mode
    triggerType
    triggerValue
    notificationValue
    notificationPeriod
    notificationTime
    status
    isViewed
    mainUser {
      id
      firstName
      lastName
    }
    beneficiary {
      id
      firstName
      lastName
    }
  }
}
    `;
export const FamilyMemberScenariosDocument = /*#__PURE__*/ gql`
    query familyMemberScenarios {
  familyMemberScenarios {
    id
    mode
    dtoIds
  }
}
    `;
export const GetSubscriptionsDocument = /*#__PURE__*/ gql`
    query getSubscriptions {
  getSubscriptions {
    id
    status
    plan
    dateStart
    dateEnd
    status
  }
}
    `;
export const GetSubscriptionStatusDocument = /*#__PURE__*/ gql`
    query getSubscriptionStatus {
  getSubscriptionStatus {
    status
  }
}
    `;
export const ExistInWhitelistDocument = /*#__PURE__*/ gql`
    query existInWhitelist($email: String!) {
  existInWhitelist(email: $email)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    RequestExport(variables: RequestExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestExportMutation>(RequestExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestExport', 'mutation');
    },
    currentExportRequest(variables?: CurrentExportRequestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentExportRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentExportRequestQuery>(CurrentExportRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentExportRequest', 'query');
    },
    getHubSettings(variables?: GetHubSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHubSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHubSettingsQuery>(GetHubSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getHubSettings', 'query');
    },
    getAvailableRegions(variables?: GetAvailableRegionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAvailableRegionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAvailableRegionsQuery>(GetAvailableRegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAvailableRegions', 'query');
    },
    getSubscriptionInfo(variables?: GetSubscriptionInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubscriptionInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubscriptionInfoQuery>(GetSubscriptionInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSubscriptionInfo', 'query');
    },
    createSubscription(variables: CreateSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubscriptionMutation>(CreateSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSubscription', 'mutation');
    },
    createAssistant(variables: CreateAssistantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAssistantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAssistantMutation>(CreateAssistantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAssistant', 'mutation');
    },
    createBeneficiary(variables: CreateBeneficiaryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBeneficiaryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBeneficiaryMutation>(CreateBeneficiaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBeneficiary', 'mutation');
    },
    sendNewInviteToBeneficiary(variables: SendNewInviteToBeneficiaryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendNewInviteToBeneficiaryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendNewInviteToBeneficiaryMutation>(SendNewInviteToBeneficiaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendNewInviteToBeneficiary', 'mutation');
    },
    registerBeneficiaryByInvitationCode(variables: RegisterBeneficiaryByInvitationCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterBeneficiaryByInvitationCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterBeneficiaryByInvitationCodeMutation>(RegisterBeneficiaryByInvitationCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerBeneficiaryByInvitationCode', 'mutation');
    },
    regenerateBeneficiaryInvite(variables: RegenerateBeneficiaryInviteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegenerateBeneficiaryInviteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegenerateBeneficiaryInviteMutation>(RegenerateBeneficiaryInviteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'regenerateBeneficiaryInvite', 'mutation');
    },
    collectionAddItem(variables: CollectionAddItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CollectionAddItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectionAddItemMutation>(CollectionAddItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'collectionAddItem', 'mutation');
    },
    collectionChangeItem(variables: CollectionChangeItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CollectionChangeItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectionChangeItemMutation>(CollectionChangeItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'collectionChangeItem', 'mutation');
    },
    collectionRemoveItem(variables: CollectionRemoveItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CollectionRemoveItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectionRemoveItemMutation>(CollectionRemoveItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'collectionRemoveItem', 'mutation');
    },
    updateManyCollections(variables: UpdateManyCollectionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateManyCollectionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateManyCollectionsMutation>(UpdateManyCollectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateManyCollections', 'mutation');
    },
    generateEncryptedMessage(variables: GenerateEncryptedMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateEncryptedMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateEncryptedMessageMutation>(GenerateEncryptedMessageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateEncryptedMessage', 'mutation');
    },
    getCurrencyRates(variables: GetCurrencyRatesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCurrencyRatesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCurrencyRatesMutation>(GetCurrencyRatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCurrencyRates', 'mutation');
    },
    uploadFile(variables: UploadFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileMutation>(UploadFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadFile', 'mutation');
    },
    deleteFile(variables: DeleteFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFileMutation>(DeleteFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFile', 'mutation');
    },
    login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'login', 'mutation');
    },
    loginViaPersonalAccountCode(variables: LoginViaPersonalAccountCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginViaPersonalAccountCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginViaPersonalAccountCodeMutation>(LoginViaPersonalAccountCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginViaPersonalAccountCode', 'mutation');
    },
    forgotPassword(variables: ForgotPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForgotPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForgotPasswordMutation>(ForgotPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'forgotPassword', 'mutation');
    },
    resetPasswordByCode(variables: ResetPasswordByCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResetPasswordByCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetPasswordByCodeMutation>(ResetPasswordByCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resetPasswordByCode', 'mutation');
    },
    loginViaDecryptedMessage(variables: LoginViaDecryptedMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginViaDecryptedMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginViaDecryptedMessageMutation>(LoginViaDecryptedMessageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginViaDecryptedMessage', 'mutation');
    },
    logout(variables: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>(LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'logout', 'mutation');
    },
    generateSmsCodeResponse(variables: GenerateSmsCodeResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateSmsCodeResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateSmsCodeResponseMutation>(GenerateSmsCodeResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateSmsCodeResponse', 'mutation');
    },
    createEmailAccount(variables: CreateEmailAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEmailAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEmailAccountMutation>(CreateEmailAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEmailAccount', 'mutation');
    },
    deleteEmailAccount(variables: DeleteEmailAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteEmailAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEmailAccountMutation>(DeleteEmailAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteEmailAccount', 'mutation');
    },
    changePassword(variables: ChangePasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangePasswordMutation>(ChangePasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changePassword', 'mutation');
    },
    changeSoweAppendixSuppressCancelConfirmation(variables: ChangeSoweAppendixSuppressCancelConfirmationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeSoweAppendixSuppressCancelConfirmationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeSoweAppendixSuppressCancelConfirmationMutation>(ChangeSoweAppendixSuppressCancelConfirmationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeSoweAppendixSuppressCancelConfirmation', 'mutation');
    },
    changeOcrSuppressLetsTryConfirmation(variables: ChangeOcrSuppressLetsTryConfirmationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeOcrSuppressLetsTryConfirmationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeOcrSuppressLetsTryConfirmationMutation>(ChangeOcrSuppressLetsTryConfirmationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeOcrSuppressLetsTryConfirmation', 'mutation');
    },
    updateProfileNames(variables?: UpdateProfileNamesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProfileNamesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProfileNamesMutation>(UpdateProfileNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProfileNames', 'mutation');
    },
    verifyPassword(variables: VerifyPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyPasswordMutation>(VerifyPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verifyPassword', 'mutation');
    },
    blockAccount(variables: BlockAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlockAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlockAccountMutation>(BlockAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'blockAccount', 'mutation');
    },
    migrateToEcies(variables: MigrateToEciesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MigrateToEciesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MigrateToEciesMutation>(MigrateToEciesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'migrateToEcies', 'mutation');
    },
    changeBaseCurrency(variables: ChangeBaseCurrencyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeBaseCurrencyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeBaseCurrencyMutation>(ChangeBaseCurrencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeBaseCurrency', 'mutation');
    },
    updateAccountSchemaVersion(variables: UpdateAccountSchemaVersionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccountSchemaVersionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccountSchemaVersionMutation>(UpdateAccountSchemaVersionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAccountSchemaVersion', 'mutation');
    },
    PushCollection(variables: PushCollectionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PushCollectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PushCollectionMutation>(PushCollectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PushCollection', 'mutation');
    },
    pushFileEncryptedSymmetricKey(variables: PushFileEncryptedSymmetricKeyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PushFileEncryptedSymmetricKeyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PushFileEncryptedSymmetricKeyMutation>(PushFileEncryptedSymmetricKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pushFileEncryptedSymmetricKey', 'mutation');
    },
    Register(variables: RegisterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterMutation>(RegisterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Register', 'mutation');
    },
    generateEmailCode(variables: GenerateEmailCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateEmailCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateEmailCodeMutation>(GenerateEmailCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateEmailCode', 'mutation');
    },
    activateAccount(variables: ActivateAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivateAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateAccountMutation>(ActivateAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activateAccount', 'mutation');
    },
    activateBeneficiaryProfile(variables: ActivateBeneficiaryProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivateBeneficiaryProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateBeneficiaryProfileMutation>(ActivateBeneficiaryProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activateBeneficiaryProfile', 'mutation');
    },
    activateAccountAfterExternalRegistration(variables: ActivateAccountAfterExternalRegistrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivateAccountAfterExternalRegistrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateAccountAfterExternalRegistrationMutation>(ActivateAccountAfterExternalRegistrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activateAccountAfterExternalRegistration', 'mutation');
    },
    isBeneficiaryProfileExists(variables: IsBeneficiaryProfileExistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IsBeneficiaryProfileExistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsBeneficiaryProfileExistsQuery>(IsBeneficiaryProfileExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'isBeneficiaryProfileExists', 'query');
    },
    createScenario(variables: CreateScenarioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateScenarioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateScenarioMutation>(CreateScenarioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createScenario', 'mutation');
    },
    updateScenario(variables: UpdateScenarioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateScenarioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateScenarioMutation>(UpdateScenarioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateScenario', 'mutation');
    },
    activateScenario(variables: ActivateScenarioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivateScenarioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateScenarioMutation>(ActivateScenarioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activateScenario', 'mutation');
    },
    cancelScenario(variables: CancelScenarioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelScenarioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelScenarioMutation>(CancelScenarioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelScenario', 'mutation');
    },
    removeScenario(variables: RemoveScenarioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveScenarioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveScenarioMutation>(RemoveScenarioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeScenario', 'mutation');
    },
    markScenarioAsViewed(variables: MarkScenarioAsViewedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkScenarioAsViewedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkScenarioAsViewedMutation>(MarkScenarioAsViewedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markScenarioAsViewed', 'mutation');
    },
    webPushSubscribe(variables: WebPushSubscribeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WebPushSubscribeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WebPushSubscribeMutation>(WebPushSubscribeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'webPushSubscribe', 'mutation');
    },
    webPushUnsubscribe(variables: WebPushUnsubscribeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WebPushUnsubscribeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WebPushUnsubscribeMutation>(WebPushUnsubscribeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'webPushUnsubscribe', 'mutation');
    },
    addToWhitelist(variables: AddToWhitelistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddToWhitelistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddToWhitelistMutation>(AddToWhitelistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addToWhitelist', 'mutation');
    },
    getAssistants(variables?: GetAssistantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAssistantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAssistantsQuery>(GetAssistantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAssistants', 'query');
    },
    currenciesList(variables?: CurrenciesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrenciesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrenciesListQuery>(CurrenciesListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currenciesList', 'query');
    },
    Debug(variables?: DebugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DebugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DebugQuery>(DebugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Debug', 'query');
    },
    getFile(variables: GetFileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFileQuery>(GetFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFile', 'query');
    },
    getZendeskToken(variables?: GetZendeskTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetZendeskTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetZendeskTokenQuery>(GetZendeskTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getZendeskToken', 'query');
    },
    verifyEmailCode(variables: VerifyEmailCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyEmailCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyEmailCodeQuery>(VerifyEmailCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verifyEmailCode', 'query');
    },
    verifyTwoFactorQuestion(variables: VerifyTwoFactorQuestionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyTwoFactorQuestionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyTwoFactorQuestionQuery>(VerifyTwoFactorQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verifyTwoFactorQuestion', 'query');
    },
    isEmailExist(variables: IsEmailExistQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IsEmailExistQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsEmailExistQuery>(IsEmailExistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'isEmailExist', 'query');
    },
    isEmailAccountTaken(variables: IsEmailAccountTakenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IsEmailAccountTakenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsEmailAccountTakenQuery>(IsEmailAccountTakenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'isEmailAccountTaken', 'query');
    },
    sendEmail(variables: SendEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendEmailMutation>(SendEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendEmail', 'mutation');
    },
    mailboxes(variables?: MailboxesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MailboxesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MailboxesQuery>(MailboxesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mailboxes', 'query');
    },
    profile(variables: ProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileQuery>(ProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profile', 'query');
    },
    OneTimeCodes(variables: OneTimeCodesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OneTimeCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OneTimeCodesQuery>(OneTimeCodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OneTimeCodes', 'query');
    },
    whoami(variables?: WhoamiQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WhoamiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WhoamiQuery>(WhoamiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'whoami', 'query');
    },
    getBeneficiaries(variables?: GetBeneficiariesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBeneficiariesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBeneficiariesQuery>(GetBeneficiariesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBeneficiaries', 'query');
    },
    getSoweAppendixSuppressCancelConfirmation(variables?: GetSoweAppendixSuppressCancelConfirmationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSoweAppendixSuppressCancelConfirmationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSoweAppendixSuppressCancelConfirmationQuery>(GetSoweAppendixSuppressCancelConfirmationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSoweAppendixSuppressCancelConfirmation', 'query');
    },
    getOcrSuppressLetsTryConfirmation(variables?: GetOcrSuppressLetsTryConfirmationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOcrSuppressLetsTryConfirmationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOcrSuppressLetsTryConfirmationQuery>(GetOcrSuppressLetsTryConfirmationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOcrSuppressLetsTryConfirmation', 'query');
    },
    getProfile(variables: GetProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProfileQuery>(GetProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProfile', 'query');
    },
    PullCollection(variables: PullCollectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PullCollectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PullCollectionQuery>(PullCollectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PullCollection', 'query');
    },
    scenario(variables: ScenarioQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScenarioQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScenarioQuery>(ScenarioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scenario', 'query');
    },
    familyMemberScenarios(variables?: FamilyMemberScenariosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FamilyMemberScenariosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FamilyMemberScenariosQuery>(FamilyMemberScenariosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'familyMemberScenarios', 'query');
    },
    getSubscriptions(variables?: GetSubscriptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubscriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubscriptionsQuery>(GetSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSubscriptions', 'query');
    },
    getSubscriptionStatus(variables?: GetSubscriptionStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubscriptionStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubscriptionStatusQuery>(GetSubscriptionStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSubscriptionStatus', 'query');
    },
    existInWhitelist(variables: ExistInWhitelistQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExistInWhitelistQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExistInWhitelistQuery>(ExistInWhitelistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'existInWhitelist', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;
